(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7211],{

/***/ 69877:
/***/ (function(module) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeFloor = Math.floor,
    nativeRandom = Math.random;

/**
 * The base implementation of `_.random` without support for returning
 * floating-point numbers.
 *
 * @private
 * @param {number} lower The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the random number.
 */
function baseRandom(lower, upper) {
  return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
}

module.exports = baseRandom;


/***/ }),

/***/ 83608:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseRandom = __webpack_require__(69877),
    isIterateeCall = __webpack_require__(16612),
    toFinite = __webpack_require__(18601);

/** Built-in method references without a dependency on `root`. */
var freeParseFloat = parseFloat;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min,
    nativeRandom = Math.random;

/**
 * Produces a random number between the inclusive `lower` and `upper` bounds.
 * If only one argument is provided a number between `0` and the given number
 * is returned. If `floating` is `true`, or either `lower` or `upper` are
 * floats, a floating-point number is returned instead of an integer.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @memberOf _
 * @since 0.7.0
 * @category Number
 * @param {number} [lower=0] The lower bound.
 * @param {number} [upper=1] The upper bound.
 * @param {boolean} [floating] Specify returning a floating-point number.
 * @returns {number} Returns the random number.
 * @example
 *
 * _.random(0, 5);
 * // => an integer between 0 and 5
 *
 * _.random(5);
 * // => also an integer between 0 and 5
 *
 * _.random(5, true);
 * // => a floating-point number between 0 and 5
 *
 * _.random(1.2, 5.2);
 * // => a floating-point number between 1.2 and 5.2
 */
function random(lower, upper, floating) {
  if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
    upper = floating = undefined;
  }
  if (floating === undefined) {
    if (typeof upper == 'boolean') {
      floating = upper;
      upper = undefined;
    }
    else if (typeof lower == 'boolean') {
      floating = lower;
      lower = undefined;
    }
  }
  if (lower === undefined && upper === undefined) {
    lower = 0;
    upper = 1;
  }
  else {
    lower = toFinite(lower);
    if (upper === undefined) {
      upper = lower;
      lower = 0;
    } else {
      upper = toFinite(upper);
    }
  }
  if (lower > upper) {
    var temp = lower;
    lower = upper;
    upper = temp;
  }
  if (floating || lower % 1 || upper % 1) {
    var rand = nativeRandom();
    return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
  }
  return baseRandom(lower, upper);
}

module.exports = random;


/***/ }),

/***/ 73955:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toString = __webpack_require__(79833);

/** Used to generate unique IDs. */
var idCounter = 0;

/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */
function uniqueId(prefix) {
  var id = ++idCounter;
  return toString(prefix) + id;
}

module.exports = uniqueId;


/***/ }),

/***/ 17230:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lottery",
      function () {
        return __webpack_require__(35837);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 12587:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19521);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57247);
/* harmony import */ var _Button_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39793);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: ",
        ";\n  border-radius: 16px;\n  display: ",
        ";\n  border: 1px solid ",
        ";\n  width: ",
        ";\n\n  & > button,\n  & > a {\n    flex: ",
        ";\n  }\n\n  & > button + button,\n  & > a + a {\n    margin-left: 0px; // To avoid focus shadow overlap\n  }\n\n  & > button,\n  & a {\n    box-shadow: none;\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var getBackgroundColor = function getBackgroundColor(param) {
    var theme = param.theme, variant = param.variant;
    return theme.colors[variant === _Button_types__WEBPACK_IMPORTED_MODULE_4__/* .variants.SUBTLE */ .o.SUBTLE ? "input" : "inputSecondary"];
};
var getBorderColor = function getBorderColor(param) {
    var theme = param.theme, variant = param.variant;
    return theme.colors[variant === _Button_types__WEBPACK_IMPORTED_MODULE_4__/* .variants.SUBTLE */ .o.SUBTLE ? "inputSecondary" : "disabled"];
};
var StyledButtonMenu = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-bec15c7f-0"
}).withConfig({
    componentId: "sc-37168429-0"
})(_templateObject(), getBackgroundColor, function(param) {
    var fullWidth = param.fullWidth;
    return fullWidth ? "flex" : "inline-flex";
}, getBorderColor, function(param) {
    var fullWidth = param.fullWidth;
    return fullWidth ? "100%" : "auto";
}, function(param) {
    var fullWidth = param.fullWidth;
    return fullWidth ? 1 : "auto";
}, function(param) {
    var disabled = param.disabled, theme = param.theme, variant = param.variant;
    if (disabled) {
        return "\n        opacity: 0.5;\n\n        & > button:disabled {\n          background-color: transparent;\n          color: ".concat(variant === _Button_types__WEBPACK_IMPORTED_MODULE_4__/* .variants.PRIMARY */ .o.PRIMARY ? theme.colors.primary : theme.colors.textSubtle, ";\n        }\n    ");
    }
    return "";
}, styled_system__WEBPACK_IMPORTED_MODULE_3__/* .space */ .Dh);
var ButtonMenu = function ButtonMenu(_param) {
    var _activeIndex = _param.activeIndex, activeIndex = _activeIndex === void 0 ? 0 : _activeIndex, _scale = _param.scale, scale = _scale === void 0 ? _Button_types__WEBPACK_IMPORTED_MODULE_4__/* .scales.MD */ .Q.MD : _scale, _variant = _param.variant, variant = _variant === void 0 ? _Button_types__WEBPACK_IMPORTED_MODULE_4__/* .variants.PRIMARY */ .o.PRIMARY : _variant, onItemClick = _param.onItemClick, disabled = _param.disabled, children = _param.children, _fullWidth = _param.fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "activeIndex",
        "scale",
        "variant",
        "onItemClick",
        "disabled",
        "children",
        "fullWidth"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledButtonMenu, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        disabled: disabled,
        variant: variant,
        fullWidth: fullWidth
    }, props), {
        children: react__WEBPACK_IMPORTED_MODULE_2__.Children.map(children, function(child, index) {
            return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.cloneElement)(child, {
                isActive: activeIndex === index,
                onClick: onItemClick ? function() {
                    return onItemClick(index);
                } : undefined,
                scale: scale,
                variant: variant,
                disabled: disabled
            });
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ButtonMenu);


/***/ }),

/***/ 70257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57247);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var CardBody = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-1aca7a6-0"
}).withConfig({
    componentId: "sc-8316b33b-0"
})(_templateObject(), styled_system__WEBPACK_IMPORTED_MODULE_1__/* .space */ .Dh);
CardBody.defaultProps = {
    p: [
        "8px",
        "8px",
        "8px",
        "20px"
    ]
};
/* harmony default export */ __webpack_exports__["Z"] = (CardBody);


/***/ }),

/***/ 55209:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57247);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: ",
        ";\n  border-radius: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var CardHeader = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-e97edbbd-0"
}).withConfig({
    componentId: "sc-206fd2b9-0"
})(_templateObject(), function(param) {
    var theme = param.theme, _variant = param.variant, variant = _variant === void 0 ? "default" : _variant;
    return theme.card.cardHeaderBackground[variant];
}, function(param) {
    var theme = param.theme;
    return "".concat(theme.radii.card, " ").concat(theme.radii.card, " 0 0");
}, styled_system__WEBPACK_IMPORTED_MODULE_1__/* .space */ .Dh);
CardHeader.defaultProps = {
    p: "24px"
};
/* harmony default export */ __webpack_exports__["Z"] = (CardHeader);


/***/ }),

/***/ 95857:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  z-index: ",
        ";\n  background-color: ",
        ";\n  color: white;\n  margin: 0;\n  padding: 8px 0;\n  position: absolute;\n  right: ",
        ";\n  top: 0;\n  text-align: center;\n  transform: ",
        ";\n  transform-origin: top left;\n  width: 96px;\n\n  &:before,\n  &:after {\n    background-color: ",
        ';\n    content: "";\n    height: 100%;\n    margin: 0 -1px; /* Removes tiny gap */\n    position: absolute;\n    top: 0;\n    width: 100%;\n  }\n\n  &:before {\n    right: 100%;\n  }\n\n  &:after {\n    left: 100%;\n  }\n\n  & > div {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    width: 96px;\n  }\n'
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var StyledCardRibbon = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-e1bdbf71-0"
}).withConfig({
    componentId: "sc-e59b2756-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.zIndices.ribbon;
}, function(param) {
    var _variantColor = param.variantColor, variantColor = _variantColor === void 0 ? "secondary" : _variantColor, theme = param.theme;
    return theme.colors[variantColor];
}, function(param) {
    var ribbonPosition = param.ribbonPosition;
    return ribbonPosition === "right" ? 0 : "auto";
}, function(param) {
    var ribbonPosition = param.ribbonPosition;
    return ribbonPosition === "right" ? "translateX(30%) translateY(0%) rotate(45deg)" : "translateX(0%) translateY(200%) rotate(-45deg)";
}, function(param) {
    var _variantColor = param.variantColor, variantColor = _variantColor === void 0 ? "secondary" : _variantColor, theme = param.theme;
    return theme.colors[variantColor];
});
var CardRibbon = function CardRibbon(_param) {
    var variantColor = _param.variantColor, text = _param.text, ribbonPosition = _param.ribbonPosition, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "variantColor",
        "text",
        "ribbonPosition"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledCardRibbon, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        variantColor: variantColor,
        ribbonPosition: ribbonPosition
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
            title: text,
            children: text
        })
    }));
};
CardRibbon.defaultProps = {
    // eslint-disable-next-line react/default-props-match-prop-types
    ribbonPosition: "right"
};
/* harmony default export */ __webpack_exports__["Z"] = (CardRibbon);


/***/ }),

/***/ 32762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6704);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: transparent;\n  border-radius: 16px;\n  box-shadow: ",
        ";\n  color: ",
        ";\n  display: block;\n  font-size: 16px;\n  height: ",
        ";\n  outline: 0;\n  padding: 0 16px;\n  width: 100%;\n  border: 1px solid ",
        ";\n\n  &::placeholder {\n    color: ",
        ";\n  }\n\n  &:disabled {\n    background-color: ",
        ";\n    box-shadow: none;\n    color: ",
        ";\n    cursor: not-allowed;\n  }\n\n  &:focus:not(:disabled) {\n    box-shadow: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/**
 * Priority: Warning --> Success
 */ var getBoxShadow = function getBoxShadow(param) {
    var _isSuccess = param.isSuccess, isSuccess = _isSuccess === void 0 ? false : _isSuccess, _isWarning = param.isWarning, isWarning = _isWarning === void 0 ? false : _isWarning, theme = param.theme;
    if (isWarning) {
        return theme.shadows.warning;
    }
    if (isSuccess) {
        return theme.shadows.success;
    }
    return theme.shadows.inset;
};
var getHeight = function getHeight(param) {
    var _scale = param.scale, scale = _scale === void 0 ? _types__WEBPACK_IMPORTED_MODULE_1__/* .scales.MD */ .Q.MD : _scale;
    switch(scale){
        case _types__WEBPACK_IMPORTED_MODULE_1__/* .scales.SM */ .Q.SM:
            return "32px";
        case _types__WEBPACK_IMPORTED_MODULE_1__/* .scales.LG */ .Q.LG:
            return "48px";
        case _types__WEBPACK_IMPORTED_MODULE_1__/* .scales.MD */ .Q.MD:
        default:
            return "40px";
    }
};
var Input = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].input.withConfig */ .ZP.input.withConfig({
    componentId: "sc-d7283ca6-0"
}).withConfig({
    componentId: "sc-5142754f-0"
})(_templateObject(), getBoxShadow, function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, getHeight, function(param) {
    var theme = param.theme;
    return theme.colors.inputSecondary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
}, function(param) {
    var theme = param.theme;
    return theme.colors.backgroundDisabled;
}, function(param) {
    var theme = param.theme;
    return theme.colors.textDisabled;
}, function(param) {
    var theme = param.theme, isWarning = param.isWarning, isSuccess = param.isSuccess;
    if (isWarning) {
        return theme.shadows.warning;
    }
    if (isSuccess) {
        return theme.shadows.success;
    }
    return theme.shadows.focus;
});
Input.defaultProps = {
    scale: _types__WEBPACK_IMPORTED_MODULE_1__/* .scales.MD */ .Q.MD,
    isSuccess: false,
    isWarning: false
};
/* harmony default export */ __webpack_exports__["Z"] = (Input);


/***/ }),

/***/ 6704:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ scales; }
/* harmony export */ });
var scales = {
    SM: "sm",
    MD: "md",
    LG: "lg"
};


/***/ }),

/***/ 96484:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44976);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 61549:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44976);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M3 13.1835H14.17L9.29 18.0635C8.9 18.4535 8.9 19.0935 9.29 19.4835C9.68 19.8735 10.31 19.8735 10.7 19.4835L17.29 12.8935C17.68 12.5035 17.68 11.8735 17.29 11.4835L10.71 4.88347C10.32 4.49347 9.69 4.49347 9.3 4.88347C8.91 5.27347 8.91 5.90347 9.3 6.29347L14.17 11.1835H3C2.45 11.1835 2 11.6335 2 12.1835C2 12.7335 2.45 13.1835 3 13.1835Z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M20 5.18347C20.5523 5.18347 21 5.63119 21 6.18347V18.1835C21 18.7358 20.5523 19.1835 20 19.1835C19.4477 19.1835 19 18.7358 19 18.1835V6.18347C19 5.63119 19.4477 5.18347 20 5.18347Z"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 2412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44976);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M18 13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 54548:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44976);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10Z",
            fill: "black"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 56658:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44976);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        width: "60",
        height: "60",
        viewBox: "0 0 60 60"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M14.3333 60V54.4445H27.2223V42.7778C24.3148 42.1666 21.7268 40.9213 19.4583 39.0417C17.1898 37.162 15.5926 34.8148 14.6667 32C10.5371 31.537 7.06019 29.8194 4.23608 26.8472C1.41203 23.8749 0 20.3333 0 16.2222V12.6667C0 11.1296 0.541667 9.81942 1.625 8.73608C2.70833 7.65275 4.0185 7.11108 5.5555 7.11108H13.5556V0H46.4444V7.11108H54.4445C55.9815 7.11108 57.2917 7.65275 58.375 8.73608C59.4583 9.81942 60 11.1296 60 12.6667V16.2222C60 20.3333 58.588 23.8749 55.7639 26.8472C52.9398 29.8194 49.4629 31.537 45.3333 32C44.4074 34.8148 42.8102 37.162 40.5417 39.0417C38.2732 40.9213 35.6852 42.1666 32.7778 42.7778V54.4445H45.6667V60H14.3333ZM13.5556 26.1111V12.6667H5.5555V16.2222C5.5555 18.5926 6.3055 20.6805 7.8055 22.4861C9.30556 24.2916 11.2222 25.5 13.5556 26.1111ZM46.4444 26.1111C48.7778 25.5 50.6944 24.2916 52.1945 22.4861C53.6945 20.6805 54.4445 18.5926 54.4445 16.2222V12.6667H46.4444V26.1111Z",
            fill: props.fill || "#FFE766"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 94998:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);
/* harmony import */ var _Text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62077);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-decoration: underline dotted;\n  text-decoration-color: ",
        ";\n  text-underline-offset: 0.1em;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var TooltipText = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-5b87ff15-0"
}).withConfig({
    componentId: "sc-b03971-0"
})(_templateObject(), function(param) {
    var theme = param.theme, decorationColor = param.decorationColor;
    var ref;
    return "".concat((theme === null || theme === void 0 ? void 0 : theme.colors) && decorationColor ? theme.colors[decorationColor] : theme === null || theme === void 0 ? void 0 : (ref = theme.colors) === null || ref === void 0 ? void 0 : ref.textSubtle);
});
/* harmony default export */ __webpack_exports__["Z"] = (TooltipText);


/***/ }),

/***/ 91543:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ useCallNoGasPrice; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36305);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97582);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64487);






function useCallNoGasPrice() {
    /**
   * Perform a contract call without setting a gas price, allowing MetaMask to handle it
   * @param contract Used to perform the call
   * @param methodName The name of the method called
   * @param methodArgs An array of arguments to pass to the method
   * @param overrides An overrides object to pass to the method
   * @returns https://docs.ethers.io/v5/api/providers/types/#providers-TransactionReceipt
   */ var callNoGasPrice = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(contract, methodName) {
            var methodArgs, overrides, contractMethod, tx, ref;
            var _arguments = arguments;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        methodArgs = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : [], overrides = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : null;
                        (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_4__/* .addBreadcrumb */ .n_)({
                            type: "Transaction",
                            message: "Call without setting gas price",
                            data: {
                                contractAddress: contract.address,
                                methodName: methodName,
                                methodArgs: methodArgs,
                                overrides: overrides
                            }
                        });
                        contractMethod = lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(contract, methodName);
                        return [
                            4,
                            contractMethod.apply(void 0, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(methodArgs).concat([
                                overrides
                            ]))
                        ];
                    case 1:
                        tx = _state.sent();
                        if (tx) {
                            ;
                            (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_4__/* .addBreadcrumb */ .n_)({
                                type: "Transaction",
                                message: "Transaction sent: ".concat(tx.hash),
                                data: {
                                    hash: tx.hash,
                                    from: tx.from,
                                    gasLimit: (ref = tx.gasLimit) === null || ref === void 0 ? void 0 : ref.toString(),
                                    nonce: tx.nonce
                                }
                            });
                        }
                        return [
                            2,
                            tx
                        ];
                }
            });
        });
        return function(contract, methodName) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    return {
        callNoGasPrice: callNoGasPrice
    };
}


/***/ }),

/***/ 35837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages_lottery; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Box_Flex = __webpack_require__(75943);
// EXTERNAL MODULE: ./packages/uikit/src/components/Heading/Heading.tsx + 1 modules
var Heading = __webpack_require__(69589);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(44147);
// EXTERNAL MODULE: ./src/config/constants/types.ts
var types = __webpack_require__(75759);
// EXTERNAL MODULE: ./src/components/PageSection/index.tsx + 2 modules
var PageSection = __webpack_require__(76751);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx
var src = __webpack_require__(52775);
// EXTERNAL MODULE: ./src/hooks/useTheme.ts
var useTheme = __webpack_require__(63850);
// EXTERNAL MODULE: ./packages/wagmi/src/index.ts + 3 modules
var wagmi_src = __webpack_require__(29315);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/state/index.ts + 23 modules
var state = __webpack_require__(88453);
// EXTERNAL MODULE: ./src/hooks/useRefreshEffect.ts
var useRefreshEffect = __webpack_require__(33533);
// EXTERNAL MODULE: ./src/state/lottery/index.ts
var lottery = __webpack_require__(63290);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/bignumber.js/bignumber.mjs
var bignumber = __webpack_require__(70794);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var reselect_es = __webpack_require__(68697);
;// CONCATENATED MODULE: ./src/state/lottery/selectors.ts




var selectCurrentLotteryId = function(state) {
    return state.lottery.currentLotteryId;
};
var selectIsTransitioning = function(state) {
    return state.lottery.isTransitioning;
};
var selectCurrentRound = function(state) {
    return state.lottery.currentRound;
};
var selectUserLotteryData = function(state) {
    return state.lottery.userLotteryData;
};
var selectLotteriesData = function(state) {
    return state.lottery.lotteriesData;
};
var selectMaxNumberTicketsPerBuyOrClaim = function(state) {
    return state.lottery.maxNumberTicketsPerBuyOrClaim;
};
var makeLotteryGraphDataByIdSelector = function(lotteryId) {
    return (0,reselect_es/* createSelector */.P1)([
        selectLotteriesData
    ], function(lotteriesData) {
        return lotteriesData === null || lotteriesData === void 0 ? void 0 : lotteriesData.find(function(lottery) {
            return lottery.id === lotteryId;
        });
    });
};
var maxNumberTicketsPerBuyOrClaimSelector = (0,reselect_es/* createSelector */.P1)([
    selectMaxNumberTicketsPerBuyOrClaim
], function(maxNumberTicketsPerBuyOrClaimAsString) {
    return new bignumber/* default */.Z(maxNumberTicketsPerBuyOrClaimAsString);
});
var currentRoundSelector = (0,reselect_es/* createSelector */.P1)([
    selectCurrentRound
], function(currentRound) {
    var priceTicketInEthAsString = currentRound.priceTicketInEth, discountDivisorAsString = currentRound.discountDivisor, amountCollectedInEthAsString = currentRound.amountCollectedInEth;
    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, currentRound), {
        priceTicketInEth: new bignumber/* default */.Z(priceTicketInEthAsString),
        discountDivisor: new bignumber/* default */.Z(discountDivisorAsString),
        amountCollectedInEth: new bignumber/* default */.Z(amountCollectedInEthAsString)
    });
});
var lotterySelector = (0,reselect_es/* createSelector */.P1)([
    currentRoundSelector,
    selectIsTransitioning,
    selectCurrentLotteryId,
    selectUserLotteryData,
    selectLotteriesData,
    maxNumberTicketsPerBuyOrClaimSelector, 
], function(processedCurrentRound, isTransitioning, currentLotteryId, userLotteryData, lotteriesData, maxNumberTicketsPerBuyOrClaim) {
    return {
        currentLotteryId: currentLotteryId,
        maxNumberTicketsPerBuyOrClaim: maxNumberTicketsPerBuyOrClaim,
        isTransitioning: isTransitioning,
        userLotteryData: userLotteryData,
        lotteriesData: lotteriesData,
        currentRound: processedCurrentRound
    };
});

;// CONCATENATED MODULE: ./src/state/lottery/hooks.ts







// Lottery
var useGetCurrentLotteryId = function() {
    return (0,es/* useSelector */.v9)(function(state) {
        return state.lottery.currentLotteryId;
    });
};
var useGetUserLotteriesGraphData = function() {
    return (0,es/* useSelector */.v9)(function(state) {
        return state.lottery.userLotteryData;
    });
};
var useGetLotteriesGraphData = function() {
    return (0,es/* useSelector */.v9)(function(state) {
        return state.lottery.lotteriesData;
    });
};
var useGetLotteryGraphDataById = function(lotteryId) {
    var lotteryGraphDataByIdSelector = (0,react.useMemo)(function() {
        return makeLotteryGraphDataByIdSelector(lotteryId);
    }, [
        lotteryId
    ]);
    return (0,es/* useSelector */.v9)(lotteryGraphDataByIdSelector);
};
var useFetchLottery = function() {
    var fetchPublicDataOnly = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var account = (0,wagmi_src/* useWeb3React */.Ge)().account;
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var currentLotteryId = useGetCurrentLotteryId();
    (0,react.useEffect)(function() {
        // get current lottery ID & max ticket buy
        dispatch((0,lottery/* fetchCurrentLotteryId */.kC)());
    }, [
        dispatch
    ]);
    (0,useRefreshEffect/* useFastRefreshEffect */.a)(function() {
        if (currentLotteryId) {
            (0,es/* batch */.dC)(function() {
                // Get historical lottery data from nodes +  last 100 subgraph entries
                dispatch((0,lottery/* fetchPublicLotteries */.S5)({
                    currentLotteryId: currentLotteryId
                }));
                // get public data for current lottery
                dispatch((0,lottery/* fetchCurrentLottery */.PU)({
                    currentLotteryId: currentLotteryId
                }));
            });
        }
    }, [
        dispatch,
        currentLotteryId
    ]);
    (0,react.useEffect)(function() {
        // get user tickets for current lottery, and user lottery subgraph data
        if (account && currentLotteryId && !fetchPublicDataOnly) {
            dispatch((0,lottery/* fetchUserTicketsAndLotteries */.w5)({
                account: account,
                currentLotteryId: currentLotteryId
            }));
        }
    }, [
        dispatch,
        currentLotteryId,
        account,
        fetchPublicDataOnly
    ]);
};
var useLottery = function() {
    return (0,es/* useSelector */.v9)(lotterySelector);
};

;// CONCATENATED MODULE: ./src/views/Lottery/pageSectionStyles.tsx
var TITLE_BG = "linear-gradient(180deg, #7645D9 0%, #452A7A 100%)";
var GET_TICKETS_BG = "linear-gradient(180deg, #7645D9 0%, #5121B1 100%)";
var CHECK_PRIZES_BG = "linear-gradient(139.73deg, #313D5C 0%, #3D2A54 100%)";
var FINISHED_ROUNDS_BG = "linear-gradient(180deg, #CBD7EF 0%, #9A9FD0 100%)";
var FINISHED_ROUNDS_BG_DARK = "linear-gradient(180deg, #434575 0%, #66578D 100%)";

;// CONCATENATED MODULE: ./src/views/Lottery/hooks/useGetNextLotteryEvent.ts



var vrfRequestTime = 180 // 3 mins
;
var secondsBetweenRounds = 300 // 5 mins
;
var transactionResolvingBuffer = 30 // Delay countdown by 30s to ensure contract transactions have been calculated and broadcast
;
var useGetNextLotteryEvent = function(endTime, status) {
    var t = (0,src/* useTranslation */.$G)().t;
    return (0,react.useMemo)(function() {
        // Current lottery is active
        if (status === types/* LotteryStatus.OPEN */.p3.OPEN) {
            return {
                nextEventTime: endTime + transactionResolvingBuffer,
                preCountdownText: null,
                postCountdownText: t("until the draw")
            };
        }
        // Current lottery has finished but not yet claimable
        if (status === types/* LotteryStatus.CLOSE */.p3.CLOSE) {
            return {
                nextEventTime: endTime + transactionResolvingBuffer + vrfRequestTime,
                preCountdownText: t("Winners announced in"),
                postCountdownText: null
            };
        }
        // Current lottery claimable. Next lottery has not yet started
        if (status === types/* LotteryStatus.CLAIMABLE */.p3.CLAIMABLE) {
            return {
                nextEventTime: endTime + transactionResolvingBuffer + secondsBetweenRounds,
                preCountdownText: t("Tickets on sale in"),
                postCountdownText: null
            };
        }
        return {
            nextEventTime: null,
            preCountdownText: null,
            postCountdownText: null
        };
    }, [
        endTime,
        status,
        t
    ]);
};
/* harmony default export */ var hooks_useGetNextLotteryEvent = (useGetNextLotteryEvent);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./packages/hooks/src/index.ts + 4 modules
var hooks_src = __webpack_require__(74903);
;// CONCATENATED MODULE: ./src/views/Lottery/hooks/useStatusTransitions.tsx









var useStatusTransitions = function() {
    var ref = useLottery(), currentLotteryId = ref.currentLotteryId, isTransitioning = ref.isTransitioning, status = ref.currentRound.status;
    var account = (0,wagmi_src/* useWeb3React */.Ge)().account;
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var previousStatus = (0,hooks_src/* usePreviousValue */.zP)(status);
    (0,react.useEffect)(function() {
        // Only run if there is a status state change
        if (previousStatus !== status && currentLotteryId) {
            // Current lottery transitions from CLOSE > CLAIMABLE
            if (previousStatus === types/* LotteryStatus.CLOSE */.p3.CLOSE && status === types/* LotteryStatus.CLAIMABLE */.p3.CLAIMABLE) {
                dispatch((0,lottery/* fetchPublicLotteries */.S5)({
                    currentLotteryId: currentLotteryId
                }));
                if (account) {
                    dispatch((0,lottery/* fetchUserLotteries */.wV)({
                        account: account,
                        currentLotteryId: currentLotteryId
                    }));
                }
            }
            // Previous lottery to new lottery. From CLAIMABLE (previous round) > OPEN (new round)
            if (previousStatus === types/* LotteryStatus.CLAIMABLE */.p3.CLAIMABLE && status === types/* LotteryStatus.OPEN */.p3.OPEN) {
                dispatch((0,lottery/* fetchPublicLotteries */.S5)({
                    currentLotteryId: currentLotteryId
                }));
                if (account) {
                    dispatch((0,lottery/* fetchUserLotteries */.wV)({
                        account: account,
                        currentLotteryId: currentLotteryId
                    }));
                }
            }
        }
    }, [
        currentLotteryId,
        status,
        previousStatus,
        account,
        dispatch
    ]);
    (0,react.useEffect)(function() {
        // Current lottery is CLAIMABLE and the lottery is transitioning to a NEW round - fetch current lottery ID every 10s.
        // The isTransitioning condition will no longer be true when fetchCurrentLotteryId returns the next lottery ID
        if (previousStatus === types/* LotteryStatus.CLAIMABLE */.p3.CLAIMABLE && status === types/* LotteryStatus.CLAIMABLE */.p3.CLAIMABLE && isTransitioning) {
            dispatch((0,lottery/* fetchCurrentLotteryId */.kC)());
            dispatch((0,lottery/* fetchPublicLotteries */.S5)({
                currentLotteryId: currentLotteryId
            }));
            var interval = setInterval(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    dispatch((0,lottery/* fetchCurrentLotteryId */.kC)());
                    dispatch((0,lottery/* fetchPublicLotteries */.S5)({
                        currentLotteryId: currentLotteryId
                    }));
                    return [
                        2
                    ];
                });
            }), 10000);
            return function() {
                return clearInterval(interval);
            };
        }
        return function() {
            return null;
        };
    }, [
        status,
        previousStatus,
        isTransitioning,
        currentLotteryId,
        dispatch
    ]);
};
/* harmony default export */ var hooks_useStatusTransitions = (useStatusTransitions);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./packages/uikit/src/components/Card/Card.tsx + 1 modules
var Card = __webpack_require__(20353);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/useModal.ts
var useModal = __webpack_require__(21812);
// EXTERNAL MODULE: ./packages/uikit/src/components/Skeleton/Skeleton.tsx + 1 modules
var Skeleton = __webpack_require__(62685);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(62077);
// EXTERNAL MODULE: ./packages/uikit/src/components/Card/CardHeader.tsx
var CardHeader = __webpack_require__(55209);
// EXTERNAL MODULE: ./packages/uikit/src/components/Card/CardBody.tsx
var CardBody = __webpack_require__(70257);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(98553);
// EXTERNAL MODULE: ./packages/uikit/src/components/Card/CardFooter.tsx
var CardFooter = __webpack_require__(5349);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/ExpandableButton.tsx
var ExpandableButton = __webpack_require__(56063);
// EXTERNAL MODULE: ./src/state/farms/hooks.ts + 1 modules
var hooks = __webpack_require__(48674);
// EXTERNAL MODULE: ./src/utils/formatBalance.ts
var formatBalance = __webpack_require__(59123);
// EXTERNAL MODULE: ./src/components/Balance.tsx
var Balance = __webpack_require__(18778);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/Modal.tsx
var Modal = __webpack_require__(85937);
// EXTERNAL MODULE: ./packages/uikit/src/hooks/useTooltip/useTooltip.tsx + 1 modules
var useTooltip = __webpack_require__(88896);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Info.tsx
var Info = __webpack_require__(95459);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/TooltipText.tsx
var TooltipText = __webpack_require__(94998);
// EXTERNAL MODULE: ./src/state/lottery/helpers.ts
var helpers = __webpack_require__(72551);
// EXTERNAL MODULE: ./src/utils/multicall.ts
var multicall = __webpack_require__(9796);
// EXTERNAL MODULE: ./src/config/abi/lotteryV2.json
var lotteryV2 = __webpack_require__(48592);
// EXTERNAL MODULE: ./src/config/constants/lottery.ts
var constants_lottery = __webpack_require__(73809);
// EXTERNAL MODULE: ./src/utils/addressHelpers.ts + 1 modules
var addressHelpers = __webpack_require__(8414);
// EXTERNAL MODULE: ./src/utils/bigNumber.ts
var bigNumber = __webpack_require__(87318);
// EXTERNAL MODULE: ./src/state/lottery/getUserTicketsData.ts
var getUserTicketsData = __webpack_require__(863);
// EXTERNAL MODULE: ./src/state/lottery/getLotteriesData.ts
var getLotteriesData = __webpack_require__(26958);
;// CONCATENATED MODULE: ./src/state/lottery/fetchUnclaimedUserRewards.ts













var lotteryAddress = (0,addressHelpers/* getLotteryV2Address */.kN)();
var fetchCakeRewardsForTickets = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(winningTickets) {
        var calls, cakeRewards, ethTotal, ticketsWithUnclaimedRewards, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    calls = winningTickets.map(function(winningTicket) {
                        var roundId = winningTicket.roundId, id = winningTicket.id, rewardBracket = winningTicket.rewardBracket;
                        return {
                            name: "viewRewardsForTicketId",
                            address: lotteryAddress,
                            params: [
                                roundId,
                                id,
                                rewardBracket
                            ]
                        };
                    });
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0,multicall/* multicallv2 */.v)({
                            abi: lotteryV2,
                            calls: calls
                        })
                    ];
                case 2:
                    cakeRewards = _state.sent();
                    ethTotal = cakeRewards.reduce(function(accum, cakeReward) {
                        return accum.plus(new bignumber/* default */.Z(cakeReward[0].toString()));
                    }, bigNumber/* BIG_ZERO */.HW);
                    ticketsWithUnclaimedRewards = winningTickets.map(function(winningTicket, index) {
                        return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, winningTicket), {
                            cakeReward: cakeRewards[index]
                        });
                    });
                    return [
                        2,
                        {
                            ticketsWithUnclaimedRewards: ticketsWithUnclaimedRewards,
                            ethTotal: ethTotal
                        }
                    ];
                case 3:
                    error = _state.sent();
                    console.error(error);
                    return [
                        2,
                        {
                            ticketsWithUnclaimedRewards: null,
                            ethTotal: null
                        }
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchCakeRewardsForTickets(winningTickets) {
        return _ref.apply(this, arguments);
    };
}();
var getRewardBracketByNumber = function(ticketNumber, finalNumber) {
    // Winning numbers are evaluated right-to-left in the smart contract, so we reverse their order for validation here:
    // i.e. '1123456' should be evaluated as '6543211'
    var ticketNumAsArray = ticketNumber.split("").reverse();
    var winningNumsAsArray = finalNumber.split("").reverse();
    var matchingNumbers = [];
    // The number at index 6 in all tickets is 1 and will always match, so finish at index 5
    for(var index = 0; index < winningNumsAsArray.length - 1; index++){
        if (ticketNumAsArray[index] !== winningNumsAsArray[index]) {
            break;
        }
        matchingNumbers.push(ticketNumAsArray[index]);
    }
    // Reward brackets refer to indexes, 0 = 1 match, 5 = 6 matches. Deduct 1 from matchingNumbers' length to get the reward bracket
    var rewardBracket = matchingNumbers.length - 1;
    return rewardBracket;
};
var getWinningTickets = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(roundDataAndUserTickets) {
        var roundId, userTickets, finalNumber, ticketsWithRewardBrackets, allWinningTickets, unclaimedWinningTickets, ref, ticketsWithUnclaimedRewards, ethTotal, albTotal;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    roundId = roundDataAndUserTickets.roundId, userTickets = roundDataAndUserTickets.userTickets, finalNumber = roundDataAndUserTickets.finalNumber;
                    ticketsWithRewardBrackets = userTickets.map(function(ticket) {
                        return {
                            roundId: roundId,
                            id: ticket.id,
                            number: ticket.number,
                            status: ticket.status,
                            rewardBracket: getRewardBracketByNumber(ticket.number, finalNumber)
                        };
                    });
                    allWinningTickets = ticketsWithRewardBrackets.filter(function(ticket) {
                        return ticket.rewardBracket >= 0;
                    });
                    unclaimedWinningTickets = allWinningTickets.filter(function(ticket) {
                        return !ticket.status;
                    });
                    if (!(unclaimedWinningTickets.length > 0)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        fetchCakeRewardsForTickets(unclaimedWinningTickets)
                    ];
                case 1:
                    ref = _state.sent(), ticketsWithUnclaimedRewards = ref.ticketsWithUnclaimedRewards, ethTotal = ref.ethTotal;
                    albTotal = bigNumber/* BIG_ZERO */.HW;
                    return [
                        2,
                        {
                            ticketsWithUnclaimedRewards: ticketsWithUnclaimedRewards,
                            allWinningTickets: allWinningTickets,
                            ethTotal: ethTotal,
                            albTotal: albTotal,
                            roundId: roundId
                        }
                    ];
                case 2:
                    if (allWinningTickets.length > 0) {
                        return [
                            2,
                            {
                                ticketsWithUnclaimedRewards: null,
                                allWinningTickets: allWinningTickets,
                                ethTotal: null,
                                albTotal: null,
                                roundId: roundId
                            }
                        ];
                    }
                    return [
                        2,
                        null
                    ];
            }
        });
    });
    return function getWinningTickets(roundDataAndUserTickets) {
        return _ref.apply(this, arguments);
    };
}();
var getWinningNumbersForRound = function(targetRoundId, lotteriesData) {
    var targetRound = lotteriesData.find(function(pastLottery) {
        return pastLottery.id === targetRoundId;
    });
    return targetRound === null || targetRound === void 0 ? void 0 : targetRound.finalNumber;
};
var fetchUnclaimedUserRewards = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(account, userLotteryData, lotteriesData, currentLotteryId) {
        var rounds, roundsInRange, claimableRounds, roundsWithPossibleWinnings, roundsToCheck, idsToCheck, userTicketData, roundsWithTickets, roundDataAndWinningTickets, winningTicketsForPastRounds, roundsWithWinningTickets, roundsWithUnclaimedWinningTickets;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    rounds = userLotteryData.rounds;
                    // If there is no user round history - return an empty array
                    if (rounds.length === 0) {
                        return [
                            2,
                            []
                        ];
                    }
                    // If the web3 provider account doesn't equal the userLotteryData account, return an empty array - this is effectively a loading state as the user switches accounts
                    if (userLotteryData.account.toLowerCase() !== account.toLowerCase()) {
                        return [
                            2,
                            []
                        ];
                    }
                    roundsInRange = rounds.filter(function(round) {
                        var lastCheckableRoundId = parseInt(currentLotteryId, 10) - getLotteriesData/* MAX_LOTTERIES_REQUEST_SIZE */.BC;
                        var roundId = parseInt(round.lotteryId, 10);
                        return roundId >= lastCheckableRoundId;
                    });
                    claimableRounds = roundsInRange.filter(function(round) {
                        return round.status.toLowerCase() === types/* LotteryStatus.CLAIMABLE */.p3.CLAIMABLE;
                    });
                    roundsWithPossibleWinnings = claimableRounds.filter(function(round) {
                        return !round.claimed || parseInt(round.totalTickets, 10) > 100;
                    });
                    roundsToCheck = roundsWithPossibleWinnings.slice(0, constants_lottery/* NUM_ROUNDS_TO_CHECK_FOR_REWARDS */.f7);
                    if (!(roundsToCheck.length > 0)) return [
                        3,
                        3
                    ];
                    idsToCheck = roundsToCheck.map(function(round) {
                        return round.lotteryId;
                    });
                    return [
                        4,
                        (0,getUserTicketsData/* fetchUserTicketsForMultipleRounds */["if"])(idsToCheck, account, currentLotteryId)
                    ];
                case 1:
                    userTicketData = _state.sent();
                    roundsWithTickets = userTicketData.filter(function(roundData) {
                        var ref;
                        return (roundData === null || roundData === void 0 ? void 0 : (ref = roundData.userTickets) === null || ref === void 0 ? void 0 : ref.length) > 0;
                    });
                    roundDataAndWinningTickets = roundsWithTickets.map(function(roundData) {
                        return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, roundData), {
                            finalNumber: getWinningNumbersForRound(roundData.roundId, lotteriesData)
                        });
                    });
                    return [
                        4,
                        Promise.all(roundDataAndWinningTickets.map(function(roundData) {
                            return getWinningTickets(roundData);
                        }))
                    ];
                case 2:
                    winningTicketsForPastRounds = _state.sent();
                    roundsWithWinningTickets = winningTicketsForPastRounds.filter(function(winningTicketData) {
                        return winningTicketData !== null;
                    });
                    roundsWithUnclaimedWinningTickets = roundsWithWinningTickets.filter(function(winningTicketData) {
                        return winningTicketData.ticketsWithUnclaimedRewards;
                    });
                    return [
                        2,
                        roundsWithUnclaimedWinningTickets
                    ];
                case 3:
                    // All rounds claimed, return empty array
                    return [
                        2,
                        []
                    ];
            }
        });
    });
    return function fetchUnclaimedUserRewards(account, userLotteryData, lotteriesData, currentLotteryId) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var lottery_fetchUnclaimedUserRewards = (fetchUnclaimedUserRewards);

// EXTERNAL MODULE: ./node_modules/lodash/orderBy.js
var orderBy = __webpack_require__(75472);
var orderBy_default = /*#__PURE__*/__webpack_require__.n(orderBy);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/lodash/random.js
var random = __webpack_require__(83608);
var random_default = /*#__PURE__*/__webpack_require__.n(random);
// EXTERNAL MODULE: ./node_modules/lodash/uniqueId.js
var uniqueId = __webpack_require__(73955);
var uniqueId_default = /*#__PURE__*/__webpack_require__.n(uniqueId);
;// CONCATENATED MODULE: ./src/views/Lottery/helpers.tsx


/**
 * Remove the '1' and reverse the digits in a lottery number retrieved from the smart contract
 */ var parseRetrievedNumber = function(number) {
    var numberAsArray = number.split("");
    numberAsArray.splice(0, 1);
    numberAsArray.reverse();
    return numberAsArray.join("");
};
var getDrawnDate = function(locale, endTime) {
    var endTimeInMs = parseInt(endTime, 10) * 1000;
    var endTimeAsDate = new Date(endTimeInMs);
    return endTimeAsDate.toLocaleDateString(locale, dateTimeOptions);
};
var dateOptions = {
    year: "numeric",
    month: "short",
    day: "numeric"
};
var timeOptions = {
    hour: "numeric",
    minute: "numeric"
};
var dateTimeOptions = (0,src_object_spread/* default */.Z)({}, dateOptions, timeOptions);
var processLotteryResponse = function(lotteryData) {
    var priceTicketInEthAsString = lotteryData.priceTicketInEth, discountDivisorAsString = lotteryData.discountDivisor, amountCollectedInEthAsString = lotteryData.amountCollectedInEth, albAmountPreAllocated = lotteryData.albAmountPreAllocated, albPrizePercent = lotteryData.albPrizePercent;
    var discountDivisor = new bignumber/* default */.Z(discountDivisorAsString);
    var priceTicketInEth = new bignumber/* default */.Z(priceTicketInEthAsString);
    var amountCollectedInEth = new bignumber/* default */.Z(amountCollectedInEthAsString);
    return {
        isLoading: lotteryData.isLoading,
        lotteryId: lotteryData.lotteryId,
        userTickets: lotteryData.userTickets,
        status: lotteryData.status,
        startTime: lotteryData.startTime,
        endTime: lotteryData.endTime,
        priceTicketInEth: priceTicketInEth,
        discountDivisor: discountDivisor,
        treasuryFee: lotteryData.treasuryFee,
        firstTicketId: lotteryData.firstTicketId,
        lastTicketId: lotteryData.lastTicketId,
        amountCollectedInEth: amountCollectedInEth,
        finalNumber: lotteryData.finalNumber,
        ethPerBracket: lotteryData.ethPerBracket,
        countWinnersPerBracket: lotteryData.countWinnersPerBracket,
        rewardsBreakdown: lotteryData.rewardsBreakdown,
        albAmountPreAllocated: albAmountPreAllocated,
        albPrizePercent: albPrizePercent
    };
};

;// CONCATENATED MODULE: ./src/views/Lottery/components/LotteryNumbers/index.tsx


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    width: ",
        ";\n    height: ",
        ";\n    padding: 10px;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 10px;\n    flex-shrink: 0; \n    border-radius: 100px; \n    text-align: center;\n    leading-trim: both;\n    text-edge: cap;\n    text-shadow: 0px 1px 0px rgba(3, 0, 20, 0.50);\n    font-family: Syncopate;\n    font-size: ",
        ";\n    font-style: normal;\n    font-weight: 700;\n    line-height: 100%;\n    letter-spacing: -0.54px;\n    text-transform: uppercase; \n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var StyledBall = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2bcc36be-0"
})(_templateObject(), function(param) {
    var size = param.size;
    return size ? "".concat(size, "px") : "40px";
}, function(param) {
    var size = param.size;
    return size ? "".concat(size, "px") : "40px";
}, function(param) {
    var fontSize = param.fontSize;
    return fontSize ? "".concat(fontSize, "px") : "18px";
});
var LotteryBall = function(param) {
    var color = param.color, number = param.number, style = param.style, _size = param.size, size = _size === void 0 ? 40 : _size, _fontSize = param.fontSize, fontSize = _fontSize === void 0 ? 18 : _fontSize;
    var styles = {
        purple: {
            backgroundColor: "#9465FF",
            boxShadow: "0px 0px ".concat(size / 2, "px 0px #060318 inset")
        },
        green: {
            backgroundColor: "rgba(102, 255, 182, 0.75)",
            boxShadow: "0px 0px ".concat(size / 2, "px 0px #050218 inset")
        },
        yellow: {
            backgroundColor: "rgba(255, 231, 102, 0.75)",
            boxShadow: "0px 0px ".concat(size / 2, "px 0px #030014 inset")
        },
        orange: {
            backgroundColor: "rgba(255, 166, 102, 0.75)",
            boxShadow: "0px 0px ".concat(size / 2, "px 0px #050218 inset")
        },
        pink: {
            backgroundColor: "rgba(255, 102, 212, 0.75)",
            boxShadow: "0px 0px ".concat(size / 2, "px 0px #050218 inset")
        },
        cyan: {
            backgroundColor: "rgba(101, 246, 255, 0.75)",
            boxShadow: "0px 0px ".concat(size / 2, "px 0px #050218 inset")
        },
        red: {
            backgroundColor: "rgba(255, 102, 102, 0.75)",
            boxShadow: "0px 0px ".concat(size / 2, "px 0px #050218 inset")
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBall, {
        style: (0,src_object_spread/* default */.Z)({}, style, styles[color]),
        size: size,
        fontSize: fontSize,
        children: number
    });
};
/* harmony default export */ var LotteryNumbers = (LotteryBall);

;// CONCATENATED MODULE: ./src/views/Lottery/components/WinningNumbers.tsx










var WinningNumbers = function(_param) {
    var number = _param.number, _size = _param.size, size = _size === void 0 ? "32px" : _size, _fontSize = _param.fontSize, fontSize = _fontSize === void 0 ? "16px" : _fontSize, rotateText = _param.rotateText, containerProps = (0,_object_without_properties/* default */.Z)(_param, [
        "number",
        "size",
        "fontSize",
        "rotateText"
    ]);
    var ref = (0,react.useState)([]), rotationValues = ref[0], setRotationValues = ref[1];
    var reversedNumber = parseRetrievedNumber(number);
    var numAsArray = reversedNumber.split("");
    var colors = [
        "pink",
        "cyan",
        "green",
        "orange",
        "green",
        "yellow",
        "purple"
    ];
    (0,react.useEffect)(function() {
        if (rotateText && numAsArray && rotationValues.length === 0) {
            setRotationValues(numAsArray.map(function() {
                return random_default()(-30, 30);
            }));
        }
    }, [
        rotateText,
        numAsArray,
        rotationValues
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Flex/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        justifyContent: "space-between"
    }, containerProps), {
        style: {
            gap: "5px"
        },
        children: numAsArray.map(function(num, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryNumbers, {
                size: parseInt(size),
                color: colors[index],
                number: parseInt(num),
                fontSize: fontSize
            }, uniqueId_default()());
        })
    }));
};
/* harmony default export */ var components_WinningNumbers = (WinningNumbers);

;// CONCATENATED MODULE: ./src/views/Lottery/components/TicketNumber.tsx

function TicketNumber_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  align-items: center;\n  height: 60px;\n  border-radius: 10px;\n  background-image: url(/images/lottery-pattern.png);\n  justify-content: space-between;\n"
    ]);
    TicketNumber_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: 1;\n  width: ",
        ";\n  height: 60px;\n  border-radius: 5px;\n  top: 0;\n  left: 0;\n  position: absolute;\n  border: 2px ",
        " solid;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var StyledNumberWrapper = (0,styled_components_browser_esm/* default */.ZP)(Box_Flex/* default */.Z).withConfig({
    componentId: "sc-be9fcde-0"
})(TicketNumber_templateObject());
var RewardHighlighter = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-be9fcde-1"
})(_templateObject1(), function(param) {
    var numberMatches = param.numberMatches;
    return "".concat(numberMatches < 6 ? numberMatches * 16.66 : 100, "%");
}, function(param) {
    var theme = param.theme;
    return theme.colors.alienPurple;
});
var TicketNumber = function(param) {
    var localId = param.localId, id = param.id, number = param.number, rewardBracket = param.rewardBracket;
    var t = (0,src/* useTranslation */.$G)().t;
    var reversedNumber = parseRetrievedNumber(number);
    var numberAsArray = reversedNumber.split("");
    var numberMatches = rewardBracket + 1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
        flexDirection: "column",
        mb: "20px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        fontSize: "12px",
                        color: "textSubtle",
                        mb: "10px",
                        children: [
                            "#",
                            localId || id
                        ]
                    }),
                    rewardBracket >= 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        fontSize: "12px",
                        children: [
                            t("Matched first"),
                            " ",
                            numberMatches
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledNumberWrapper, {
                children: [
                    rewardBracket >= 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(RewardHighlighter, {
                        numberMatches: numberMatches
                    }),
                    numberAsArray.map(function(digit) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Flex/* default */.Z, {
                            justifyContent: "center",
                            width: "16.66%",
                            alignItems: "center",
                            style: {
                                padding: "25px 14px",
                                height: "60px"
                            },
                            children: digit
                        }, "".concat(localId || id, "-").concat(digit, "-").concat(uniqueId_default()()));
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_TicketNumber = (TicketNumber);

// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/styles.tsx
var styles = __webpack_require__(15426);
// EXTERNAL MODULE: ./node_modules/lodash/delay.js
var delay = __webpack_require__(98066);
var delay_default = /*#__PURE__*/__webpack_require__.n(delay);
// EXTERNAL MODULE: ./node_modules/canvas-confetti/dist/confetti.module.mjs
var confetti_module = __webpack_require__(39883);
// EXTERNAL MODULE: ./packages/uikit/src/contexts/ToastsContext/useToast.ts
var useToast = __webpack_require__(19237);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/AutoRenew.tsx
var AutoRenew = __webpack_require__(63771);
// EXTERNAL MODULE: ./src/components/Toast/index.tsx + 1 modules
var Toast = __webpack_require__(96036);
// EXTERNAL MODULE: ./src/hooks/useCallDefaultGasPrice.ts
var useCallDefaultGasPrice = __webpack_require__(91543);
// EXTERNAL MODULE: ./src/hooks/useCatchTxError.tsx
var useCatchTxError = __webpack_require__(76431);
// EXTERNAL MODULE: ./src/hooks/useContract.ts + 2 modules
var useContract = __webpack_require__(93146);
;// CONCATENATED MODULE: ./src/views/Lottery/components/ClaimPrizesModal/ClaimPrizesInner.tsx




















var ClaimInnerContainer = function(param) {
    var onSuccess = param.onSuccess, roundsToClaim = param.roundsToClaim;
    var ref, ref1;
    var account = (0,wagmi_src/* useWeb3React */.Ge)().account;
    var t = (0,src/* useTranslation */.$G)().t;
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var ref2 = useLottery(), maxNumberTicketsPerBuyOrClaim = ref2.maxNumberTicketsPerBuyOrClaim, currentLotteryId = ref2.currentLotteryId;
    var toastSuccess = (0,useToast/* useToast */.p)().toastSuccess;
    var callNoGasPrice = (0,useCallDefaultGasPrice/* useCallNoGasPrice */.s)().callNoGasPrice;
    var ref3 = (0,useCatchTxError/* default */.Z)(), fetchWithCatchTxError = ref3.fetchWithCatchTxError, pendingTx = ref3.loading;
    var ref4 = (0,react.useState)(0), activeClaimIndex = ref4[0], setActiveClaimIndex = ref4[1];
    var ref5 = (0,react.useState)(null), albRewardData = ref5[0], setAlbRewardData = ref5[1];
    var ref6 = (0,react.useState)(Math.ceil(roundsToClaim[activeClaimIndex].ticketsWithUnclaimedRewards.length / maxNumberTicketsPerBuyOrClaim.toNumber())), pendingBatchClaims = ref6[0], setPendingBatchClaims = ref6[1];
    var lotteryContract = (0,useContract/* useLotteryV2Contract */.X0)();
    var newLotteryContract = (0,useContract/* useNewLotteryV2Contract */.Du)();
    var activeClaimData = roundsToClaim[activeClaimIndex];
    var ethPrice = (0,hooks/* useEthPriceBusd */.Tv)();
    var ethReward = activeClaimData.ethTotal;
    var albReward = activeClaimData.albTotal;
    var dollarReward = ethReward.times(ethPrice);
    var rewardAsBalance = (0,formatBalance/* getBalanceAmount */.U4)(ethReward, 18);
    var albRewardAsBalance = (0,formatBalance/* getBalanceAmount */.U4)(albReward, 18);
    var dollarRewardAsBalance = (0,formatBalance/* getBalanceAmount */.U4)(dollarReward).toNumber();
    var parseUnclaimedTicketDataForClaimCall = function(ticketsWithUnclaimedRewards, lotteryId) {
        var ticketIds = ticketsWithUnclaimedRewards.map(function(ticket) {
            return ticket.id;
        });
        var brackets = ticketsWithUnclaimedRewards.map(function(ticket) {
            return ticket.rewardBracket;
        });
        return {
            lotteryId: lotteryId,
            ticketIds: ticketIds,
            brackets: brackets
        };
    };
    var claimTicketsCallData = parseUnclaimedTicketDataForClaimCall(activeClaimData.ticketsWithUnclaimedRewards, activeClaimData.roundId);
    var shouldBatchRequest = maxNumberTicketsPerBuyOrClaim.lt(claimTicketsCallData.ticketIds.length);
    var handleProgressToNextClaim = function() {
        if (roundsToClaim.length > activeClaimIndex + 1) {
            // If there are still rounds to claim, move onto the next claim
            setActiveClaimIndex(activeClaimIndex + 1);
            dispatch((0,lottery/* fetchUserLotteries */.wV)({
                account: account,
                currentLotteryId: currentLotteryId
            }));
        } else {
            onSuccess();
        }
    };
    var getTicketBatches = function(ticketIds, brackets) {
        var requests = [];
        var maxAsNumber = maxNumberTicketsPerBuyOrClaim.toNumber();
        for(var i = 0; i < ticketIds.length; i += maxAsNumber){
            var ticketIdsSlice = ticketIds.slice(i, maxAsNumber + i);
            var bracketsSlice = brackets.slice(i, maxAsNumber + i);
            requests.push({
                ticketIds: ticketIdsSlice,
                brackets: bracketsSlice
            });
        }
        return requests;
    };
    var handleClaim = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var lotteryId, ticketIds, brackets, receipt;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        lotteryId = claimTicketsCallData.lotteryId, ticketIds = claimTicketsCallData.ticketIds, brackets = claimTicketsCallData.brackets;
                        return [
                            4,
                            fetchWithCatchTxError(function() {
                                return callNoGasPrice(parseInt(lotteryId) >= parseInt(lottery/* LATEST_LOTTERY_NEW_CONTRACT */.hi) ? newLotteryContract : lotteryContract, "claimTickets", [
                                    lotteryId,
                                    ticketIds,
                                    brackets
                                ]);
                            })
                        ];
                    case 1:
                        receipt = _state.sent();
                        if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                            toastSuccess(t("Prizes Collected!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                                txHash: receipt.transactionHash,
                                children: t("Your prizes for round %lotteryId% have been sent to your wallet", {
                                    lotteryId: lotteryId
                                })
                            }));
                            handleProgressToNextClaim();
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleClaim() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleBatchClaim = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var lotteryId, ticketIds, brackets, ticketBatches, transactionsToFire, receipts, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step, _ret, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        lotteryId = claimTicketsCallData.lotteryId, ticketIds = claimTicketsCallData.ticketIds, brackets = claimTicketsCallData.brackets;
                        ticketBatches = getTicketBatches(ticketIds, brackets);
                        transactionsToFire = ticketBatches.length;
                        receipts = [];
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        _loop = function() {
                            var ticketBatch, receipt;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        ticketBatch = _step.value;
                                        return [
                                            4,
                                            fetchWithCatchTxError(function() {
                                                return callNoGasPrice(parseInt(lotteryId) >= parseInt(lottery/* LATEST_LOTTERY_NEW_CONTRACT */.hi) ? newLotteryContract : lotteryContract, "claimTickets", [
                                                    lotteryId,
                                                    ticketBatch.ticketIds,
                                                    ticketBatch.brackets
                                                ]);
                                            })
                                        ];
                                    case 1:
                                        receipt = _state.sent();
                                        if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                                            // One transaction within batch has succeeded
                                            receipts.push(receipt);
                                            setPendingBatchClaims(transactionsToFire - receipts.length);
                                            // More transactions are to be done within the batch. Issue toast to give user feedback.
                                            if (receipts.length !== transactionsToFire) {
                                                toastSuccess(t("Prizes Collected!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                                                    txHash: receipt.transactionHash,
                                                    children: t("Claim %claimNum% of %claimTotal% for round %lotteryId% was successful. Please confirm the next transaction", {
                                                        claimNum: receipts.length,
                                                        claimTotal: transactionsToFire,
                                                        lotteryId: lotteryId
                                                    })
                                                }));
                                            }
                                        } else {
                                            return [
                                                2,
                                                "break"
                                            ];
                                        }
                                        return [
                                            2
                                        ];
                                }
                            });
                        };
                        _iterator = ticketBatches[Symbol.iterator]();
                        _state.label = 2;
                    case 2:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            5
                        ];
                        return [
                            5,
                            (0,tslib_es6.__values)(_loop())
                        ];
                    case 3:
                        _ret = _state.sent();
                        if (_ret === "break") return [
                            3,
                            5
                        ];
                        _state.label = 4;
                    case 4:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            2
                        ];
                    case 5:
                        return [
                            3,
                            8
                        ];
                    case 6:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            8
                        ];
                    case 7:
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 8:
                        // Batch is finished
                        if (receipts.length === transactionsToFire) {
                            toastSuccess(t("Prizes Collected!"), t("Your ETH prizes for round %lotteryId% have been sent to your wallet", {
                                lotteryId: lotteryId
                            }));
                            handleProgressToNextClaim();
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleBatchClaim() {
            return _ref.apply(this, arguments);
        };
    }();
    var lotteryId = claimTicketsCallData.lotteryId, brackets = claimTicketsCallData.brackets;
    var getAlbRewards = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var lotteryForAlb, rewardsPercentagePerBracket, totalAlbPrizePool, albPrizePercent, totalReward, ticketCounts;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,helpers/* fetchLottery */.JE)(lotteryId, true)
                        ];
                    case 1:
                        lotteryForAlb = _state.sent();
                        rewardsPercentagePerBracket = lotteryForAlb.rewardsBreakdown.map(function(reward) {
                            return parseFloat(reward) / 100;
                        });
                        totalAlbPrizePool = new bignumber/* default */.Z(lotteryForAlb.albAmountPreAllocated).div(1e18);
                        albPrizePercent = new bignumber/* default */.Z(lotteryForAlb.albPrizePercent).div(1000);
                        totalReward = new bignumber/* default */.Z(0);
                        ticketCounts = {};
                        brackets.forEach(function(bracket) {
                            ticketCounts[bracket] = (ticketCounts[bracket] || 0) + 1;
                        });
                        rewardsPercentagePerBracket.forEach(function(percentage, index) {
                            var bracketTotalPrize = totalAlbPrizePool.times(percentage).div(100).times(albPrizePercent);
                            var winnersInBracket = lotteryForAlb.countWinnersPerBracket[index];
                            var prizePerWinner = parseInt(winnersInBracket) > 0 ? bracketTotalPrize.div(winnersInBracket) : new bignumber/* default */.Z(0);
                            var userTicketsInBracket = ticketCounts[index] || 0;
                            var rewardForThisBracket = prizePerWinner.times(userTicketsInBracket);
                            totalReward = totalReward.plus(rewardForThisBracket);
                        });
                        return [
                            2,
                            {
                                rewards: totalReward,
                                percentage: lotteryForAlb.albPrizePercent
                            }
                        ];
                }
            });
        });
        return function getAlbRewards() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        var fetchAlbRewards = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var data;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                getAlbRewards()
                            ];
                        case 1:
                            data = _state.sent();
                            setAlbRewardData(data);
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchAlbRewards() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchAlbRewards();
    }, [
        claimTicketsCallData
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                flexDirection: "column",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        mb: "4px",
                        textAlign: [
                            "center",
                            null,
                            "left"
                        ],
                        children: t("You won")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                        alignItems: [
                            "flex-start",
                            null,
                            "center"
                        ],
                        justifyContent: [
                            "flex-start",
                            null,
                            "space-between"
                        ],
                        flexDirection: "column",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                                textAlign: [
                                    "center",
                                    null,
                                    "left"
                                ],
                                lineHeight: "1.1",
                                value: (ref = rewardAsBalance === null || rewardAsBalance === void 0 ? void 0 : rewardAsBalance.times(albRewardData === null || albRewardData === void 0 ? void 0 : albRewardData.percentage)) === null || ref === void 0 ? void 0 : ref.div(1000).toNumber(),
                                decimals: 8,
                                fontSize: "44px",
                                bold: true,
                                color: "text",
                                unit: " ETH"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                                textAlign: [
                                    "center",
                                    null,
                                    "left"
                                ],
                                lineHeight: "1.1",
                                value: albRewardData === null || albRewardData === void 0 ? void 0 : (ref1 = albRewardData.rewards) === null || ref1 === void 0 ? void 0 : ref1.toNumber(),
                                decimals: 0,
                                fontSize: "44px",
                                bold: true,
                                color: "text",
                                unit: " ALB"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                        mt: [
                            "12px",
                            null,
                            "0"
                        ],
                        textAlign: [
                            "center",
                            null,
                            "left"
                        ],
                        value: dollarRewardAsBalance,
                        fontSize: "12px",
                        color: "textSubtle",
                        unit: " USD",
                        prefix: "~"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Flex/* default */.Z, {
                alignItems: "center",
                justifyContent: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                    mt: "8px",
                    fontSize: "12px",
                    color: "textSubtle",
                    children: [
                        t("Round"),
                        " #",
                        activeClaimData.roundId
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Flex/* default */.Z, {
                alignItems: "center",
                justifyContent: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                    isLoading: pendingTx,
                    endIcon: pendingTx ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                        spin: true,
                        color: "currentColor"
                    }) : null,
                    mt: "20px",
                    width: "100%",
                    onClick: function() {
                        return shouldBatchRequest ? handleBatchClaim() : handleClaim();
                    },
                    children: [
                        pendingTx ? t("Claiming") : t("Claim"),
                        " ",
                        pendingBatchClaims > 1 ? "(".concat(pendingBatchClaims, ")") : ""
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var ClaimPrizesInner = (ClaimInnerContainer);

;// CONCATENATED MODULE: ./src/views/Lottery/components/ClaimPrizesModal/index.tsx

function ClaimPrizesModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  overflow: visible;\n\n  ",
        " {\n    min-width: 380px;\n  }\n"
    ]);
    ClaimPrizesModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ClaimPrizesModal_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border-top-right-radius: 32px;\n  border-top-left-radius: 32px;\n"
    ]);
    ClaimPrizesModal_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: -116px; // line up bunny at the top of the modal\n  left: 0px;\n  text-align: center;\n  width: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}












var StyledModal = (0,styled_components_browser_esm/* default */.ZP)(styles/* ModalContainer */.F0).withConfig({
    componentId: "sc-1c7656bb-0"
})(ClaimPrizesModal_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var StyledModalHeader = (0,styled_components_browser_esm/* default */.ZP)(styles/* ModalHeader */.xB).withConfig({
    componentId: "sc-1c7656bb-1"
})(ClaimPrizesModal_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.gradientCardHeader;
});
var BunnyDecoration = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1c7656bb-2"
})(_templateObject2());
var showConfetti = function() {
    (0,confetti_module/* default */.Z)({
        particleCount: 200,
        startVelocity: 30,
        gravity: 0.5,
        spread: 350,
        colors: [
            "#65F6FF",
            "#66FFB6",
            "#9465FF",
            "#FF66D4",
            "#FFA666",
            "#FFE766"
        ],
        origin: {
            x: 0.5,
            y: 0.3
        }
    });
};
var ClaimPrizesModal = function(param) {
    var onDismiss = param.onDismiss, roundsToClaim = param.roundsToClaim;
    var t = (0,src/* useTranslation */.$G)().t;
    var account = (0,wagmi_src/* useWeb3React */.Ge)().account;
    var currentLotteryId = useLottery().currentLotteryId;
    var dispatch = (0,state/* useAppDispatch */.TL)();
    (0,react.useEffect)(function() {
        delay_default()(showConfetti, 100);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledModal, {
        $minWidth: "280px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledModalHeader, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ModalTitle */.r6, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                            children: t("Collect Winnings")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ModalCloseButton */.ol, {
                        onDismiss: onDismiss
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ModalBody */.fe, {
                p: "24px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClaimPrizesInner, {
                    onSuccess: function() {
                        dispatch((0,lottery/* fetchUserLotteries */.wV)({
                            account: account,
                            currentLotteryId: currentLotteryId
                        }));
                        onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
                    },
                    roundsToClaim: roundsToClaim
                })
            })
        ]
    });
};
/* harmony default export */ var components_ClaimPrizesModal = (ClaimPrizesModal);

;// CONCATENATED MODULE: ./src/views/Lottery/components/ViewTicketsModal/PreviousRoundTicketsInner.tsx




function PreviousRoundTicketsInner_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n  margin: -30px;\n  padding: 30px;\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    PreviousRoundTicketsInner_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PreviousRoundTicketsInner_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-right: -20px;\n  padding-right: 24px;\n  max-height: 300px;\n  overflow-y: scroll;\n  margin-top: 24px;\n"
    ]);
    PreviousRoundTicketsInner_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PreviousRoundTicketsInner_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  justify-content: space-between;\n  align-items: center;\n  padding: 15px 0;\n  color: ",
        ";\n  border-top: 1px solid ",
        ";\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    PreviousRoundTicketsInner_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

















var TopBox = (0,styled_components_browser_esm/* default */.ZP)(Box_Flex/* default */.Z).withConfig({
    componentId: "sc-6a83414c-0"
})(PreviousRoundTicketsInner_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
});
var ScrollBox = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-6a83414c-1"
})(PreviousRoundTicketsInner_templateObject1());
var CustomText = (0,styled_components_browser_esm/* default */.ZP)(Box_Flex/* default */.Z).withConfig({
    componentId: "sc-6a83414c-2"
})(PreviousRoundTicketsInner_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
}, function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
}, function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
});
var TicketSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                width: "32px",
                height: "12px",
                mt: "2px",
                mb: "4px"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                width: "100%",
                height: "34px",
                mb: "12px"
            })
        ]
    });
};
var PreviousRoundTicketsInner = function(param) {
    var roundId = param.roundId;
    var ref;
    var ref1 = (0,react.useState)(null), lotteryInfo = ref1[0], setLotteryInfo = ref1[1];
    var ref2 = (0,react.useState)(null), allUserTickets = ref2[0], setAllUserTickets = ref2[1];
    var ref3 = (0,react.useState)({
        allWinningTickets: null,
        ticketsWithUnclaimedRewards: null,
        isFetched: false,
        claimData: null
    }), userWinningTickets = ref3[0], setUserWinningTickets = ref3[1];
    var t = (0,src/* useTranslation */.$G)().t;
    var theme = (0,useTheme/* default */.ZP)().theme;
    var account = (0,wagmi_src/* useWeb3React */.Ge)().account;
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_ClaimPrizesModal, {
        roundsToClaim: [
            userWinningTickets.claimData
        ]
    }), false), 1), onPresentClaimModal = ref4[0];
    var TooltipComponent = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    mb: "16px",
                    children: t("Tickets must match the winning number in the exact same order, starting from the first digit.")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    mb: "16px",
                    children: t("If the winning number is “123456”:")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    mb: "4px",
                    children: t("“120000” matches the first 2 digits.")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    children: t("“000006” matches the last digit, but since the first five digits are wrong, it doesn’t win any prizes.")
                })
            ]
        });
    };
    var ref5 = (0,useTooltip/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipComponent, {}), {
        placement: "bottom-end",
        tooltipOffset: [
            20,
            10
        ]
    }), targetRef = ref5.targetRef, tooltip = ref5.tooltip, tooltipVisible = ref5.tooltipVisible;
    var currentRound = useLottery().currentRound;
    console.log("currentRound", currentRound);
    (0,react.useEffect)(function() {
        var addWinningTicketInfoToAllTickets = function(_allTickets, _allWinningTickets) {
            var allTicketsWithWinningTickets = _allTickets.map(function(ticket) {
                var winningTicketEquivalent = _allWinningTickets.find(function(winningTicket) {
                    return winningTicket.id === ticket.id;
                });
                if (winningTicketEquivalent) {
                    return winningTicketEquivalent;
                }
                return ticket;
            });
            return allTicketsWithWinningTickets;
        };
        var sortTicketsByWinningBracket = function(tickets) {
            return orderBy_default()(tickets, function(ticket) {
                return ticket.rewardBracket === undefined ? 0 : ticket.rewardBracket + 1;
            }, "desc");
        };
        var fetchData = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var isNew, roundIdAdjusted, ref, userTickets, lotteryData, processedLotteryData, winningTickets, allTicketsWithWinningTicketInfo, ticketsSortedByWinners;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            isNew = parseInt(lottery/* LATEST_LOTTERY_NEW_CONTRACT */.hi) < parseInt(roundId);
                            roundIdAdjusted = !isNew ? (parseInt(roundId) + 2).toString() : roundId;
                            return [
                                4,
                                Promise.all([
                                    (0,getUserTicketsData/* fetchUserTicketsForOneRound */.sh)(account, roundIdAdjusted, currentRound.lotteryId),
                                    (0,helpers/* fetchLottery */.JE)(roundIdAdjusted, isNew)
                                ])
                            ];
                        case 1:
                            ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                                _state.sent(),
                                2
                            ]), userTickets = ref[0], lotteryData = ref[1];
                            processedLotteryData = processLotteryResponse(lotteryData);
                            return [
                                4,
                                getWinningTickets({
                                    roundId: roundIdAdjusted,
                                    userTickets: userTickets,
                                    finalNumber: processedLotteryData.finalNumber.toString()
                                })
                            ];
                        case 2:
                            winningTickets = _state.sent();
                            setUserWinningTickets({
                                isFetched: true,
                                allWinningTickets: winningTickets === null || winningTickets === void 0 ? void 0 : winningTickets.allWinningTickets,
                                ticketsWithUnclaimedRewards: winningTickets === null || winningTickets === void 0 ? void 0 : winningTickets.ticketsWithUnclaimedRewards,
                                claimData: winningTickets
                            });
                            setLotteryInfo(processedLotteryData);
                            // If the user has some winning tickets - modify the userTickets response to include that data
                            if (winningTickets === null || winningTickets === void 0 ? void 0 : winningTickets.allWinningTickets) {
                                allTicketsWithWinningTicketInfo = addWinningTicketInfoToAllTickets(userTickets, winningTickets.allWinningTickets);
                                ticketsSortedByWinners = sortTicketsByWinningBracket(allTicketsWithWinningTicketInfo);
                                setAllUserTickets(ticketsSortedByWinners);
                            } else {
                                setAllUserTickets(userTickets);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchData();
    }, [
        roundId,
        account
    ]);
    var getFooter = function() {
        var ref;
        if ((userWinningTickets === null || userWinningTickets === void 0 ? void 0 : (ref = userWinningTickets.ticketsWithUnclaimedRewards) === null || ref === void 0 ? void 0 : ref.length) > 0) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                onClick: onPresentClaimModal,
                mt: "24px",
                width: "100%",
                children: t("Collect Prizes")
            });
        }
        if (!userWinningTickets.allWinningTickets) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: targetRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                    alignItems: "center",
                    justifyContent: "center",
                    mt: "20px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Info/* default */.Z, {
                            height: "20px",
                            width: "20px",
                            color: "textSubtle",
                            mr: "8px"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipText/* default */.Z, {
                            color: "textSubtle",
                            children: t("Why didn't I win?")
                        })
                    ]
                })
            });
        }
        return null;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            tooltipVisible && tooltip,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TopBox, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontWeight: 500,
                        textAlign: "center",
                        color: "text",
                        fontSize: "18px",
                        mb: "15px",
                        children: t("Winning numbers")
                    }),
                    (lotteryInfo === null || lotteryInfo === void 0 ? void 0 : lotteryInfo.finalNumber) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_WinningNumbers, {
                        number: lotteryInfo.finalNumber.toString(),
                        size: "40",
                        fontSize: "18"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        width: "230px",
                        height: "34px"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ScrollBox, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "text",
                        fontSize: "18px",
                        my: "16px",
                        children: t("Your tickets")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomText, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Flex/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                    color: "textSubtle",
                                    children: [
                                        t("Total tickets"),
                                        ":"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                bold: true,
                                color: "text",
                                children: allUserTickets ? allUserTickets.length : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                    width: "56px",
                                    height: "24px"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomText, {
                        mb: "24px",
                        style: {
                            borderTop: "none"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Flex/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                    color: "textSubtle",
                                    children: [
                                        t("Winning tickets"),
                                        ":"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                bold: true,
                                color: "text",
                                children: userWinningTickets.isFetched ? (userWinningTickets === null || userWinningTickets === void 0 ? void 0 : (ref = userWinningTickets.allWinningTickets) === null || ref === void 0 ? void 0 : ref.length) || "0" : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                    width: "40px",
                                    height: "24px"
                                })
                            })
                        ]
                    }),
                    allUserTickets ? allUserTickets.map(function(ticket) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TicketNumber, {
                            id: ticket.id,
                            number: ticket.number,
                            rewardBracket: ticket.rewardBracket,
                            status: ticket.status
                        }, ticket.id);
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketSkeleton, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketSkeleton, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketSkeleton, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketSkeleton, {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Flex/* default */.Z, {
                borderTop: "1px solid ".concat(theme.colors.cardBorder),
                alignItems: "center",
                justifyContent: "center",
                children: userWinningTickets.isFetched && getFooter()
            })
        ]
    });
};
/* harmony default export */ var ViewTicketsModal_PreviousRoundTicketsInner = (PreviousRoundTicketsInner);

// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Minus.tsx
var Minus = __webpack_require__(2412);
// EXTERNAL MODULE: ./packages/uikit/src/components/BalanceInput/BalanceInput.tsx
var BalanceInput = __webpack_require__(39665);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Add.tsx
var Add = __webpack_require__(96484);
// EXTERNAL MODULE: ./src/components/ApproveConfirmButtons.tsx
var ApproveConfirmButtons = __webpack_require__(73546);
// EXTERNAL MODULE: ./src/components/ConnectWalletButton.tsx + 1 modules
var ConnectWalletButton = __webpack_require__(72409);
// EXTERNAL MODULE: ./src/hooks/useTokenBalance.ts
var useTokenBalance = __webpack_require__(94186);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
;// CONCATENATED MODULE: ./src/views/Lottery/components/BuyTicketsModal/TicketInput.tsx


function TicketInput_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 60px;\n  box-sizing: border-box;\n  border-radius: 10px;\n  margin-bottom: 20px;\n  ",
        "\n"
    ]);
    TicketInput_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TicketInput_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  border: none;\n  height: 60px;\n  padding: 25px 14px;\n  font-size: 18px;\n  flex: 1;\n  width: 16.66%;\n  text-align: center;\n  min-width: 0;\n  background-color: transparent;\n  caret-color: #7a6faa;\n\n  &::placeholder {\n    text-align: center;\n  }\n\n  &:placeholder-shown {\n    text-align: left;\n  }\n\n  &:focus {\n    outline: none;\n    border: 1px solid ",
        " !important;\n  }\n\n  &::-webkit-outer-spin-button,\n  &::-webkit-inner-spin-button {\n    /* display: none; <- Crashes Chrome on hover */\n    -webkit-appearance: none;\n    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */\n  }\n\n  &:first-child {\n    border: 1px solid ",
        ";\n    border-bottom-left-radius: 10px;\n    border-top-left-radius: 10px;\n  }\n\n  &:last-child {\n    border-top-right-radius: 10px;\n    border-bottom-right-radius: 10px;\n    border: 1px solid ",
        ";\n    border-left: none;\n  }\n\n  &:not(:first-child):not(:last-child) {\n    border-right: 1px solid ",
        ";\n    border-top: 1px solid ",
        ";\n    border-bottom: 1px solid ",
        ";\n  }\n\n  -moz-appearance: textfield; /* Firefox */\n"
    ]);
    TicketInput_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var InputsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a8069772-0"
})(TicketInput_templateObject(), function(param) {
    var isDuplicate = param.isDuplicate;
    return isDuplicate && "\n    border: 1px solid #FFB237;\n    box-shadow: 0px 0px 0px 2px #FFB237;\n  ";
});
var DigitInput = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-a8069772-1"
})(TicketInput_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, function(param) {
    var theme = param.theme;
    return theme.colors.alienPurple;
}, function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
}, function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
}, function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
}, function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
}, function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
});
var getIdLabel = function(id) {
    if (id < 10) return "#00".concat(id);
    if (id < 100) return "#0".concat(id);
    return "#".concat(id);
};
var TicketContainer = function(param) {
    var ticket = param.ticket, duplicateWith = param.duplicateWith, updateTicket = param.updateTicket, disabled = param.disabled;
    var ref = (0,react.useState)(false), focused = ref[0], setFocused = ref[1];
    var containerRef = (0,react.useRef)(null);
    var digit1 = (0,react.useRef)(null);
    var digit2 = (0,react.useRef)(null);
    var digit3 = (0,react.useRef)(null);
    var digit4 = (0,react.useRef)(null);
    var digit5 = (0,react.useRef)(null);
    var digit6 = (0,react.useRef)(null);
    var t = (0,src/* useTranslation */.$G)().t;
    var digitRefs = [
        digit1,
        digit2,
        digit3,
        digit4,
        digit5,
        digit6
    ];
    var scrollInputIntoView = function() {
        if (containerRef.current) {
            containerRef.current.scrollIntoView({
                block: "center",
                behavior: "smooth"
            });
        }
    };
    var onPasteHandler = function(e) {
        e.preventDefault();
        var pasteContent = e.clipboardData.getData("Text");
        if (pasteContent.length <= 6 && /^\d+$/.test(pasteContent)) {
            var filler = Array(6 - pasteContent.length).fill("");
            updateTicket(ticket.id, (0,_to_consumable_array/* default */.Z)(pasteContent.split("")).concat((0,_to_consumable_array/* default */.Z)(filler)));
        }
    };
    var onFocusHandler = function() {
        scrollInputIntoView();
        setFocused(true);
    };
    var onBlurHandler = function() {
        setFocused(false);
    };
    var onChangeHandler = function(event, digitId) {
        var currentKey = parseInt(event.key, 10);
        if ([
            "e",
            "E",
            ".",
            ",",
            "-",
            "Unidentified"
        ].includes(event.key)) {
            event.preventDefault();
            return;
        }
        // Handling numeric inputs
        if (currentKey >= 0 && currentKey <= 9) {
            event.preventDefault();
            var newNumbers = (0,_to_consumable_array/* default */.Z)(ticket.numbers);
            newNumbers[digitId] = "".concat(currentKey);
            updateTicket(ticket.id, newNumbers);
            var nextDigitId = digitId + 1;
            // if we're not on the last digit - auto-tab
            var nextInput = digitRefs[nextDigitId];
            if (nextDigitId !== 6 && nextInput.current) {
                nextInput.current.focus();
            }
        }
        if (event.key === "Backspace") {
            event.preventDefault();
            // If some number is there - delete the number
            if (ticket.numbers[digitId]) {
                var newNumbers1 = (0,_to_consumable_array/* default */.Z)(ticket.numbers);
                newNumbers1[digitId] = "";
                updateTicket(ticket.id, newNumbers1);
            } else {
                // if the cell is empty and user presses backspace - remove previous
                var prevDigitId = digitId - 1;
                var nextInput1 = digitRefs[prevDigitId];
                // prevent focusing on non-existent input
                if (prevDigitId !== -1 && nextInput1.current) {
                    nextInput1.current.focus();
                    var newNumbers2 = (0,_to_consumable_array/* default */.Z)(ticket.numbers);
                    newNumbers2[prevDigitId] = "";
                    updateTicket(ticket.id, newNumbers2);
                }
            }
        }
        if (event.key === "Delete") {
            event.preventDefault();
            if (ticket.numbers[digitId]) {
                var newNumbers3 = (0,_to_consumable_array/* default */.Z)(ticket.numbers);
                newNumbers3[digitId] = "";
                updateTicket(ticket.id, newNumbers3);
            } else {
                // if the cell is empty and user presses delete - remove next
                var nextDigitId1 = digitId + 1;
                var nextInput2 = digitRefs[nextDigitId1];
                // prevent focusing on non-existent input
                if (nextDigitId1 !== 6 && nextInput2.current) {
                    nextInput2.current.focus();
                    var newNumbers4 = (0,_to_consumable_array/* default */.Z)(ticket.numbers);
                    newNumbers4[nextDigitId1] = "";
                    updateTicket(ticket.id, newNumbers4);
                }
            }
        }
        if (event.key === "ArrowLeft") {
            event.preventDefault();
            var prevDigitId1 = digitId - 1;
            var nextInput3 = digitRefs[prevDigitId1];
            // prevent focusing on non-existent input
            if (prevDigitId1 !== -1 && nextInput3.current) {
                nextInput3.current.focus();
            }
        }
        if (event.key === "ArrowRight") {
            event.preventDefault();
            var nextDigitId2 = digitId + 1;
            var nextInput4 = digitRefs[nextDigitId2];
            // prevent focusing on non-existent input
            if (nextDigitId2 !== 6 && nextInput4.current) {
                nextInput4.current.focus();
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        mb: "10px",
                        fontSize: "12px",
                        color: "textSubtle",
                        children: getIdLabel(ticket.id)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontSize: "12px",
                        color: "warning",
                        children: duplicateWith.length !== 0 && t("Duplicate")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputsContainer, {
                ref: containerRef,
                onClick: scrollInputIntoView,
                focused: focused,
                isDuplicate: duplicateWith.length !== 0,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DigitInput, {
                        ref: digit1,
                        type: "number",
                        value: ticket.numbers[0],
                        onKeyDown: function(e) {
                            return onChangeHandler(e, 0);
                        },
                        placeholder: "_",
                        onChange: function(e) {
                            return e.preventDefault();
                        },
                        disabled: disabled,
                        onFocus: onFocusHandler,
                        onBlur: onBlurHandler,
                        onPaste: onPasteHandler,
                        inputMode: "numeric"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DigitInput, {
                        ref: digit2,
                        type: "number",
                        value: ticket.numbers[1],
                        onKeyDown: function(e) {
                            return onChangeHandler(e, 1);
                        },
                        placeholder: "_",
                        onChange: function(e) {
                            return e.preventDefault();
                        },
                        disabled: disabled,
                        onFocus: onFocusHandler,
                        onBlur: onBlurHandler,
                        onPaste: onPasteHandler,
                        inputMode: "numeric"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DigitInput, {
                        ref: digit3,
                        type: "number",
                        value: ticket.numbers[2],
                        onKeyDown: function(e) {
                            return onChangeHandler(e, 2);
                        },
                        placeholder: "_",
                        onChange: function(e) {
                            return e.preventDefault();
                        },
                        disabled: disabled,
                        onFocus: onFocusHandler,
                        onBlur: onBlurHandler,
                        onPaste: onPasteHandler,
                        inputMode: "numeric"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DigitInput, {
                        ref: digit4,
                        type: "number",
                        value: ticket.numbers[3],
                        onKeyDown: function(e) {
                            return onChangeHandler(e, 3);
                        },
                        placeholder: "_",
                        onChange: function(e) {
                            return e.preventDefault();
                        },
                        disabled: disabled,
                        onFocus: onFocusHandler,
                        onBlur: onBlurHandler,
                        onPaste: onPasteHandler,
                        inputMode: "numeric"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DigitInput, {
                        ref: digit5,
                        type: "number",
                        value: ticket.numbers[4],
                        onKeyDown: function(e) {
                            return onChangeHandler(e, 4);
                        },
                        placeholder: "_",
                        onChange: function(e) {
                            return e.preventDefault();
                        },
                        disabled: disabled,
                        onFocus: onFocusHandler,
                        onBlur: onBlurHandler,
                        onPaste: onPasteHandler,
                        inputMode: "numeric"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DigitInput, {
                        ref: digit6,
                        type: "number",
                        value: ticket.numbers[5],
                        onKeyDown: function(e) {
                            return onChangeHandler(e, 5);
                        },
                        placeholder: "_",
                        onChange: function(e) {
                            return e.preventDefault();
                        },
                        disabled: disabled,
                        onFocus: onFocusHandler,
                        onBlur: onBlurHandler,
                        onPaste: onPasteHandler,
                        inputMode: "numeric"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var TicketInput = (TicketContainer);

;// CONCATENATED MODULE: ./src/views/Lottery/components/BuyTicketsModal/EditNumbersModal.tsx

function EditNumbersModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & div:first-child {\n    & div:first-child {\n      padding: 0;\n    }\n  }\n  & div:nth-child(2) {\n    padding: 0;\n  }\n\n  ",
        " {\n    width: 280px;\n  }\n"
    ]);
    EditNumbersModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function EditNumbersModal_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 310px;\n  overflow-y: scroll;\n  border-bottom: ",
        ";\n  padding: 24px;\n"
    ]);
    EditNumbersModal_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var EditNumbersModal_StyledModal = (0,styled_components_browser_esm/* default */.ZP)(Modal/* default */.Z).withConfig({
    componentId: "sc-b5ff57ed-0"
})(EditNumbersModal_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var ScrollableContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b5ff57ed-1"
})(EditNumbersModal_templateObject1(), function(param) {
    var theme = param.theme;
    return "1px solid ".concat(theme.colors.cardBorder);
});
var EditNumbersModal = function(param) {
    var totalCost = param.totalCost, updateTicket = param.updateTicket, randomize = param.randomize, tickets = param.tickets, allComplete = param.allComplete, onConfirm = param.onConfirm, isConfirming = param.isConfirming, onDismiss = param.onDismiss;
    var theme = (0,useTheme/* default */.ZP)().theme;
    var t = (0,src/* useTranslation */.$G)().t;
    var handleOnConfirm = (0,react.useCallback)(function() {
        return onConfirm();
    }, [
        onConfirm
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(EditNumbersModal_StyledModal, {
        title: t("Edit numbers"),
        onDismiss: onDismiss,
        headerBackground: theme.colors.gradientCardHeader,
        onBack: onDismiss,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ScrollableContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                        justifyContent: "space-between",
                        mb: "16px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                fontSize: "18px",
                                color: "text",
                                children: [
                                    t("Total cost"),
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                fontSize: "18px",
                                children: [
                                    "~",
                                    totalCost,
                                    " ETH"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontSize: "12px",
                        color: "textSubtle",
                        mb: "16px",
                        children: t("Numbers are randomized, with no duplicates among your tickets. Tap a number to edit it. Available digits: 0-9")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        disabled: isConfirming,
                        mb: "16px",
                        variant: "secondary",
                        width: "100%",
                        height: "44px",
                        onClick: randomize,
                        children: t("Randomize")
                    }),
                    tickets.map(function(ticket) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketInput, {
                            ticket: ticket,
                            duplicateWith: ticket.duplicateWith,
                            updateTicket: updateTicket,
                            disabled: isConfirming
                        }, ticket.id);
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                flexDirection: "column",
                justifyContent: "center",
                m: "24px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        id: "lotteryBuyEdited",
                        disabled: !allComplete || isConfirming,
                        endIcon: isConfirming ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                            spin: true,
                            color: "currentColor"
                        }) : undefined,
                        onClick: handleOnConfirm,
                        children: isConfirming ? t("Confirming") : t("Confirm and buy")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        style: {
                            border: "none"
                        },
                        mt: "10px",
                        variant: "secondary",
                        disabled: isConfirming,
                        onClick: onDismiss,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            fontSize: "18px",
                            children: t("Go back")
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var BuyTicketsModal_EditNumbersModal = (EditNumbersModal);

;// CONCATENATED MODULE: ./src/views/Lottery/components/BuyTicketsModal/NumTicketsToBuyButton.tsx

function NumTicketsToBuyButton_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-grow: 1;\n  background: transparent;\n  border: 1px solid ",
        ";\n  height: 32px;\n  padding: 10px 14px;\n  justify-content: center;\n  align-items: center; \n  border-radius: 100px; \n  font-family: Syncopate;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 100%;\n  letter-spacing: -0.42px;\n  text-transform: uppercase; \n"
    ]);
    NumTicketsToBuyButton_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-de5564f4-0"
})(NumTicketsToBuyButton_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
});
var NumTicketsToBuyButton = function(param) {
    var children = param.children, onClick = param.onClick, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
        disabled: disabled,
        scale: "xs",
        mx: "2px",
        p: "4px 16px",
        variant: "tertiary",
        onClick: onClick,
        children: children
    });
};
/* harmony default export */ var BuyTicketsModal_NumTicketsToBuyButton = (NumTicketsToBuyButton);

;// CONCATENATED MODULE: ./src/views/Lottery/components/BuyTicketsModal/generateTicketNumbers.tsx


/**
 * Generate a specific number of unique, randomised 7-digit lottery numbers between 1000000 & 1999999
 */ var generateTicketNumbers = function(numberOfTickets, userCurrentTickets) {
    var minNumber = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1000000, maxNumber = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1999999;
    // Populate array with existing tickets (if they have them) to ensure no duplicates when generating new numbers
    var existingTicketNumbers = (userCurrentTickets === null || userCurrentTickets === void 0 ? void 0 : userCurrentTickets.length) > 0 ? userCurrentTickets.map(function(ticket) {
        return parseInt(ticket === null || ticket === void 0 ? void 0 : ticket.number);
    }) : [];
    var generatedTicketNumbers = (0,_to_consumable_array/* default */.Z)(existingTicketNumbers);
    for(var count = 0; count < numberOfTickets; count++){
        var randomNumber = random_default()(minNumber, maxNumber);
        while(generatedTicketNumbers.includes(randomNumber)){
            // Catch for duplicates - generate a new number until the array doesn't include the random number generated
            randomNumber = random_default()(minNumber, maxNumber);
        }
        generatedTicketNumbers.push(randomNumber);
    }
    // Filter out the users' existing tickets
    var ticketsToBuy = (userCurrentTickets === null || userCurrentTickets === void 0 ? void 0 : userCurrentTickets.length) > 0 ? generatedTicketNumbers.filter(function(ticketNumber) {
        return !existingTicketNumbers.includes(ticketNumber);
    }) : generatedTicketNumbers;
    return ticketsToBuy;
};
/* harmony default export */ var BuyTicketsModal_generateTicketNumbers = (generateTicketNumbers);

;// CONCATENATED MODULE: ./src/views/Lottery/components/BuyTicketsModal/useTicketsReducer.tsx






var getInitialState = function(param) {
    var amount = param.amount, userCurrentTickets = param.userCurrentTickets;
    var randomTickets = BuyTicketsModal_generateTicketNumbers(amount, userCurrentTickets);
    var randomTicketsAsStringArray = randomTickets.map(function(ticket) {
        return parseRetrievedNumber(ticket.toString()).split("");
    });
    var tickets = Array.from({
        length: amount
    }, function(_, i) {
        return i + 1;
    }).map(function(index) {
        return {
            id: index,
            numbers: randomTicketsAsStringArray[index - 1],
            duplicateWith: [],
            isComplete: true
        };
    });
    return {
        tickets: tickets,
        allComplete: true
    };
};
var reducer = function(state, action) {
    switch(action.type){
        case "updateTicket":
            {
                var tickets = (0,_to_consumable_array/* default */.Z)(state.tickets);
                var _payload = action.payload, ticketId = _payload.ticketId, newNumbers = _payload.newNumbers;
                var newDuplicates = state.tickets.filter(function(ticket) {
                    return ticket.id !== ticketId && ticket.isComplete && ticket.numbers.join("") === newNumbers.join("");
                });
                // If ticket was duplicate but not duplicate anymore with this update
                // go through previously considered duplicates and remove id of this ticket
                // from their duplicateWith array
                var prevDuplicates = tickets[ticketId - 1].duplicateWith;
                prevDuplicates.forEach(function(prevTicketId) {
                    if (!newDuplicates.map(function(param) {
                        var id = param.id;
                        return id;
                    }).includes(prevTicketId)) {
                        var dupsToUpdate = (0,_to_consumable_array/* default */.Z)(tickets[prevTicketId - 1].duplicateWith);
                        var indexToRemove = dupsToUpdate.findIndex(function(id) {
                            return id === ticketId;
                        });
                        dupsToUpdate.splice(indexToRemove, 1);
                        tickets[prevTicketId - 1] = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, tickets[prevTicketId - 1]), {
                            duplicateWith: dupsToUpdate
                        });
                    }
                });
                // If found duplicates - update their duplicateWith array
                if (newDuplicates.length !== 0) {
                    newDuplicates.forEach(function(duplicate) {
                        tickets[duplicate.id - 1] = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, duplicate), {
                            duplicateWith: (0,_to_consumable_array/* default */.Z)(duplicate.duplicateWith).concat([
                                ticketId
                            ])
                        });
                    });
                }
                var updatedTicket = {
                    id: ticketId,
                    numbers: newNumbers,
                    duplicateWith: newDuplicates.map(function(ticket) {
                        return ticket.id;
                    }),
                    isComplete: newNumbers.join("").length === 6
                };
                tickets[ticketId - 1] = updatedTicket;
                // Check if all tickets are filled
                var allComplete = tickets.every(function(ticket) {
                    return ticket.isComplete;
                });
                return {
                    tickets: tickets,
                    allComplete: allComplete
                };
            }
        case "reset":
            return getInitialState({
                amount: action.payload.amount,
                userCurrentTickets: action.payload.userCurrentTickets
            });
        default:
            throw new Error();
    }
};
var useTicketsReducer = function(amount, userCurrentTickets) {
    var ref = (0,react.useReducer)(reducer, {
        amount: amount,
        userCurrentTickets: userCurrentTickets
    }, getInitialState), state = ref[0], dispatch = ref[1];
    (0,react.useEffect)(function() {
        dispatch({
            type: "reset",
            payload: {
                amount: amount,
                userCurrentTickets: userCurrentTickets
            }
        });
    }, [
        amount,
        userCurrentTickets
    ]);
    var updateTicket = function(ticketId, newNumbers) {
        dispatch({
            type: "updateTicket",
            payload: {
                ticketId: ticketId,
                newNumbers: newNumbers
            }
        });
    };
    var randomize = function() {
        dispatch({
            type: "reset",
            payload: {
                amount: amount,
                userCurrentTickets: userCurrentTickets
            }
        });
    };
    var getTicketsForPurchase = function() {
        return state.tickets.map(function(ticket) {
            var reversedTicket = (0,_to_consumable_array/* default */.Z)(ticket.numbers).map(function(num) {
                return parseInt(num, 10);
            }).reverse();
            reversedTicket.unshift(1);
            var ticketAsNumber = parseInt(reversedTicket.join(""), 10);
            return ticketAsNumber;
        });
    };
    return [
        updateTicket,
        randomize,
        state.tickets,
        state.allComplete,
        getTicketsForPurchase
    ];
};

// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Svg.tsx
var Svg_Svg = __webpack_require__(44976);
;// CONCATENATED MODULE: ./src/views/Lottery/svgs/Bogo.tsx




var BogoIcon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Svg_Svg/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        width: "62",
        height: "50",
        viewBox: "0 0 62 50",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                filter: "url(#filter0_i_4725_8270)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M33.0489 5.76862C32.8951 4.6748 33.6572 3.66347 34.751 3.50974L57.7466 0.277932C58.8404 0.124205 59.8517 0.886302 60.0054 1.98012L60.2509 3.72661C60.3278 4.27352 59.9352 4.76591 59.4339 4.99772C58.1079 5.61094 57.2802 7.03857 57.4941 8.56C57.7079 10.0814 58.897 11.2256 60.3406 11.4496C60.8864 11.5343 61.3995 11.8994 61.4764 12.4463L61.7218 14.193C61.8756 15.2868 61.1135 16.2982 60.0197 16.4519L37.0241 19.6837C35.9303 19.8374 34.919 19.0753 34.7653 17.9815L34.3807 15.2455C34.3807 15.2454 34.3808 15.2453 34.3809 15.2453C36.2419 14.9837 37.5385 13.2631 37.2769 11.4021C37.0154 9.54117 35.2948 8.24458 33.4338 8.50612C33.4337 8.50614 33.4336 8.50605 33.4336 8.50593L33.0489 5.76862Z",
                    fill: "#FFA666"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                filter: "url(#filter1_i_4725_8270)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                    cx: "32.7711",
                    cy: "21.7848",
                    rx: "9.07383",
                    ry: "9.07383",
                    fill: "#FF6666"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M31.8641 27.2294V22.6925H27.3271V20.8777H31.8641V16.3408H33.6788V20.8777H38.2157V22.6925H33.6788V27.2294H31.8641Z",
                fill: "#F6F3FF"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                filter: "url(#filter2_i_4725_8270)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M5.28051 21.9453C5.7372 20.3526 7.39854 19.4317 8.99121 19.8884L38.113 28.239C39.7056 28.6957 40.6265 30.357 40.1698 31.9497L39.246 35.1714C39.246 35.1714 39.246 35.1715 39.2459 35.1714C36.8373 34.4808 34.3249 35.8735 33.6342 38.2821C32.9436 40.6907 34.3362 43.2031 36.7448 43.8938C36.7449 43.8938 36.7449 43.8938 36.7449 43.8938L35.821 47.1157C35.3643 48.7084 33.703 49.6292 32.1103 49.1726L2.9886 40.822C1.39593 40.3653 0.475032 38.704 0.931723 37.1113L1.85514 33.891C1.85539 33.8901 1.85629 33.8896 1.85715 33.8899C4.26575 34.5805 6.7782 33.1879 7.46886 30.7792C8.15951 28.3706 6.76684 25.8582 4.35824 25.1675C4.35738 25.1673 4.35688 25.1664 4.35713 25.1655L5.28051 21.9453Z",
                    fill: "#FFA666"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                        id: "filter0_i_4725_8270",
                        x: "33.0293",
                        y: "0.257812",
                        width: "28.7119",
                        height: "19.4453",
                        filterUnits: "userSpaceOnUse",
                        "color-interpolation-filters": "sRGB",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                                "flood-opacity": "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                stdDeviation: "5"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 1 0 0 0 0 0.841667 0 0 0 0 0.9551 0 0 0 1 0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect1_innerShadow_4725_8270"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                        id: "filter1_i_4725_8270",
                        x: "23.6973",
                        y: "12.7109",
                        width: "18.1475",
                        height: "18.1475",
                        filterUnits: "userSpaceOnUse",
                        "color-interpolation-filters": "sRGB",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                                "flood-opacity": "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                stdDeviation: "5"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.0196078 0 0 0 0 0.00784314 0 0 0 0 0.0941176 0 0 0 1 0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect1_innerShadow_4725_8270"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                        id: "filter2_i_4725_8270",
                        x: "0.814453",
                        y: "19.7715",
                        width: "39.4727",
                        height: "29.5176",
                        filterUnits: "userSpaceOnUse",
                        "color-interpolation-filters": "sRGB",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                                "flood-opacity": "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                stdDeviation: "5"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 1 0 0 0 0 0.841667 0 0 0 0 0.9551 0 0 0 1 0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect1_innerShadow_4725_8270"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var Bogo = (BogoIcon);

;// CONCATENATED MODULE: ./src/views/Lottery/components/BuyTicketsModal/BuyTicketsModal.tsx




function BuyTicketsModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    width: 280px;\n  }\n  div {\n    overflow-x: hidden;\n  }\n"
    ]);
    BuyTicketsModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BuyTicketsModal_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  justify-content: space-between;\n  margin-top: 8px;\n  margin-bottom: 24px;\n  display: ",
        ";\n"
    ]);
    BuyTicketsModal_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function BuyTicketsModal_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 60px;\n  border: 1px solid rgba(255, 255, 255, 0.20); \n  justify-content: center;\n  align-items: center;\n  border-radius: 10px;\n  margin: 0px 20px;\n  text-align: center;\n  div {\n    padding: 0px;\n    border-bottom: none !important;\n    div {\n      div {\n        input {\n          font-size: 18px;\n          text-align: center;\n        }\n      }\n    }\n  }\n"
    ]);
    BuyTicketsModal_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: linear-gradient(180deg, rgba(23, 20, 39, 0.40) 0%, rgba(205, 99, 67, 0.40) 72.4%, rgba(228, 142, 80, 0.40) 100%); \n  border-bottom: 1px solid ",
        ";\n  height: 70px;\n  padding: 15px 20px;\n  justify-content: space-between;\n  align-items: center;\n  align-self: stretch; \n  width: calc(100% + 40px);\n  margin-left: -20px;\n  margin-top: -20px;\n  margin-bottom: 30px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

























var BuyTicketsModal_StyledModal = (0,styled_components_browser_esm/* default */.ZP)(Modal/* default */.Z).withConfig({
    componentId: "sc-b7248775-0"
})(BuyTicketsModal_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var ShortcutButtonsWrapper = (0,styled_components_browser_esm/* default */.ZP)(Box_Flex/* default */.Z).withConfig({
    componentId: "sc-b7248775-1"
})(BuyTicketsModal_templateObject1(), function(param) {
    var isVisible = param.isVisible;
    return isVisible ? "flex" : "none";
});
var StyledBalanceContainer = (0,styled_components_browser_esm/* default */.ZP)(Box_Flex/* default */.Z).withConfig({
    componentId: "sc-b7248775-2"
})(BuyTicketsModal_templateObject2());
var BogoContainer = (0,styled_components_browser_esm/* default */.ZP)(Box_Flex/* default */.Z).withConfig({
    componentId: "sc-b7248775-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
});
var BuyingStage;
(function(BuyingStage) {
    BuyingStage["BUY"] = "Buy";
    BuyingStage["EDIT"] = "Edit";
})(BuyingStage || (BuyingStage = {}));
var BuyTicketsModal = function(param) {
    var onDismiss = param.onDismiss;
    var account = (0,wagmi_src/* useWeb3React */.Ge)().account;
    var t = (0,src/* useTranslation */.$G)().t;
    var theme = (0,useTheme/* default */.ZP)().theme;
    var ref = useLottery(), maxNumberTicketsPerBuyOrClaim = ref.maxNumberTicketsPerBuyOrClaim, currentLotteryId = ref.currentLotteryId, _currentRound = ref.currentRound, priceTicketInEth = _currentRound.priceTicketInEth, discountDivisor = _currentRound.discountDivisor, isBogoOn = _currentRound.isBogoOn, _userTickets = _currentRound.userTickets, userCurrentTickets = _userTickets.tickets;
    var ethNotWeiPrice = priceTicketInEth ? priceTicketInEth.dividedBy(new bignumber/* default */.Z(10).pow(18)) : bigNumber/* BIG_ZERO */.HW;
    var callNoGasPrice = (0,useCallDefaultGasPrice/* useCallNoGasPrice */.s)().callNoGasPrice;
    var ref1 = (0,react.useState)("1"), ticketsToBuy = ref1[0], setTicketsToBuy = ref1[1];
    var ref2 = (0,react.useState)(isBogoOn ? "2" : "1"), actualTickets = ref2[0], setActualTickets = ref2[1];
    var ref3 = (0,react.useState)(""), discountValue = ref3[0], setDiscountValue = ref3[1];
    var ref4 = (0,react.useState)(""), totalCost = ref4[0], setTotalCost = ref4[1];
    var ref5 = (0,react.useState)(""), ticketCostBeforeDiscount = ref5[0], setTicketCostBeforeDiscount = ref5[1];
    var ref6 = (0,react.useState)(BuyingStage.BUY), buyingStage = ref6[0], setBuyingStage = ref6[1];
    var ref7 = (0,react.useState)(bigNumber/* BIG_ZERO */.HW), maxPossibleTicketPurchase = ref7[0], setMaxPossibleTicketPurchase = ref7[1];
    var ref8 = (0,react.useState)(false), maxTicketPurchaseExceeded = ref8[0], setMaxTicketPurchaseExceeded = ref8[1];
    var ref9 = (0,react.useState)(false), userNotEnoughCake = ref9[0], setUserNotEnoughCake = ref9[1];
    var lotteryContract = (0,useContract/* useNewLotteryV2Contract */.Du)();
    var toastSuccess = (0,useToast/* useToast */.p)().toastSuccess;
    var ref10 = (0,useTokenBalance/* useGetBnbBalance */.nu)(), balance = ref10.balance, fetchStatus = ref10.fetchStatus;
    // balance from useTokenBalance causes rerenders in effects as a new BigNumber is instantiated on each render, hence memoising it using the stringified value below.
    var stringifiedUserCake = balance.toJSON();
    var memoisedUserCake = (0,react.useMemo)(function() {
        return new bignumber/* default */.Z(stringifiedUserCake);
    }, [
        stringifiedUserCake
    ]);
    var ethPrice = (0,hooks/* useEthPriceBusd */.Tv)();
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var hasFetchedBalance = fetchStatus === types/* FetchStatus.Fetched */.iF.Fetched;
    var TooltipComponent = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    mb: "16px",
                    children: t("Buying multiple tickets in a single transaction gives a discount. The discount increases in a linear way, up to the maximum of 100 tickets:")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    children: t("2 tickets: 0.05%")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    children: t("50 tickets: 2.45%")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    children: t("100 tickets: 4.95%")
                })
            ]
        });
    };
    var ref11 = (0,useTooltip/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipComponent, {}), {
        placement: "bottom-end",
        tooltipOffset: [
            20,
            10
        ]
    }), targetRef = ref11.targetRef, tooltip = ref11.tooltip, tooltipVisible = ref11.tooltipVisible;
    var limitNumberByMaxTicketsPerBuy = (0,react.useCallback)(function(number) {
        return number.gt(maxNumberTicketsPerBuyOrClaim) ? maxNumberTicketsPerBuyOrClaim : number;
    }, [
        maxNumberTicketsPerBuyOrClaim
    ]);
    var getTicketCostAfterDiscount = (0,react.useCallback)(function(numberTickets) {
        var ticketsToPayFor = isBogoOn ? numberTickets.dividedBy(2) : numberTickets;
        var totalAfterDiscount = priceTicketInEth.times(ticketsToPayFor).times(discountDivisor.plus(1).minus(ticketsToPayFor)).div(discountDivisor);
        return totalAfterDiscount;
    }, [
        discountDivisor,
        priceTicketInEth,
        isBogoOn
    ]);
    var getMaxTicketBuyWithDiscount = (0,react.useCallback)(function(numberTickets) {
        var costAfterDiscount = getTicketCostAfterDiscount(numberTickets);
        var costBeforeDiscount = ethNotWeiPrice.times(numberTickets);
        var discountAmount = costBeforeDiscount.minus(costAfterDiscount);
        var ticketsBoughtWithDiscount = discountAmount.div(ethNotWeiPrice);
        var overallTicketBuy = numberTickets.plus(ticketsBoughtWithDiscount);
        return {
            overallTicketBuy: overallTicketBuy,
            ticketsBoughtWithDiscount: ticketsBoughtWithDiscount
        };
    }, [
        getTicketCostAfterDiscount,
        ethNotWeiPrice
    ]);
    var validateInput = (0,react.useCallback)(function(inputNumber) {
        var ticketsAfterBogo = isBogoOn ? inputNumber.times(2) : inputNumber;
        var limitedNumberTickets = limitNumberByMaxTicketsPerBuy(ticketsAfterBogo);
        var cakeCostAfterDiscount = getTicketCostAfterDiscount(limitedNumberTickets);
        if (cakeCostAfterDiscount.gt(new bignumber/* default */.Z(balance === null || balance === void 0 ? void 0 : balance.toString()))) {
            setUserNotEnoughCake(true);
        } else if ((isBogoOn ? inputNumber.times(2) : inputNumber).isGreaterThan(maxNumberTicketsPerBuyOrClaim)) {
            setMaxTicketPurchaseExceeded(true);
        } else {
            setUserNotEnoughCake(false);
            setMaxTicketPurchaseExceeded(false);
        }
    }, [
        limitNumberByMaxTicketsPerBuy,
        getTicketCostAfterDiscount,
        maxNumberTicketsPerBuyOrClaim,
        balance
    ]);
    (0,react.useEffect)(function() {
        var getMaxPossiblePurchase = function() {
            var maxBalancePurchase = memoisedUserCake.div(ethNotWeiPrice);
            var limitedMaxPurchase = limitNumberByMaxTicketsPerBuy(maxBalancePurchase);
            var maxPurchase;
            // If the users' max ETH balance purchase is less than the contract limit - factor the discount logic into the max number of tickets they can purchase
            if (limitedMaxPurchase.lt(maxNumberTicketsPerBuyOrClaim)) {
                // Get max tickets purchasable with the users' balance, as well as using the discount to buy tickets
                var ref = getMaxTicketBuyWithDiscount(limitedMaxPurchase), maxPlusDiscountTickets = ref.overallTicketBuy;
                // Knowing how many tickets they can buy when counting the discount - plug that total in, and see how much that total will get discounted
                var ref1 = getMaxTicketBuyWithDiscount(maxPlusDiscountTickets), secondTicketDiscountBuy = ref1.ticketsBoughtWithDiscount;
                // Add the additional tickets that can be bought with the discount, to the original max purchase
                maxPurchase = limitedMaxPurchase.plus(secondTicketDiscountBuy);
            } else {
                maxPurchase = limitedMaxPurchase;
            }
            setMaxPossibleTicketPurchase(maxPurchase);
        };
        getMaxPossiblePurchase();
    }, [
        maxNumberTicketsPerBuyOrClaim,
        ethNotWeiPrice,
        memoisedUserCake,
        limitNumberByMaxTicketsPerBuy,
        getTicketCostAfterDiscount,
        getMaxTicketBuyWithDiscount,
        hasFetchedBalance, 
    ]);
    (0,react.useEffect)(function() {
        var numberOfTicketsToBuy = new bignumber/* default */.Z(ticketsToBuy);
        var costAfterDiscount = getTicketCostAfterDiscount(numberOfTicketsToBuy);
        var costBeforeDiscount = priceTicketInEth.times(numberOfTicketsToBuy);
        var discountBeingApplied = costBeforeDiscount.minus(costAfterDiscount);
        setTicketCostBeforeDiscount(costBeforeDiscount.gt(0) ? (0,formatBalance/* getFullDisplayBalance */.NJ)(costBeforeDiscount) : "0");
        setTotalCost(costBeforeDiscount.gt(0) ? (0,formatBalance/* getFullDisplayBalance */.NJ)(costBeforeDiscount) : "0");
        setDiscountValue(discountBeingApplied.gt(0) ? (0,formatBalance/* getFullDisplayBalance */.NJ)(discountBeingApplied, 18, 5) : "0");
    }, [
        ticketsToBuy,
        ethNotWeiPrice,
        discountDivisor,
        getTicketCostAfterDiscount,
        priceTicketInEth,
        isBogoOn
    ]);
    var getNumTicketsByPercentage = function(percentage) {
        var percentageOfMaxTickets = maxPossibleTicketPurchase.gt(0) ? maxPossibleTicketPurchase.div(new bignumber/* default */.Z(isBogoOn ? 50 : 100)).times(new bignumber/* default */.Z(percentage)) : bigNumber/* BIG_ZERO */.HW;
        return Math.floor(percentageOfMaxTickets.toNumber());
    };
    var handleInputChange = function(input) {
        var inputAsInt = parseInt(input, 10);
        var inputAsBN = new bignumber/* default */.Z(inputAsInt);
        var limitedNumberTickets = limitNumberByMaxTicketsPerBuy(inputAsBN);
        validateInput(inputAsBN);
        setTicketsToBuy(inputAsInt ? limitedNumberTickets.toString() : "");
        var actualTicketCount = isBogoOn ? inputAsInt * 2 : inputAsInt;
        setActualTickets(actualTicketCount.toString());
    };
    var handleNumberButtonClick = function(number) {
        var finalTicketCount = isBogoOn ? number * 2 : number;
        setTicketsToBuy(finalTicketCount.toFixed());
        setUserNotEnoughCake(false);
        setMaxTicketPurchaseExceeded(false);
    };
    var ref12 = (0,_sliced_to_array/* default */.Z)(useTicketsReducer(parseInt(actualTickets, 10), userCurrentTickets), 5), updateTicket = ref12[0], randomize = ref12[1], tickets = ref12[2], allComplete = ref12[3], getTicketsForPurchase = ref12[4];
    var onConfirm = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ticketsForPurchase, ticketsToPayFor, txReceipt, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        ticketsForPurchase = getTicketsForPurchase();
                        ticketsToPayFor = isBogoOn ? ticketsForPurchase.length / 2 : ticketsForPurchase.length;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            callNoGasPrice(lotteryContract, "buyTickets", [
                                currentLotteryId,
                                ticketsForPurchase
                            ], {
                                value: priceTicketInEth.times(ticketsToPayFor).plus(1).toString()
                            })
                        ];
                    case 2:
                        txReceipt = _state.sent();
                        return [
                            4,
                            txReceipt.wait()
                        ];
                    case 3:
                        _state.sent();
                        if (txReceipt) {
                            onSuccess({
                                receipt: txReceipt
                            });
                        } else {
                            console.error("Transaction failed:", txReceipt);
                        }
                        return [
                            3,
                            5
                        ];
                    case 4:
                        error = _state.sent();
                        console.error("Error while buying tickets:", error);
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function onConfirm() {
            return _ref.apply(this, arguments);
        };
    }();
    var onSuccess = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var receipt;
            return (0,tslib_es6.__generator)(this, function(_state) {
                receipt = param.receipt;
                onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
                dispatch((0,lottery/* fetchUserTicketsAndLotteries */.w5)({
                    account: account,
                    currentLotteryId: currentLotteryId
                }));
                toastSuccess(t("Lottery tickets purchased!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                    txHash: receipt.transactionHash
                }));
                return [
                    2
                ];
            });
        });
        return function onSuccess(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var getErrorMessage = function() {
        if (userNotEnoughCake) return t("Insufficient ETH balance");
        return t("The maximum number of tickets you can buy in one transaction is %maxTickets%", {
            maxTickets: maxNumberTicketsPerBuyOrClaim.toString()
        });
    };
    var percentageDiscount = function() {
        var percentageAsBn = new bignumber/* default */.Z(discountValue).div(new bignumber/* default */.Z(ticketCostBeforeDiscount)).times(100);
        if (percentageAsBn.isNaN() || percentageAsBn.eq(0)) {
            return 0;
        }
        return percentageAsBn.toNumber().toFixed(2);
    };
    var disableBuying = userNotEnoughCake || !ticketsToBuy || maxTicketPurchaseExceeded || new bignumber/* default */.Z(ticketsToBuy).lte(0) || getTicketsForPurchase().length !== parseInt(actualTickets, 10);
    if (buyingStage === BuyingStage.EDIT) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(BuyTicketsModal_EditNumbersModal, {
            totalCost: totalCost,
            updateTicket: updateTicket,
            randomize: randomize,
            tickets: tickets,
            allComplete: allComplete,
            onConfirm: onConfirm,
            isConfirming: false,
            onDismiss: function() {
                return setBuyingStage(BuyingStage.BUY);
            }
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BuyTicketsModal_StyledModal, {
        title: t("Buy Tickets"),
        onDismiss: onDismiss,
        headerBackground: theme.colors.gradientCardHeader,
        children: [
            tooltipVisible && tooltip,
            isBogoOn && /*#__PURE__*/ (0,jsx_runtime.jsxs)(BogoContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                        flexDirection: "column",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: "red",
                                fontSize: "14px",
                                fontWeight: 500,
                                children: "THIS WEEK ONLY"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: "text",
                                fontSize: "18px",
                                children: "Buy 1 ticket, get one free"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Bogo, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                alignItems: "center",
                mb: "15px",
                mx: "auto",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        disabled: parseInt(actualTickets) === 0,
                        onClick: function() {
                            return handleInputChange((parseFloat(ticketsToBuy) - 1).toString());
                        },
                        variant: "tertiary",
                        scale: "sm",
                        style: {
                            borderRadius: "100px",
                            height: "44px",
                            width: "44px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Minus/* default */.Z, {
                            width: "24px",
                            color: "text"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBalanceContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BalanceInput/* default */.Z, {
                            isWarning: account && (userNotEnoughCake || maxTicketPurchaseExceeded),
                            placeholder: "0",
                            value: ticketsToBuy,
                            onUserInput: handleInputChange
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        disabled: actualTickets === "100",
                        onClick: function() {
                            return handleInputChange((ticketsToBuy === "" ? 1 : parseInt(ticketsToBuy) + 1).toString());
                        },
                        variant: "tertiary",
                        scale: "sm",
                        style: {
                            borderRadius: "100px",
                            height: "44px",
                            width: "44px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Add/* default */.Z, {
                            width: "24px",
                            color: "text"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ShortcutButtonsWrapper, {
                isVisible: account && hasFetchedBalance,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BuyTicketsModal_NumTicketsToBuyButton, {
                        onClick: function() {
                            return handleInputChange("10");
                        },
                        children: hasFetchedBalance ? 10 : ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BuyTicketsModal_NumTicketsToBuyButton, {
                        onClick: function() {
                            return handleInputChange("25");
                        },
                        children: hasFetchedBalance ? 25 : ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BuyTicketsModal_NumTicketsToBuyButton, {
                        onClick: function() {
                            return handleInputChange("50");
                        },
                        children: hasFetchedBalance ? 50 : ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BuyTicketsModal_NumTicketsToBuyButton, {
                        onClick: function() {
                            return handleInputChange("50");
                        },
                        children: t("Max")
                    })
                ]
            }),
            isBogoOn && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                color: "success",
                fontSize: "12px",
                mt: "4px",
                children: [
                    "BOGO Offer Active: You will receive ",
                    parseFloat(ticketsToBuy) * 2,
                    " tickets for the price of ",
                    ticketsToBuy,
                    "."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Flex/* default */.Z, {
                borderTop: "1px solid ".concat(theme.colors.cardBorder),
                alignItems: "center",
                justifyContent: "center",
                py: "10px",
                width: "100%",
                mt: "30px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                    justifyContent: "space-between",
                    flexDirection: "column",
                    width: "100%",
                    children: [
                        account && (userNotEnoughCake || maxTicketPurchaseExceeded) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            fontSize: "12px",
                            color: "red",
                            children: getErrorMessage()
                        }),
                        account && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                            justifyContent: "space-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                    color: "textSubtle",
                                    fontSize: "14px",
                                    children: [
                                        t("Balance"),
                                        ":"
                                    ]
                                }),
                                hasFetchedBalance ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    fontSize: "14px",
                                    color: "text",
                                    children: parseFloat(balance.toString()) / 1e18
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                    width: 50,
                                    height: 12
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                borderTop: "1px solid ".concat(theme.colors.cardBorder),
                flexDirection: "column",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                        justifyContent: "space-between",
                        py: "10px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                color: "textSubtle",
                                fontSize: "14px",
                                children: [
                                    t("Cost"),
                                    " (ETH)"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                color: "text",
                                fontSize: "14px",
                                children: [
                                    priceTicketInEth && (0,formatBalance/* getFullDisplayBalance */.NJ)(priceTicketInEth.times(ticketsToBuy || 0)),
                                    " ETH"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                        borderTop: "1px solid ".concat(theme.colors.cardBorder),
                        pt: "8px",
                        mb: "24px",
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: "textSubtle",
                                fontSize: "18px",
                                children: t("You pay")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                fontSize: "18px",
                                children: [
                                    "~",
                                    totalCost === null || totalCost === void 0 ? void 0 : totalCost.slice(0, 12),
                                    " ETH"
                                ]
                            })
                        ]
                    }),
                    account ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ApproveConfirmButtons/* default */.Z, {
                                isConfirmDisabled: disableBuying,
                                isApproveDisabled: true,
                                onConfirm: onConfirm,
                                buttonArrangement: ApproveConfirmButtons/* ButtonArrangement.SEQUENTIAL */.N.SEQUENTIAL,
                                confirmLabel: t("Buy Instantly"),
                                confirmId: "lotteryBuyInstant"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                variant: "secondary",
                                mt: "8px",
                                disabled: disableBuying,
                                onClick: function() {
                                    setBuyingStage(BuyingStage.EDIT);
                                },
                                children: t("View/Edit Numbers")
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectWalletButton/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        mt: "24px",
                        fontSize: "12px",
                        color: "textSubtle",
                        children: t('"Buy Instantly" chooses random numbers, with no duplicates among your tickets. Prices are set before each round starts. Purchases are final.')
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var BuyTicketsModal_BuyTicketsModal = (BuyTicketsModal);

;// CONCATENATED MODULE: ./src/views/Lottery/components/BuyTicketsButton.tsx










var BuyTicketsButton = function(_param) {
    var disabled = _param.disabled, props = (0,_object_without_properties/* default */.Z)(_param, [
        "disabled"
    ]);
    var t = (0,src/* useTranslation */.$G)().t;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(BuyTicketsModal_BuyTicketsModal, {})), 1), onPresentBuyTicketsModal = ref[0];
    var ref1 = useLottery(), status = ref1.currentRound.status;
    var getBuyButtonText = function() {
        if (status === types/* LotteryStatus.OPEN */.p3.OPEN) {
            return t("Buy Tickets");
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: t("On sale soon!")
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        disabled: disabled,
        onClick: onPresentBuyTicketsModal,
        children: getBuyButtonText()
    }));
};
/* harmony default export */ var components_BuyTicketsButton = (BuyTicketsButton);

;// CONCATENATED MODULE: ./src/views/Lottery/components/ViewTicketsModal/CurrentRoundTicketsInner.tsx

function CurrentRoundTicketsInner_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-height: 300px;\n  overflow-y: scroll;\n  margin-left: -24px;\n  margin-right: -24px;\n  padding-left: 24px;\n  padding-right: 20px;\n"
    ]);
    CurrentRoundTicketsInner_templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var CurrentRoundTicketsInner_ScrollBox = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-a886fe5a-0"
})(CurrentRoundTicketsInner_templateObject());
var CurrentRoundTicketsInner = function() {
    var t = (0,src/* useTranslation */.$G)().t;
    var theme = (0,useTheme/* default */.ZP)().theme;
    var ref = useLottery(), isTransitioning = ref.isTransitioning, _currentRound = ref.currentRound, status = _currentRound.status, userTickets = _currentRound.userTickets;
    var ticketBuyIsDisabled = status !== types/* LotteryStatus.OPEN */.p3.OPEN || isTransitioning;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                flexDirection: "column",
                overflowX: "hidden",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "text",
                        fontSize: "18px",
                        mb: "16px",
                        mt: "10px",
                        children: t("Your tickets")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrentRoundTicketsInner_ScrollBox, {
                        children: userTickets.tickets.map(function(ticket, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TicketNumber, {
                                localId: index + 1,
                                id: ticket.id,
                                number: ticket.number,
                                status: ticket.status
                            }, ticket.id);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Flex/* default */.Z, {
                alignItems: "center",
                justifyContent: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BuyTicketsButton, {
                    disabled: ticketBuyIsDisabled,
                    mt: "24px",
                    width: "100%"
                })
            })
        ]
    });
};
/* harmony default export */ var ViewTicketsModal_CurrentRoundTicketsInner = (CurrentRoundTicketsInner);

;// CONCATENATED MODULE: ./src/views/Lottery/components/ViewTicketsModal/index.tsx

function ViewTicketsModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    width: 280px;\n  }\n"
    ]);
    ViewTicketsModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var ViewTicketsModal_StyledModal = (0,styled_components_browser_esm/* default */.ZP)(Modal/* default */.Z).withConfig({
    componentId: "sc-db328d78-0"
})(ViewTicketsModal_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var ViewTicketsModal = function(param) {
    var onDismiss = param.onDismiss, roundId = param.roundId, roundStatus = param.roundStatus;
    var t = (0,src/* useTranslation */.$G)().t;
    var theme = (0,useTheme/* default */.ZP)().theme;
    var currentLotteryId = useLottery().currentLotteryId;
    var isPreviousRound = (roundStatus === null || roundStatus === void 0 ? void 0 : roundStatus.toLowerCase()) === types/* LotteryStatus.CLAIMABLE */.p3.CLAIMABLE || roundId !== currentLotteryId;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewTicketsModal_StyledModal, {
        title: "".concat(t("Round"), " ").concat(roundId),
        onDismiss: onDismiss,
        headerBackground: theme.colors.gradientCardHeader,
        children: isPreviousRound ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewTicketsModal_PreviousRoundTicketsInner, {
            roundId: roundId
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewTicketsModal_CurrentRoundTicketsInner, {})
    });
};
/* harmony default export */ var components_ViewTicketsModal = (ViewTicketsModal);

;// CONCATENATED MODULE: ./src/views/Lottery/components/RewardBracketDetail.tsx







var RewardBracketDetail = function(param) {
    var rewardBracket = param.rewardBracket, cakeAmount = param.cakeAmount, albAmount = param.albAmount, numberWinners = param.numberWinners, isHistoricRound = param.isHistoricRound, isBurn = param.isBurn, isLoading = param.isLoading;
    var t = (0,src/* useTranslation */.$G)().t;
    var ethPrice = (0,hooks/* useEthPriceBusd */.Tv)();
    var cakePrice = (0,hooks/* usePriceCakeBusd */.Iu)();
    var getRewardText = function() {
        var numberMatch = rewardBracket + 1;
        if (isBurn) {
            return t("Burn");
        }
        if (rewardBracket === 5) {
            return t("Match all %numberMatch%", {
                numberMatch: numberMatch
            });
        }
        return t("Match first %numberMatch%", {
            numberMatch: numberMatch
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
        flexDirection: "column",
        mt: "20px",
        children: [
            isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                mb: "4px",
                mt: "8px",
                height: 16,
                width: 80
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: isBurn ? "failure" : "text",
                children: getRewardText()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    isLoading || cakeAmount.isNaN() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        my: "4px",
                        mr: "10px",
                        height: 20,
                        width: 110
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                                fontSize: "18px",
                                unit: " ETH",
                                value: (0,formatBalance/* getBalanceNumber */.mW)(cakeAmount),
                                decimals: 6
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                                fontSize: "18px",
                                unit: " ALB",
                                value: (0,formatBalance/* getBalanceNumber */.mW)(albAmount),
                                decimals: 0
                            })
                        ]
                    }),
                    isLoading || cakeAmount.isNaN() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                            mt: "4px",
                            mb: "16px",
                            height: 12,
                            width: 70
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                        fontSize: "12px",
                        color: "textSubtle",
                        prefix: "~$",
                        value: (0,formatBalance/* getBalanceNumber */.mW)(cakeAmount === null || cakeAmount === void 0 ? void 0 : cakeAmount.times(ethPrice).plus(albAmount === null || albAmount === void 0 ? void 0 : albAmount.times(new bignumber/* default */.Z(cakePrice === null || cakePrice === void 0 ? void 0 : cakePrice.toString())))),
                        decimals: 0
                    }),
                    isHistoricRound && cakeAmount && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            numberWinners !== "0" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                fontSize: "12px",
                                color: "textSubtle",
                                children: [
                                    (0,formatBalance/* getFullDisplayBalance */.NJ)(cakeAmount.div(parseInt(numberWinners, 10)), 18, 8),
                                    " ETH ",
                                    t("each")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                fontSize: "12px",
                                color: "textSubtle",
                                children: [
                                    numberWinners,
                                    " ",
                                    t("Winning Tickets")
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_RewardBracketDetail = (RewardBracketDetail);

;// CONCATENATED MODULE: ./src/views/Lottery/components/RewardBrackets.tsx

function RewardBrackets_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  height: 1px;\n  width: 100%;\n"
    ]);
    RewardBrackets_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function RewardBrackets_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  flex-direction: column;\n"
    ]);
    RewardBrackets_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function RewardBrackets_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: repeat(2, auto);\n  row-gap: 16px;\n\n  ",
        " {\n    grid-template-columns: repeat(4, 1fr);\n  }\n"
    ]);
    RewardBrackets_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}








var Divider = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8c39b6c1-0"
})(RewardBrackets_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.primary_disabled;
});
var Wrapper = (0,styled_components_browser_esm/* default */.ZP)(Box_Flex/* default */.Z).withConfig({
    componentId: "sc-8c39b6c1-1"
})(RewardBrackets_templateObject1());
var RewardsInner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8c39b6c1-2"
})(RewardBrackets_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var RewardBrackets = function(param) {
    var lotteryNodeData = param.lotteryNodeData, isHistoricRound = param.isHistoricRound;
    var t = (0,src/* useTranslation */.$G)().t;
    var ref = (0,react.useState)({
        isLoading: true,
        cakeToBurn: bigNumber/* BIG_ZERO */.HW,
        rewardsLessTreasuryFee: bigNumber/* BIG_ZERO */.HW,
        rewardsBreakdown: null,
        countWinnersPerBracket: null,
        albAmountPreAllocated: null,
        albPrizePercent: null
    }), state = ref[0], setState = ref[1];
    (0,react.useEffect)(function() {
        if (lotteryNodeData) {
            var treasuryFee = lotteryNodeData.treasuryFee, amountCollectedInEth = lotteryNodeData.amountCollectedInEth, rewardsBreakdown = lotteryNodeData.rewardsBreakdown, countWinnersPerBracket = lotteryNodeData.countWinnersPerBracket, albAmountPreAllocated = lotteryNodeData.albAmountPreAllocated, albPrizePercent = lotteryNodeData.albPrizePercent;
            var feeAsPercentage = new bignumber/* default */.Z(treasuryFee).div(100);
            var cakeToBurn = feeAsPercentage.div(100).times(new bignumber/* default */.Z(amountCollectedInEth));
            var amountLessTreasuryFee = new bignumber/* default */.Z(amountCollectedInEth).minus(cakeToBurn);
            setState({
                isLoading: false,
                cakeToBurn: cakeToBurn,
                rewardsLessTreasuryFee: amountLessTreasuryFee,
                rewardsBreakdown: rewardsBreakdown,
                countWinnersPerBracket: countWinnersPerBracket,
                albAmountPreAllocated: albAmountPreAllocated,
                albPrizePercent: albPrizePercent
            });
        } else {
            setState({
                isLoading: true,
                cakeToBurn: bigNumber/* BIG_ZERO */.HW,
                rewardsLessTreasuryFee: bigNumber/* BIG_ZERO */.HW,
                rewardsBreakdown: null,
                countWinnersPerBracket: null,
                albAmountPreAllocated: null,
                albPrizePercent: null
            });
        }
    }, [
        lotteryNodeData
    ]);
    var getCakeRewards = function(bracket) {
        var shareAsPercentage = new bignumber/* default */.Z(state.rewardsBreakdown[bracket]).div(100);
        return state.rewardsLessTreasuryFee.div(100).times(shareAsPercentage).div(1000).times(state.albPrizePercent);
    };
    var getAlbRewards = function(bracket) {
        var shareAsPercentage = new bignumber/* default */.Z(state.rewardsBreakdown[bracket]).div(100);
        return new bignumber/* default */.Z(state.albAmountPreAllocated).times(shareAsPercentage).div(10).times(state.albPrizePercent).div(10000);
    };
    var isLoading = state.isLoading, countWinnersPerBracket = state.countWinnersPerBracket, cakeToBurn = state.cakeToBurn;
    var rewardBrackets = [
        0,
        1,
        2,
        3,
        4,
        5
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {
                style: {
                    marginTop: "20px"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                fontSize: "14px",
                my: "20px",
                children: [
                    t("Match the winning number in the same order to share prizes."),
                    " ",
                    !isHistoricRound && t("Current prizes up for grabs:")
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RewardsInner, {
                children: rewardBrackets.map(function(bracketIndex) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_RewardBracketDetail, {
                        rewardBracket: bracketIndex,
                        cakeAmount: !isLoading && getCakeRewards(bracketIndex),
                        albAmount: !isLoading && getAlbRewards(bracketIndex),
                        numberWinners: !isLoading && countWinnersPerBracket[bracketIndex],
                        isHistoricRound: isHistoricRound,
                        isLoading: isLoading
                    }, bracketIndex);
                })
            })
        ]
    });
};
/* harmony default export */ var components_RewardBrackets = (RewardBrackets);

;// CONCATENATED MODULE: ./src/views/Lottery/hooks/useNextEventCountdown.ts




var useNextEventCountdown = function(nextEventTime) {
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var ref = (0,react.useState)(null), secondsRemaining = ref[0], setSecondsRemaining = ref[1];
    var timer = (0,react.useRef)(null);
    var currentLotteryId = useLottery().currentLotteryId;
    (0,react.useEffect)(function() {
        dispatch((0,lottery/* setLotteryIsTransitioning */.og)({
            isTransitioning: false
        }));
        var currentSeconds = Math.floor(Date.now() / 1000);
        var secondsRemainingCalc = nextEventTime - currentSeconds;
        setSecondsRemaining(secondsRemainingCalc);
        timer.current = setInterval(function() {
            setSecondsRemaining(function(prevSecondsRemaining) {
                // Clear current interval at end of countdown and fetch current lottery to get updated state
                if (prevSecondsRemaining <= 1) {
                    clearInterval(timer.current);
                    dispatch((0,lottery/* setLotteryIsTransitioning */.og)({
                        isTransitioning: true
                    }));
                    dispatch((0,lottery/* fetchCurrentLottery */.PU)({
                        currentLotteryId: currentLotteryId
                    }));
                }
                return prevSecondsRemaining - 1;
            });
        }, 1000);
        return function() {
            return clearInterval(timer.current);
        };
    }, [
        setSecondsRemaining,
        nextEventTime,
        currentLotteryId,
        timer,
        dispatch
    ]);
    return secondsRemaining;
};
/* harmony default export */ var hooks_useNextEventCountdown = (useNextEventCountdown);

// EXTERNAL MODULE: ./src/utils/getTimePeriods.ts
var getTimePeriods = __webpack_require__(13471);
// EXTERNAL MODULE: ./src/state/wallet/hooks.ts
var wallet_hooks = __webpack_require__(5460);
;// CONCATENATED MODULE: ./src/views/Lottery/components/NextDrawCard.tsx


function NextDrawCard_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: auto;\n\n  ",
        " {\n    grid-column-gap: 32px;\n    grid-template-columns: auto 1fr;\n  }\n"
    ]);
    NextDrawCard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function NextDrawCard_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  border: 1px solid rgba(255, 255, 255, 0.10); background: rgba(255, 255, 255, 0.01);\n  box-shadow: 0px 0px 0px 10px rgba(255, 255, 255, 0.03) inset;\n  border-radius: 38px;\n  padding: 8px;\n\n  ",
        " {\n    width: 520px;\n  }\n\n  ",
        " {\n    width: 680px;\n  }\n"
    ]);
    NextDrawCard_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function NextDrawCard_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  border-radius: 30px;\n  border: 1px solid ",
        ";\n  background: radial-gradient(70.71% 70.71% at 50% 50%, rgba(148, 101, 255, 0.04) 0%, rgba(148, 101, 255, 0.00) 100%), rgba(4, 1, 21, 0.10); \n  display: flex;\n  flex-direction: column;\n"
    ]);
    NextDrawCard_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function NextDrawCard_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 20px;\n"
    ]);
    NextDrawCard_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding: 0px 20px 20px 20px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 30px; \n  border-radius: 30px;\n  border: 1px solid rgba(243, 238, 255, 0.08);\n  background: linear-gradient(180deg, rgba(243, 238, 255, 0.00) 0%, rgba(243, 238, 255, 0.04) 100%), rgba(147, 130, 255, 0.01);\n  box-shadow: 0px 0px 12px 0px rgba(255, 255, 255, 0.08) inset; \n  position: relative;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  display: flex;\n  top: 0;\n  left: 50%;\n  font-size: 14px;\n  transform: translateX(-50%);\n  padding: 7px 8px;\n  border-radius: 0px 0px 12px 12px;\n  border: 1px solid rgba(255, 102, 102, 0.15);\n  background: linear-gradient(180deg, rgba(255, 102, 102, 0.65) 0%, rgba(255, 102, 102, 0.36) 100%), rgba(147, 130, 255, 0.01);\n  box-shadow: 0px 0px 7px 0px ",
        " inset;\n  width: max-content;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}



















var Grid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-93db22d7-0"
})(NextDrawCard_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var StyledCard = (0,styled_components_browser_esm/* default */.ZP)(Card/* default */.Z).withConfig({
    componentId: "sc-93db22d7-1"
})(NextDrawCard_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var StyledCardInner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-93db22d7-2"
})(NextDrawCard_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
});
var NextDrawWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-93db22d7-3"
})(NextDrawCard_templateObject3());
var StyledBogoContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-93db22d7-4"
})(_templateObject4());
var BogoHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-93db22d7-5"
})(_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.colors.red;
});
var NextDrawCard = function() {
    var ref;
    var ref1 = (0,src/* useTranslation */.$G)(), t = ref1.t, locale = ref1.currentLanguage.locale;
    var account = (0,wagmi_src/* useWeb3React */.Ge)().account;
    var ref2 = useLottery(), currentLotteryId = ref2.currentLotteryId, isTransitioning = ref2.isTransitioning, currentRound = ref2.currentRound;
    var endTime = currentRound.endTime, amountCollectedInEth = currentRound.amountCollectedInEth, userTickets = currentRound.userTickets, status = currentRound.status, albAmountPreAllocated = currentRound.albAmountPreAllocated;
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_ViewTicketsModal, {
        roundId: currentLotteryId,
        roundStatus: status
    })), 1), onPresentViewTicketsModal = ref3[0];
    var ref4 = (0,react.useState)(false), isExpanded = ref4[0], setIsExpanded = ref4[1];
    var ticketBuyIsDisabled = status !== types/* LotteryStatus.OPEN */.p3.OPEN || isTransitioning;
    var secondsRemaining = hooks_useNextEventCountdown(parseInt(currentRound === null || currentRound === void 0 ? void 0 : currentRound.endTime));
    var ref5 = (0,getTimePeriods/* default */.Z)(secondsRemaining), days = ref5.days, hours = ref5.hours, minutes = ref5.minutes;
    var ethPrice = (0,hooks/* useEthPriceBusd */.Tv)({
        forceMainnet: true
    });
    var cakePrice = (0,hooks/* usePriceCakeBusd */.Iu)();
    var prizeInBusd = amountCollectedInEth.times(ethPrice).plus(new bignumber/* default */.Z(albAmountPreAllocated).times(new bignumber/* default */.Z(cakePrice === null || cakePrice === void 0 ? void 0 : cakePrice.toString())));
    var endTimeMs = parseInt(endTime, 10) * 1000;
    var endDate = new Date(endTimeMs);
    var isLotteryOpen = status === types/* LotteryStatus.OPEN */.p3.OPEN;
    var userTicketCount = (userTickets === null || userTickets === void 0 ? void 0 : (ref = userTickets.tickets) === null || ref === void 0 ? void 0 : ref.length) || 0;
    var getPrizeBalances = function() {
        if (status === types/* LotteryStatus.CLOSE */.p3.CLOSE || status === types/* LotteryStatus.CLAIMABLE */.p3.CLAIMABLE) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Heading/* default */.Z, {
                scale: "xl",
                color: "text",
                textAlign: [
                    "center",
                    null,
                    null,
                    "left"
                ],
                children: [
                    t("Calculating"),
                    "..."
                ]
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                prizeInBusd.isNaN() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                    my: "7px",
                    height: 40,
                    width: 160
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                    fontSize: "32px",
                    color: "success",
                    textAlign: "center",
                    lineHeight: "1",
                    bold: true,
                    fontFamily: "Syncopate, sans-serif",
                    prefix: "~$",
                    value: (0,formatBalance/* getBalanceNumber */.mW)(prizeInBusd),
                    decimals: 0,
                    mb: "20px"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                    style: {
                        gap: "5px"
                    },
                    children: [
                        prizeInBusd.isNaN() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                            my: "2px",
                            height: 14,
                            width: 90
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                            justifyContent: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                                    fontSize: "18px",
                                    color: "text",
                                    textAlign: "center",
                                    value: (0,formatBalance/* getBalanceNumber */.mW)(amountCollectedInEth),
                                    decimals: 4
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    ml: "5px",
                                    children: "ETH"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            textAlign: "center",
                            children: "+"
                        }),
                        prizeInBusd.isNaN() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                            my: "2px",
                            height: 14,
                            width: 90
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                            justifyContent: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                                    fontSize: "19px",
                                    color: "text",
                                    textAlign: "center",
                                    value: (0,formatBalance/* getBalanceNumber */.mW)(new bignumber/* default */.Z(albAmountPreAllocated)),
                                    decimals: 0
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    ml: "5px",
                                    children: "ALB"
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    var getNextDrawId = function() {
        if (status === types/* LotteryStatus.OPEN */.p3.OPEN) {
            return "".concat(currentLotteryId, " |");
        }
        if (status === types/* LotteryStatus.PENDING */.p3.PENDING) {
            return "";
        }
        return parseInt(currentLotteryId, 10) + 1;
    };
    var getNextDrawDateTime = function() {
        if (status === types/* LotteryStatus.OPEN */.p3.OPEN) {
            return "".concat(t("Extraction in"), " ").concat(days, "d ").concat(hours, "h ").concat(minutes, "m");
        }
        return "";
    };
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    var width = (0,wallet_hooks/* useWindowDimensions */.dz)().width;
    var ticketRoundText = userTicketCount > 1 ? t("You have %amount% tickets this round", {
        amount: userTicketCount
    }) : t("You have %amount% ticket this round", {
        amount: userTicketCount
    });
    var ref6 = (0,_sliced_to_array/* default */.Z)(ticketRoundText.split(userTicketCount.toString()), 2), youHaveText = ref6[0], ticketsThisRoundText = ref6[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCard, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCardInner, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHeader/* default */.Z, {
                    p: "20px",
                    style: {
                        borderBottom: "1px solid ".concat(theme.colors.cardBorder)
                    },
                    mb: "60px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                mr: "12px",
                                children: t("Next Draw")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                children: [
                                    currentLotteryId && "#".concat(getNextDrawId()),
                                    " ",
                                    Boolean(endTime) && getNextDrawDateTime()
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CardBody/* default */.Z, {
                    p: "0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Flex/* default */.Z, {
                                justifyContent: [
                                    "center",
                                    null,
                                    null,
                                    "flex-start"
                                ],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    mb: "20px",
                                    color: "textSubtle",
                                    children: t("Prize pot")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Flex/* default */.Z, {
                                flexDirection: "column",
                                mb: "20px",
                                justifyContent: "center",
                                children: getPrizeBalances()
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBogoContainer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BogoHeader, {
                                        children: "THIS WEEK ONLY"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Bogo, {
                                        mt: "60px"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        mb: "-30px",
                                        children: "Buy one ticket"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        children: "get one free"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BuyTicketsButton, {
                                        disabled: ticketBuyIsDisabled,
                                        maxWidth: "280px"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Flex/* default */.Z, {
                                width: "100%",
                                alignItems: "center",
                                mb: !isLotteryOpen && "60px",
                                children: isLotteryOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                                    alignItems: "center",
                                    width: "100%",
                                    justifyContent: !userTickets.isLoading && userTicketCount > 0 ? "space-between" : "center",
                                    borderTop: "1px solid ".concat(theme.colors.cardBorder),
                                    borderBottom: "1px solid ".concat(theme.colors.cardBorder),
                                    p: "20px",
                                    mt: "60px",
                                    children: [
                                        account && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                                            justifyContent: "center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                    fontSize: width >= 500 ? "18px" : "14px",
                                                    color: "textSubtle",
                                                    display: "inline",
                                                    children: [
                                                        youHaveText,
                                                        " "
                                                    ]
                                                }),
                                                !userTickets.isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                                                    fontSize: width >= 500 ? "18px" : "14px",
                                                    value: userTicketCount,
                                                    decimals: 0,
                                                    display: "inline",
                                                    mx: "4px"
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                    mx: "4px",
                                                    height: 20,
                                                    width: 40
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                    fontSize: width >= 500 ? "18px" : "14px",
                                                    color: "textSubtle",
                                                    display: "inline",
                                                    children: [
                                                        " ",
                                                        ticketsThisRoundText
                                                    ]
                                                })
                                            ]
                                        }),
                                        !userTickets.isLoading && userTicketCount > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            onClick: onPresentViewTicketsModal,
                                            height: "44px",
                                            width: "fit-content",
                                            p: "0",
                                            variant: "text",
                                            scale: "sm",
                                            style: {
                                                border: "1px solid ".concat(theme.colors.cardBorder),
                                                padding: "0px 20px",
                                                fontSize: "".concat(width >= 500 ? "18px" : "14px"),
                                                color: "".concat(theme.colors.text)
                                            },
                                            children: t("View your tickets")
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardFooter/* default */.Z, {
                    p: "0",
                    children: [
                        isExpanded && /*#__PURE__*/ (0,jsx_runtime.jsx)(NextDrawWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_RewardBrackets, {
                                lotteryNodeData: currentRound
                            })
                        }),
                        (status === types/* LotteryStatus.OPEN */.p3.OPEN || status === types/* LotteryStatus.CLOSE */.p3.CLOSE) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Flex/* default */.Z, {
                            alignItems: "center",
                            justifyContent: "center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandableButton/* ExpandableLabel */.L, {
                                expanded: isExpanded,
                                onClick: function() {
                                    return setIsExpanded(!isExpanded);
                                },
                                children: isExpanded ? t("Hide") : t("Details")
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var components_NextDrawCard = (NextDrawCard);

// EXTERNAL MODULE: ./packages/uikit/src/components/ButtonMenu/ButtonMenu.tsx
var ButtonMenu = __webpack_require__(12587);
// EXTERNAL MODULE: ./packages/uikit/src/components/ButtonMenu/ButtonMenuItem.tsx
var ButtonMenuItem = __webpack_require__(51983);
;// CONCATENATED MODULE: ./src/views/Lottery/components/HistoryTabMenu.tsx

function HistoryTabMenu_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: transparent;\n  border: none;\n  button {\n    background: none;\n  }\n"
    ]);
    HistoryTabMenu_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function HistoryTabMenu_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-top-left-radius: ",
        ";\n  border-bottom-left-radius: ",
        ";\n  border-top-right-radius: ",
        ";\n  border-bottom-right-radius: ",
        ";\n  border: 1px solid ",
        ";\n  letter-spacing: 0;\n"
    ]);
    HistoryTabMenu_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var CustomCard = (0,styled_components_browser_esm/* default */.ZP)(ButtonMenu/* default */.Z).withConfig({
    componentId: "sc-70d1b520-0"
})(HistoryTabMenu_templateObject());
var CustomButtonMenuItem = (0,styled_components_browser_esm/* default */.ZP)(ButtonMenuItem/* default */.Z).withConfig({
    componentId: "sc-70d1b520-1"
})(HistoryTabMenu_templateObject1(), function(param) {
    var side = param.side;
    return side === "left" ? "10px" : "0px";
}, function(param) {
    var side = param.side;
    return side === "left" ? "10px" : "0px";
}, function(param) {
    var side = param.side;
    return side === "right" ? "10px" : "0px";
}, function(param) {
    var side = param.side;
    return side === "right" ? "10px" : "0px";
}, function(param) {
    var theme = param.theme, isActive = param.isActive;
    return isActive ? theme.colors.alienPurple : theme.colors.cardBorder;
});
var HistoryTabMenu = function(param) {
    var setActiveIndex = param.setActiveIndex, activeIndex = param.activeIndex;
    var t = (0,src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomCard, {
        activeIndex: activeIndex,
        onItemClick: setActiveIndex,
        scale: "sm",
        variant: "subtle",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomButtonMenuItem, {
                side: "left",
                children: t("All history")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomButtonMenuItem, {
                side: "right",
                children: t("Your history")
            })
        ]
    });
};
/* harmony default export */ var components_HistoryTabMenu = (HistoryTabMenu);

// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ArrowBack.tsx
var ArrowBack = __webpack_require__(87844);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/SmallDot.tsx
var SmallDot = __webpack_require__(54548);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ChevronRight.tsx
var ChevronRight = __webpack_require__(37303);
;// CONCATENATED MODULE: ./src/views/Lottery/components/YourHistoryCard/FinishedRoundRow.tsx

function FinishedRoundRow_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: repeat(3, 1fr) auto;\n  margin-bottom: 8px;\n  cursor: pointer;\n"
    ]);
    FinishedRoundRow_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function FinishedRoundRow_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  path {\n    fill: ",
        ";\n  }\n"
    ]);
    FinishedRoundRow_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function FinishedRoundRow_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  ",
        " {\n    font-size: 18px;\n  }\n"
    ]);
    FinishedRoundRow_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





var FinishedRoundRow_Grid = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-c9312246-0"
})(FinishedRoundRow_templateObject());
var StyledSmallDotIcon = (0,styled_components_browser_esm/* default */.ZP)(SmallDot/* default */.Z).withConfig({
    componentId: "sc-c9312246-1"
})(FinishedRoundRow_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.textDisabled;
});
var ResponsiveText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-c9312246-2"
})(FinishedRoundRow_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
});
var FinishedRoundRow = function(param) {
    var roundId = param.roundId, numberTickets = param.numberTickets, endTime = param.endTime, onClick = param.onClick, _hasWon = param.hasWon, hasWon = _hasWon === void 0 ? false : _hasWon;
    var ref = (0,src/* useTranslation */.$G)(), locale = ref.currentLanguage.locale;
    var endTimeInMs = parseInt(endTime, 10) * 1000;
    var endTimeAsDate = new Date(endTimeInMs);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FinishedRoundRow_Grid, {
        onClick: function() {
            return onClick(roundId);
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Flex/* default */.Z, {
                alignItems: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveText, {
                    color: "text",
                    children: roundId
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                alignItems: [
                    "flex-start",
                    null,
                    "center"
                ],
                justifyContent: [
                    "center",
                    null,
                    "flex-start"
                ],
                flexDirection: [
                    "column",
                    null,
                    "row"
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveText, {
                        mr: [
                            "0",
                            null,
                            "6px"
                        ],
                        children: endTimeAsDate.toLocaleDateString(locale, dateOptions)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveText, {
                        color: "text",
                        children: endTimeAsDate.toLocaleTimeString(undefined, timeOptions)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Flex/* default */.Z, {
                alignItems: "center",
                justifyContent: "space-between",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveText, {
                    children: numberTickets
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Flex/* default */.Z, {
                alignItems: "center",
                justifyContent: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRight/* default */.Z, {
                    color: "text"
                })
            })
        ]
    });
};
/* harmony default export */ var YourHistoryCard_FinishedRoundRow = (FinishedRoundRow);

;// CONCATENATED MODULE: ./src/views/Lottery/components/YourHistoryCard/FinishedRoundTable.tsx

function FinishedRoundTable_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: repeat(3, 1fr) auto;\n"
    ]);
    FinishedRoundTable_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var FinishedRoundTable_Grid = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-71e144ca-0"
})(FinishedRoundTable_templateObject());
var FinishedRoundTable = function(param) {
    var handleShowMoreClick = param.handleShowMoreClick, numUserRoundsRequested = param.numUserRoundsRequested, handleHistoryRowClick = param.handleHistoryRowClick;
    var ref;
    var t = (0,src/* useTranslation */.$G)().t;
    var userLotteryData = useGetUserLotteriesGraphData();
    var filteredForClaimable = userLotteryData === null || userLotteryData === void 0 ? void 0 : userLotteryData.rounds.filter(function(round) {
        return round.status.toLowerCase() === types/* LotteryStatus.CLAIMABLE */.p3.CLAIMABLE;
    });
    var sortedByRoundId = filteredForClaimable === null || filteredForClaimable === void 0 ? void 0 : filteredForClaimable.sort(function(roundA, roundB) {
        return parseInt(roundB.lotteryId, 10) - parseInt(roundA.lotteryId, 10);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FinishedRoundTable_Grid, {
                px: "24px",
                pt: "24px",
                mb: "8px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontSize: "14px",
                        color: "textSubtle",
                        children: "#"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontSize: "14px",
                        color: "textSubtle",
                        children: t("Date")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontSize: "14px",
                        color: "textSubtle",
                        children: t("Your Tickets")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        width: "20px"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                px: "24px",
                pb: "24px",
                flexDirection: "column",
                overflowY: "scroll",
                height: "240px",
                children: [
                    userLotteryData && sortedByRoundId.map(function(finishedRound) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(YourHistoryCard_FinishedRoundRow, {
                            roundId: finishedRound.lotteryId,
                            hasWon: finishedRound.claimed,
                            numberTickets: finishedRound.totalTickets,
                            endTime: finishedRound.endTime,
                            onClick: handleHistoryRowClick
                        }, finishedRound.lotteryId);
                    }),
                    (userLotteryData === null || userLotteryData === void 0 ? void 0 : (ref = userLotteryData.rounds) === null || ref === void 0 ? void 0 : ref.length) === numUserRoundsRequested && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Flex/* default */.Z, {
                        justifyContent: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            mt: "12px",
                            variant: "text",
                            width: "fit-content",
                            onClick: handleShowMoreClick,
                            children: t("Show More")
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var YourHistoryCard_FinishedRoundTable = (FinishedRoundTable);

// EXTERNAL MODULE: ./packages/uikit/src/components/Card/CardRibbon.tsx
var CardRibbon = __webpack_require__(95857);
// EXTERNAL MODULE: ./packages/uikit/src/contexts/MatchBreakpoints/useMatchBreakpoints.ts
var useMatchBreakpoints = __webpack_require__(34701);
;// CONCATENATED MODULE: ./src/views/Lottery/components/PreviousRoundCard/Body.tsx


function Body_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  padding: 0;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    Body_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Body_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: auto;\n\n  ",
        " {\n    grid-column-gap: 72px;\n    grid-row-gap: 36px;\n    grid-template-columns: auto 1fr;\n  }\n"
    ]);
    Body_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Body_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  right: -20px;\n  top: -20px;\n\n  ",
        " {\n    right: -10px;\n    top: -10px;\n  }\n"
    ]);
    Body_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}









var StyledCardBody = (0,styled_components_browser_esm/* default */.ZP)(CardBody/* default */.Z).withConfig({
    componentId: "sc-a149a7e2-0"
})(Body_templateObject());
var Body_Grid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a149a7e2-1"
})(Body_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var StyledCardRibbon = (0,styled_components_browser_esm/* default */.ZP)(CardRibbon/* default */.Z).withConfig({
    componentId: "sc-a149a7e2-2"
})(Body_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.xs;
});
var PreviousRoundCardBody = function(param) {
    var lotteryNodeData = param.lotteryNodeData, lotteryId = param.lotteryId;
    var t = (0,src/* useTranslation */.$G)().t;
    var ref = useLottery(), currentLotteryId = ref.currentLotteryId, status = ref.currentRound.status;
    var userLotteryData = useGetUserLotteriesGraphData();
    var isNew = parseInt(lottery/* LATEST_LOTTERY_NEW_CONTRACT */.hi) < parseInt(lotteryId);
    var userDataForRound = userLotteryData.rounds.find(function(userLotteryRound) {
        return userLotteryRound.lotteryId === (!isNew ? (parseInt(lotteryId) + 2).toString() : lotteryId);
    });
    var ref1 = (0,useMatchBreakpoints/* default */.Z)(), isLg = ref1.isLg, isXl = ref1.isXl, isXxl = ref1.isXxl;
    var isLargerScreen = isLg || isXl || isXxl;
    var currentLotteryIdAsInt = parseInt(currentLotteryId);
    var mostRecentFinishedRoundId = status === types/* LotteryStatus.CLAIMABLE */.p3.CLAIMABLE ? currentLotteryIdAsInt : currentLotteryIdAsInt - 1;
    var isLatestRound = mostRecentFinishedRoundId.toString() === lotteryId;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_ViewTicketsModal, {
        roundId: lotteryId,
        roundStatus: lotteryNodeData === null || lotteryNodeData === void 0 ? void 0 : lotteryNodeData.status
    })), 1), onPresentViewTicketsModal = ref2[0];
    var totalTicketNumber = userDataForRound ? userDataForRound.totalTickets : 0;
    var ticketRoundText = totalTicketNumber > 1 ? t("You had %amount% tickets this round", {
        amount: totalTicketNumber
    }) : t("You had %amount% ticket this round", {
        amount: totalTicketNumber
    });
    var ref3 = (0,_sliced_to_array/* default */.Z)(ticketRoundText.split(totalTicketNumber.toString()), 2), youHadText = ref3[0], ticketsThisRoundText = ref3[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCardBody, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
            flexDirection: "column",
            width: "100%",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                    flexDirection: "column",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Flex/* default */.Z, {
                            justifyContent: "center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                mb: "30px",
                                mt: "60px",
                                fontSize: "18px",
                                children: t("Winning numbers")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Flex/* default */.Z, {
                            mb: "60px",
                            justifyContent: "center",
                            children: lotteryId ? (lotteryNodeData === null || lotteryNodeData === void 0 ? void 0 : lotteryNodeData.finalNumber) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_WinningNumbers, {
                                rotateText: isLargerScreen || false,
                                number: lotteryNodeData === null || lotteryNodeData === void 0 ? void 0 : lotteryNodeData.finalNumber.toString(),
                                size: isLargerScreen ? "60" : "40",
                                fontSize: isLargerScreen ? "32" : "20"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                width: [
                                    "240px",
                                    null,
                                    null,
                                    "450px"
                                ],
                                height: [
                                    "34px",
                                    null,
                                    null,
                                    "71px"
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Flex/* default */.Z, {
                                    flexDirection: "column",
                                    alignItems: "center",
                                    width: [
                                        "240px",
                                        null,
                                        null,
                                        "480px"
                                    ],
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        mb: "8px",
                                        children: t("Please specify Round")
                                    })
                                })
                            })
                        })
                    ]
                }),
                userDataForRound && isNew && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                        p: "20px",
                        style: {
                            borderTop: "1px solid rgba(255,255,255,0.07)"
                        },
                        width: "100%",
                        alignItems: "center",
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                py: "20px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                        display: "inline",
                                        children: [
                                            youHadText,
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        display: "inline",
                                        bold: true,
                                        children: userDataForRound.totalTickets
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        display: "inline",
                                        children: ticketsThisRoundText
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                onClick: onPresentViewTicketsModal,
                                height: "auto",
                                width: "fit-content",
                                p: "0",
                                variant: "secondary",
                                scale: "sm",
                                style: {
                                    padding: "15px 20px 16px 20px",
                                    fontSize: "18px",
                                    height: "44px"
                                },
                                children: t("View your tickets")
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Body = (PreviousRoundCardBody);

;// CONCATENATED MODULE: ./src/views/Lottery/components/PreviousRoundCard/FooterExpanded.tsx



function FooterExpanded_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 20px;\n  flex-direction: column;\n"
    ]);
    FooterExpanded_templateObject = function _templateObject() {
        return data;
    };
    return data;
}












var FooterExpanded_NextDrawWrapper = (0,styled_components_browser_esm/* default */.ZP)(Box_Flex/* default */.Z).withConfig({
    componentId: "sc-fa4d0228-0"
})(FooterExpanded_templateObject());
var PreviousRoundCardFooter = function(param) {
    var lotteryNodeData = param.lotteryNodeData, lotteryId = param.lotteryId;
    var t = (0,src/* useTranslation */.$G)().t;
    var ref = (0,react.useState)(), fetchedLotteryGraphData = ref[0], setFetchedLotteryGraphData = ref[1];
    var lotteryGraphDataFromState = useGetLotteryGraphDataById(lotteryId);
    var ethPrice = (0,hooks/* useEthPriceBusd */.Tv)();
    var cakePrice = (0,hooks/* usePriceCakeBusd */.Iu)();
    (0,react.useEffect)(function() {
        var getGraphData = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var fetchedGraphData;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0,getLotteriesData/* getGraphLotteries */.GP)(undefined, undefined, {
                                    id_in: [
                                        lotteryId
                                    ]
                                }, false)
                            ];
                        case 1:
                            fetchedGraphData = _state.sent();
                            setFetchedLotteryGraphData(fetchedGraphData[0]);
                            return [
                                2
                            ];
                    }
                });
            });
            return function getGraphData() {
                return _ref.apply(this, arguments);
            };
        }();
        if (!lotteryGraphDataFromState) {
            getGraphData();
        }
    }, [
        lotteryGraphDataFromState,
        lotteryId
    ]);
    var prizeInBusd = new bignumber/* default */.Z(NaN);
    if (lotteryNodeData) {
        var amountCollectedInEth = lotteryNodeData.amountCollectedInEth, albAmountPreAllocated = lotteryNodeData.albAmountPreAllocated;
        prizeInBusd = amountCollectedInEth.times(ethPrice).plus(new bignumber/* default */.Z(albAmountPreAllocated).times(new bignumber/* default */.Z(cakePrice === null || cakePrice === void 0 ? void 0 : cakePrice.toString())));
    }
    var getTotalUsers = function() {
        if (!lotteryGraphDataFromState && fetchedLotteryGraphData) {
            var ref;
            return fetchedLotteryGraphData === null || fetchedLotteryGraphData === void 0 ? void 0 : (ref = fetchedLotteryGraphData.totalUsers) === null || ref === void 0 ? void 0 : ref.toLocaleString();
        }
        if (lotteryGraphDataFromState) {
            var ref1;
            return lotteryGraphDataFromState === null || lotteryGraphDataFromState === void 0 ? void 0 : (ref1 = lotteryGraphDataFromState.totalUsers) === null || ref1 === void 0 ? void 0 : ref1.toLocaleString();
        }
        return null;
    };
    var getPrizeBalances = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                prizeInBusd.isNaN() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                    my: "7px",
                    height: 40,
                    width: 200
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Heading/* default */.Z, {
                    lineHeight: "1",
                    color: "text",
                    style: {
                        fontSize: "18px"
                    },
                    textAlign: "center",
                    children: [
                        "~$",
                        (0,formatBalance/* formatNumber */.uf)((0,formatBalance/* getBalanceNumber */.mW)(prizeInBusd), 0, 0)
                    ]
                }),
                prizeInBusd.isNaN() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                    my: "2px",
                    height: 14,
                    width: 90
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                            mt: "10px",
                            textAlign: "center",
                            fontSize: "14px",
                            color: "textSubtle",
                            unit: " ETH",
                            value: (0,formatBalance/* getBalanceNumber */.mW)(lotteryNodeData === null || lotteryNodeData === void 0 ? void 0 : lotteryNodeData.amountCollectedInEth),
                            decimals: 6
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                            mt: "10px",
                            textAlign: "center",
                            fontSize: "14px",
                            color: "textSubtle",
                            unit: " ALB",
                            value: (0,formatBalance/* getBalanceNumber */.mW)(new bignumber/* default */.Z(lotteryNodeData === null || lotteryNodeData === void 0 ? void 0 : lotteryNodeData.albAmountPreAllocated)),
                            decimals: 0
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterExpanded_NextDrawWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                mr: "24px",
                flexDirection: "row",
                justifyContent: "space-around",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: "18px",
                                mb: "15px",
                                children: t("Prize pot")
                            }),
                            getPrizeBalances()
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        mb: "24px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Flex/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                mb: "15px",
                                fontSize: "18px",
                                display: "inline",
                                children: [
                                    t("Total players this round"),
                                    ":",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    lotteryNodeData && (lotteryGraphDataFromState || fetchedLotteryGraphData) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        textAlign: "center",
                                        fontSize: "18px",
                                        fontWeight: 700,
                                        className: "syncopate",
                                        children: parseInt(getTotalUsers()) + 8 || 12
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                        height: 14,
                                        width: 31
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_RewardBrackets, {
                lotteryNodeData: lotteryNodeData,
                isHistoricRound: true
            })
        ]
    });
};
/* harmony default export */ var FooterExpanded = (PreviousRoundCardFooter);

;// CONCATENATED MODULE: ./src/views/Lottery/components/PreviousRoundCard/Footer.tsx

function Footer_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  button {\n    padding: 0px;\n    height: auto;\n  }\n"
    ]);
    Footer_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var CustomFlex = (0,styled_components_browser_esm/* default */.ZP)(Box_Flex/* default */.Z).withConfig({
    componentId: "sc-c8df55b4-0"
})(Footer_templateObject());
var Footer_PreviousRoundCardFooter = function(param) {
    var lotteryNodeData = param.lotteryNodeData, lotteryId = param.lotteryId;
    var ref = (0,react.useState)(false), isExpanded = ref[0], setIsExpanded = ref[1];
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    (0,react.useEffect)(function() {
        if (!lotteryId) {
            setIsExpanded(false);
        }
    }, [
        lotteryId
    ]);
    var ref1 = (0,src/* useTranslation */.$G)(), t = ref1.t, locale = ref1.currentLanguage.locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardFooter/* default */.Z, {
        p: "0",
        style: {
            borderTop: "1px solid ".concat(theme.colors.cardBorder)
        },
        children: [
            isExpanded && /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterExpanded, {
                lotteryNodeData: lotteryNodeData,
                lotteryId: lotteryId
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                p: "20px",
                alignItems: "center",
                justifyContent: lotteryNodeData ? "space-between" : "center",
                children: [
                    lotteryNodeData && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        fontSize: "14px",
                        children: [
                            t("Drawn"),
                            " ",
                            getDrawnDate(locale, lotteryNodeData.endTime)
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomFlex, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandableButton/* ExpandableLabel */.L, {
                            expanded: isExpanded,
                            onClick: function() {
                                if (lotteryId) {
                                    setIsExpanded(!isExpanded);
                                }
                            },
                            children: isExpanded ? t("Hide") : t("Show details")
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Footer = (Footer_PreviousRoundCardFooter);

;// CONCATENATED MODULE: ./src/views/Lottery/components/YourHistoryCard/index.tsx



function YourHistoryCard_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n\n  ",
        " {\n    width: 680px;\n  }\n"
    ]);
    YourHistoryCard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function YourHistoryCard_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 240px;\n"
    ]);
    YourHistoryCard_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
















var YourHistoryCard_StyledCard = (0,styled_components_browser_esm/* default */.ZP)(Card/* default */.Z).withConfig({
    componentId: "sc-9baa0a9b-0"
})(YourHistoryCard_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var YourHistoryCard_StyledCardBody = (0,styled_components_browser_esm/* default */.ZP)(CardBody/* default */.Z).withConfig({
    componentId: "sc-9baa0a9b-1"
})(YourHistoryCard_templateObject1());
var YourHistoryCard = function(param) {
    var handleShowMoreClick = param.handleShowMoreClick, numUserRoundsRequested = param.numUserRoundsRequested;
    var ref = (0,src/* useTranslation */.$G)(), t = ref.t, locale = ref.currentLanguage.locale;
    var account = (0,wagmi_src/* useWeb3React */.Ge)().account;
    var ref1 = (0,react.useState)(false), shouldShowRoundDetail = ref1[0], setShouldShowRoundDetail = ref1[1];
    var ref2 = (0,react.useState)(null), selectedLotteryNodeData = ref2[0], setSelectedLotteryNodeData = ref2[1];
    var ref3 = (0,react.useState)(null), selectedLotteryId = ref3[0], setSelectedLotteryId = ref3[1];
    var ref4 = useLottery(), isTransitioning = ref4.isTransitioning, status = ref4.currentRound.status;
    var userLotteryData = useGetUserLotteriesGraphData();
    var ticketBuyIsDisabled = status !== types/* LotteryStatus.OPEN */.p3.OPEN || isTransitioning;
    var handleHistoryRowClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(lotteryId) {
            var isNew, lotteryData, processedLotteryData;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setShouldShowRoundDetail(true);
                        setSelectedLotteryId(lotteryId);
                        isNew = parseInt(lottery/* LATEST_LOTTERY_NEW_CONTRACT */.hi) < parseInt(lotteryId);
                        return [
                            4,
                            (0,helpers/* fetchLottery */.JE)(lotteryId, isNew)
                        ];
                    case 1:
                        lotteryData = _state.sent();
                        processedLotteryData = processLotteryResponse(lotteryData);
                        setSelectedLotteryNodeData(processedLotteryData);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleHistoryRowClick(lotteryId) {
            return _ref.apply(this, arguments);
        };
    }();
    var clearState = (0,react.useCallback)(function() {
        setShouldShowRoundDetail(false);
        setSelectedLotteryNodeData(null);
        setSelectedLotteryId(null);
    }, []);
    var getHeader = function() {
        if (shouldShowRoundDetail) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowBack/* default */.Z, {
                        cursor: "pointer",
                        onClick: clearState,
                        mr: "20px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                        flexDirection: "column",
                        alignItems: "flex-start",
                        justifyContent: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Heading/* default */.Z, {
                                scale: "md",
                                mb: "4px",
                                children: [
                                    t("Round"),
                                    " ",
                                    selectedLotteryId || ""
                                ]
                            }),
                            (selectedLotteryNodeData === null || selectedLotteryNodeData === void 0 ? void 0 : selectedLotteryNodeData.endTime) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                fontSize: "14px",
                                children: [
                                    t("Drawn"),
                                    " ",
                                    getDrawnDate(locale, selectedLotteryNodeData.endTime)
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                width: "185px",
                                height: "21px"
                            })
                        ]
                    })
                ]
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
            scale: "md",
            children: t("Rounds")
        });
    };
    var getBody = function() {
        if (shouldShowRoundDetail) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Body, {
                lotteryNodeData: selectedLotteryNodeData,
                lotteryId: selectedLotteryId
            });
        }
        var claimableRounds = userLotteryData === null || userLotteryData === void 0 ? void 0 : userLotteryData.rounds.filter(function(round) {
            return round.status.toLowerCase() === types/* LotteryStatus.CLAIMABLE */.p3.CLAIMABLE;
        });
        if (!account) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(YourHistoryCard_StyledCardBody, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        textAlign: "center",
                        color: "textSubtle",
                        mb: "16px",
                        children: t("Connect your wallet to check your history")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectWalletButton/* default */.Z, {})
                ]
            });
        }
        if (claimableRounds.length === 0) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(YourHistoryCard_StyledCardBody, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    maxWidth: "280px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Flex/* default */.Z, {
                            alignItems: "center",
                            justifyContent: "center",
                            mb: "16px",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                textAlign: "left",
                                children: t("No lottery history found")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            textAlign: "center",
                            color: "textSubtle",
                            mb: "16px",
                            children: t("Buy tickets for the next round!")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BuyTicketsButton, {
                            disabled: ticketBuyIsDisabled,
                            width: "100%"
                        })
                    ]
                })
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(YourHistoryCard_FinishedRoundTable, {
            handleHistoryRowClick: handleHistoryRowClick,
            handleShowMoreClick: handleShowMoreClick,
            numUserRoundsRequested: numUserRoundsRequested
        });
    };
    var getFooter = function() {
        if (selectedLotteryNodeData) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {
                lotteryNodeData: selectedLotteryNodeData,
                lotteryId: selectedLotteryId
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CardFooter/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Flex/* default */.Z, {
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center"
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(YourHistoryCard_StyledCard, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHeader/* default */.Z, {
                children: getHeader()
            }),
            getBody(),
            getFooter()
        ]
    });
};
/* harmony default export */ var components_YourHistoryCard = (YourHistoryCard);

// EXTERNAL MODULE: ./packages/uikit/src/components/Input/Input.tsx
var Input = __webpack_require__(32762);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/IconButton.tsx
var IconButton = __webpack_require__(89663);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ArrowForward.tsx
var ArrowForward = __webpack_require__(18029);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ArrowLast.tsx
var ArrowLast = __webpack_require__(61549);
;// CONCATENATED MODULE: ./src/views/Lottery/components/AllHistoryCard/RoundSwitcher.tsx

function RoundSwitcher_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 60px;\n  height: 100%;\n  margin-left: 5px;\n  padding: 0;\n  margin-right: 10px;\n  &:focus {\n    box-shadow: none !important;\n  }\n"
    ]);
    RoundSwitcher_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function RoundSwitcher_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 7px 8px;\n  align-items: center;\n  gap: 2px;\n  height: 24px;\n  border-radius: 100px;\n  border: 1px solid ",
        ";\n  background: linear-gradient(180deg, rgba(243, 238, 255, 0.00) 0%, rgba(243, 238, 255, 0.04) 100%), rgba(147, 130, 255, 0.01);\n  box-shadow: 0px 0px 12px 0px ",
        " inset;\n  color: ",
        ";\n  text-align: right;\n  leading-trim: both;\n  text-edge: cap;\n  font-family: DM Sans;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 100%;\n  text-transform: uppercase; \n"
    ]);
    RoundSwitcher_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function RoundSwitcher_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 32px;\n\n  :disabled {\n    background: none;\n\n    svg {\n      fill: ",
        ";\n\n      path {\n        fill: ",
        ";\n      }\n    }\n  }\n"
    ]);
    RoundSwitcher_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var StyledInput = (0,styled_components_browser_esm/* default */.ZP)(Input/* default */.Z).withConfig({
    componentId: "sc-19975b1-0"
})(RoundSwitcher_templateObject());
var CustomTag = (0,styled_components_browser_esm/* default */.ZP)(Box_Flex/* default */.Z).withConfig({
    componentId: "sc-19975b1-1"
})(RoundSwitcher_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
}, function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
}, function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
});
var StyledIconButton = (0,styled_components_browser_esm/* default */.ZP)(IconButton/* default */.Z).withConfig({
    componentId: "sc-19975b1-2"
})(RoundSwitcher_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
}, function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
});
var RoundSwitcher = function(param) {
    var isLoading = param.isLoading, selectedRoundId = param.selectedRoundId, mostRecentRound = param.mostRecentRound, handleInputChange = param.handleInputChange, handleArrowButtonPress = param.handleArrowButtonPress;
    var t = (0,src/* useTranslation */.$G)().t;
    var selectedRoundIdAsInt = parseInt(selectedRoundId, 10);
    var isLatestRound = selectedRoundIdAsInt === mostRecentRound;
    var handleOnChange = function(e) {
        if (e.currentTarget.validity.valid) {
            handleInputChange(e);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
        alignItems: "center",
        justifyContent: "space-between",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontSize: "18px",
                        children: t("Round #")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledInput, {
                        pattern: "^[0-9]+$",
                        inputMode: "numeric",
                        disabled: isLoading,
                        id: "round-id",
                        name: "round-id",
                        value: selectedRoundId,
                        scale: "lg",
                        onChange: handleOnChange,
                        style: {
                            border: "none"
                        }
                    }),
                    isLatestRound && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomTag, {
                        children: "Latest"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIconButton, {
                        disabled: !selectedRoundIdAsInt || selectedRoundIdAsInt <= 1,
                        onClick: function() {
                            return handleArrowButtonPress(selectedRoundIdAsInt - 1);
                        },
                        variant: "text",
                        scale: "sm",
                        mr: "4px",
                        style: {
                            border: "none"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowBack/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIconButton, {
                        disabled: selectedRoundIdAsInt >= mostRecentRound,
                        onClick: function() {
                            return handleArrowButtonPress(selectedRoundIdAsInt + 1);
                        },
                        variant: "text",
                        scale: "sm",
                        mr: "4px",
                        style: {
                            border: "none"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForward/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIconButton, {
                        disabled: selectedRoundIdAsInt >= mostRecentRound,
                        onClick: function() {
                            return handleArrowButtonPress(mostRecentRound);
                        },
                        variant: "text",
                        scale: "sm",
                        style: {
                            border: "none"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowLast/* default */.Z, {})
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var AllHistoryCard_RoundSwitcher = (RoundSwitcher);

;// CONCATENATED MODULE: ./src/views/Lottery/components/AllHistoryCard/index.tsx



function AllHistoryCard_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n\n  ",
        " {\n    width: 680px;\n  }\n"
    ]);
    AllHistoryCard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AllHistoryCard_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 20px;\n  z-index: 2;\n  background: none;\n  border-bottom: 1px ",
        " solid;\n"
    ]);
    AllHistoryCard_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}














var AllHistoryCard_StyledCard = (0,styled_components_browser_esm/* default */.ZP)(Card/* default */.Z).withConfig({
    componentId: "sc-8810cf94-0"
})(AllHistoryCard_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var StyledCardHeader = (0,styled_components_browser_esm/* default */.ZP)(CardHeader/* default */.Z).withConfig({
    componentId: "sc-8810cf94-1"
})(AllHistoryCard_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
});
var AllHistoryCard = function() {
    var ref = (0,src/* useTranslation */.$G)(), t = ref.t, locale = ref.currentLanguage.locale;
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var ref1 = useLottery(), currentLotteryId = ref1.currentLotteryId, lotteriesData = ref1.lotteriesData, _currentRound = ref1.currentRound, status = _currentRound.status, isLoading = _currentRound.isLoading;
    var ref2 = (0,react.useState)(null), latestRoundId = ref2[0], setLatestRoundId = ref2[1];
    var ref3 = (0,react.useState)(""), selectedRoundId = ref3[0], setSelectedRoundId = ref3[1];
    var ref4 = (0,react.useState)(null), selectedLotteryNodeData = ref4[0], setSelectedLotteryNodeData = ref4[1];
    var timer = (0,react.useRef)(null);
    var numRoundsFetched = lotteriesData === null || lotteriesData === void 0 ? void 0 : lotteriesData.length;
    (0,react.useEffect)(function() {
        if (currentLotteryId) {
            var currentLotteryIdAsInt = currentLotteryId ? parseInt(currentLotteryId) : null;
            var mostRecentFinishedRoundId = status === types/* LotteryStatus.CLAIMABLE */.p3.CLAIMABLE ? currentLotteryIdAsInt : currentLotteryIdAsInt - 1;
            setLatestRoundId(mostRecentFinishedRoundId);
            setSelectedRoundId(mostRecentFinishedRoundId.toString());
        }
    }, [
        currentLotteryId,
        status
    ]);
    (0,react.useEffect)(function() {
        setSelectedLotteryNodeData(null);
        var fetchLotteryData = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var isNew, lotteryData, processedLotteryData;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            isNew = parseInt(lottery/* LATEST_LOTTERY_NEW_CONTRACT */.hi) < parseInt(selectedRoundId);
                            return [
                                4,
                                (0,helpers/* fetchLottery */.JE)((parseInt(selectedRoundId) + (!isNew ? 2 : 0)).toString(), isNew)
                            ];
                        case 1:
                            lotteryData = _state.sent();
                            processedLotteryData = processLotteryResponse(lotteryData);
                            setSelectedLotteryNodeData(processedLotteryData);
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchLotteryData() {
                return _ref.apply(this, arguments);
            };
        }();
        timer.current = setInterval(function() {
            if (selectedRoundId) {
                fetchLotteryData();
            }
            clearInterval(timer.current);
        }, 1000);
        return function() {
            return clearInterval(timer.current);
        };
    }, [
        selectedRoundId,
        currentLotteryId,
        numRoundsFetched,
        dispatch
    ]);
    var handleInputChange = function(event) {
        var value = event.target.value;
        if (value) {
            setSelectedRoundId(value);
            if (parseInt(value, 10) <= 0) {
                setSelectedRoundId("");
            }
            if (parseInt(value, 10) >= latestRoundId) {
                setSelectedRoundId(latestRoundId.toString());
            }
        } else {
            setSelectedRoundId("");
        }
    };
    var handleArrowButtonPress = function(targetRound) {
        if (targetRound) {
            setSelectedRoundId(targetRound.toString());
        } else {
            // targetRound is NaN when the input is empty, the only button press that will trigger this func is 'forward one'
            setSelectedRoundId("1");
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AllHistoryCard_StyledCard, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCardHeader, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AllHistoryCard_RoundSwitcher, {
                    isLoading: isLoading,
                    selectedRoundId: selectedRoundId,
                    mostRecentRound: latestRoundId,
                    handleInputChange: handleInputChange,
                    handleArrowButtonPress: handleArrowButtonPress
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Body, {
                lotteryNodeData: selectedLotteryNodeData,
                lotteryId: selectedRoundId
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {
                lotteryNodeData: selectedLotteryNodeData,
                lotteryId: selectedRoundId
            })
        ]
    });
};
/* harmony default export */ var components_AllHistoryCard = (AllHistoryCard);

// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/TrophyGold.tsx
var TrophyGold = __webpack_require__(56658);
;// CONCATENATED MODULE: ./src/views/Lottery/hooks/useGetUnclaimedRewards.ts







var useGetUnclaimedRewards = function() {
    var account = (0,wagmi_src/* useWeb3React */.Ge)().account;
    var ref = useLottery(), isTransitioning = ref.isTransitioning, currentLotteryId = ref.currentLotteryId;
    var userLotteryData = useGetUserLotteriesGraphData();
    var lotteriesData = useGetLotteriesGraphData();
    var ref1 = (0,react.useState)([]), unclaimedRewards = ref1[0], setUnclaimedRewards = ref1[1];
    var ref2 = (0,react.useState)(types/* FetchStatus.Idle */.iF.Idle), fetchStatus = ref2[0], setFetchStatus = ref2[1];
    (0,react.useEffect)(function() {
        // Reset on account change and round transition
        setFetchStatus(types/* FetchStatus.Idle */.iF.Idle);
    }, [
        account,
        isTransitioning
    ]);
    var fetchAllRewards = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var unclaimedRewardsResponse;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setFetchStatus(types/* FetchStatus.Fetching */.iF.Fetching);
                        return [
                            4,
                            lottery_fetchUnclaimedUserRewards(account, userLotteryData, lotteriesData, currentLotteryId)
                        ];
                    case 1:
                        unclaimedRewardsResponse = _state.sent();
                        setUnclaimedRewards(unclaimedRewardsResponse);
                        setFetchStatus(types/* FetchStatus.Fetched */.iF.Fetched);
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchAllRewards() {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        fetchAllRewards: fetchAllRewards,
        unclaimedRewards: unclaimedRewards,
        fetchStatus: fetchStatus
    };
};
/* harmony default export */ var hooks_useGetUnclaimedRewards = (useGetUnclaimedRewards);

;// CONCATENATED MODULE: ./src/views/Lottery/components/CheckPrizesSection.tsx


function CheckPrizesSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 20px;\n  position: relative;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 16px; \n  width: 100%;\n  margin-left: 8px;\n  margin-right: 8px;\n  @media (min-width: 680px) {\n    margin-left: auto;\n    margin-right: auto;\n  }\n  max-width: 680px;\n  border-radius: 30px;\n  border: 1px solid rgba(243, 238, 255, 0.08);\n  background: linear-gradient(180deg, rgba(243, 238, 255, 0.00) 0%, rgba(243, 238, 255, 0.04) 100%), rgba(147, 130, 255, 0.01);\n  box-shadow: 0px 0px 12px 0px rgba(255, 255, 255, 0.08) inset;\n  @media (min-width: 1280px) {\n    position: absolute;\n    right: 15px;\n    top: 0;\n    width: 400px;\n"
    ]);
    CheckPrizesSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CheckPrizesSection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 15px 20px 16px 20px !important;; \n  font-size: 18px !important;\n  font-style: normal;\n  font-weight: 500 !important;\n  line-height: 140%;\n  font-family: DM Sans !important;\n  height: 44px !important;\n  background: transparent !important;\n  text-transform: none !important;\n  letter-spacing: 0 !important;\n  box-shadow: none !important;\n  border: 1px solid ",
        " !important;\n"
    ]);
    CheckPrizesSection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CheckPrizesSection_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 60px;\n  ",
        " {\n    height: 100px;\n  }\n"
    ]);
    CheckPrizesSection_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CheckPrizesSection_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 54px;\n  ",
        " {\n    height: 84px;\n  }\n"
    ]);
    CheckPrizesSection_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}










var StyledFlex = (0,styled_components_browser_esm/* default */.ZP)(Box_Flex/* default */.Z).withConfig({
    componentId: "sc-1c136627-0"
})(CheckPrizesSection_templateObject());
var CustomButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-1c136627-1"
})(CheckPrizesSection_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.inputBorder;
});
var TicketImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-1c136627-2"
})(CheckPrizesSection_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var TornTicketImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-1c136627-3"
})(CheckPrizesSection_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var CheckPrizesSection = function() {
    var t = (0,src/* useTranslation */.$G)().t;
    var account = (0,wagmi_src/* useWeb3React */.Ge)().account;
    var ref = useLottery(), isTransitioning = ref.isTransitioning, status = ref.currentRound.status;
    var ref1 = hooks_useGetUnclaimedRewards(), fetchAllRewards = ref1.fetchAllRewards, unclaimedRewards = ref1.unclaimedRewards, fetchStatus = ref1.fetchStatus;
    var userLotteryData = useGetUserLotteriesGraphData();
    var ref2 = (0,react.useState)(false), hasCheckedForRewards = ref2[0], setHasCheckedForRewards = ref2[1];
    var ref3 = (0,react.useState)(false), hasRewardsToClaim = ref3[0], setHasRewardsToClaim = ref3[1];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_ClaimPrizesModal, {
        roundsToClaim: unclaimedRewards
    }), false), 1), onPresentClaimModal = ref4[0];
    var isFetchingRewards = fetchStatus === types/* FetchStatus.Fetching */.iF.Fetching;
    var lotteryIsNotClaimable = status === types/* LotteryStatus.CLOSE */.p3.CLOSE;
    var isCheckNowDisabled = !userLotteryData.account || lotteryIsNotClaimable;
    (0,react.useEffect)(function() {
        if (fetchStatus === types/* FetchStatus.Fetched */.iF.Fetched) {
            // Manage showing unclaimed rewards modal once per page load / once per lottery state change
            if (unclaimedRewards.length > 0 && !hasCheckedForRewards) {
                setHasRewardsToClaim(true);
                setHasCheckedForRewards(true);
                onPresentClaimModal();
            }
            if (unclaimedRewards.length === 0 && !hasCheckedForRewards) {
                setHasRewardsToClaim(false);
                setHasCheckedForRewards(true);
            }
        }
    }, [
        unclaimedRewards,
        hasCheckedForRewards,
        fetchStatus,
        onPresentClaimModal
    ]);
    (0,react.useEffect)(function() {
        // Clear local state on account change, or when lottery isTransitioning state changes
        setHasRewardsToClaim(false);
        setHasCheckedForRewards(false);
    }, [
        account,
        isTransitioning
    ]);
    var getBody = function() {
        if (!account) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        }
        if (hasCheckedForRewards && !hasRewardsToClaim) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFlex, {
                alignItems: "center",
                justifyContent: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                    mx: [
                        "4px",
                        null,
                        "16px"
                    ],
                    flexDirection: "column",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            textAlign: "center",
                            color: "#F4EEFF",
                            children: t("No prizes to collect")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            textAlign: "center",
                            color: "textSubtle",
                            children: t("Better luck next time!")
                        })
                    ]
                })
            });
        }
        if (hasCheckedForRewards && hasRewardsToClaim) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFlex, {
                alignItems: "center",
                justifyContent: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                    mx: [
                        "4px",
                        null,
                        "16px"
                    ],
                    flexDirection: "column",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                            textAlign: "center",
                            color: "#F4EEFF",
                            children: t("Congratulations!")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                            textAlign: "center",
                            color: "#F4EEFF",
                            children: t("Why not play again")
                        })
                    ]
                })
            });
        }
        var checkNowText = function() {
            if (lotteryIsNotClaimable) {
                return "".concat(t("Calculating"), "...");
            }
            if (isFetchingRewards) {
                return t("Checking");
            }
            return t("Check now");
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFlex, {
            alignItems: "center",
            justifyContent: "center",
            m: "auto",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                flexDirection: [
                    "column",
                    "column",
                    "column",
                    "row"
                ],
                style: {
                    gap: "15px"
                },
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TrophyGold/* default */.Z, {
                        fill: "#9F9DAE",
                        height: "24px",
                        width: "24px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        textAlign: "center",
                        color: "#F4EEFF",
                        children: t("Are you a winner?")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomButton, {
                        disabled: isCheckNowDisabled,
                        onClick: fetchAllRewards,
                        isLoading: isFetchingRewards,
                        endIcon: isFetchingRewards ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                            color: "currentColor",
                            spin: true
                        }) : null,
                        children: checkNowText()
                    })
                ]
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Flex/* default */.Z, {
        children: getBody()
    });
};
/* harmony default export */ var components_CheckPrizesSection = (CheckPrizesSection);

// EXTERNAL MODULE: ./packages/uikit/src/components/Link/Link.tsx
var Link = __webpack_require__(98768);
;// CONCATENATED MODULE: ./src/views/Lottery/svgs/TicketPurchaseCard.tsx




var TicketPurchaseCard = function(props) {
    return /*#__PURE__*/ _jsxs(Svg, _object_spread_props(_object_spread({
        viewBox: "0 0 296 121"
    }, props), {
        children: [
            /*#__PURE__*/ _jsxs("g", {
                filter: "url(#filter0_dd_ticket_purchase_card)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "M4 16C4 7.16344 11.1634 0 20 0H66V113H20C11.1634 113 4 105.837 4 97V16Z",
                        fill: "#FFB237"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M69.4931 2.94568C68.9511 1.38001 67.6569 0 66 0V10H90V0C88.3431 0 87.0489 1.38001 86.5069 2.94568C85.2868 6.4696 81.9389 9 78 9C74.0611 9 70.7132 6.4696 69.4931 2.94568Z",
                        fill: "#FFB237"
                    }),
                    /*#__PURE__*/ _jsx("rect", {
                        x: "66",
                        y: "10",
                        width: "10",
                        height: "93",
                        fill: "#FFB237"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M78 103V10",
                        stroke: "#FFB237",
                        strokeWidth: "4",
                        strokeDasharray: "4 4"
                    }),
                    /*#__PURE__*/ _jsx("rect", {
                        x: "80",
                        y: "10",
                        width: "10",
                        height: "93",
                        fill: "#FFB237"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M69.4931 110.054C68.9511 111.62 67.6569 113 66 113V103H90V113C88.3431 113 87.0489 111.62 86.5069 110.054C85.2868 106.53 81.9389 104 78 104C74.0611 104 70.7132 106.53 69.4931 110.054Z",
                        fill: "#FFB237"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M90 0H276C284.837 0 292 7.16344 292 16V97C292 105.837 284.837 113 276 113H90V0Z",
                        fill: "#FFB237"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsxs("filter", {
                    id: "filter0_dd_ticket_purchase_card",
                    x: "0",
                    y: "0",
                    width: "296",
                    height: "121",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ _jsx("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ _jsx("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        }),
                        /*#__PURE__*/ _jsx("feOffset", {
                            dx: "2",
                            dy: "2"
                        }),
                        /*#__PURE__*/ _jsx("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 1 0 0 0 0 0.686275 0 0 0 0 0 0 0 0 1 0"
                        }),
                        /*#__PURE__*/ _jsx("feBlend", {
                            mode: "normal",
                            in2: "BackgroundImageFix",
                            result: "effect1_dropShadow_ticket_purchase_card"
                        }),
                        /*#__PURE__*/ _jsx("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        }),
                        /*#__PURE__*/ _jsx("feOffset", {
                            dy: "4"
                        }),
                        /*#__PURE__*/ _jsx("feGaussianBlur", {
                            stdDeviation: "2"
                        }),
                        /*#__PURE__*/ _jsx("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                        }),
                        /*#__PURE__*/ _jsx("feBlend", {
                            mode: "normal",
                            in2: "effect1_dropShadow_ticket_purchase_card",
                            result: "effect2_dropShadow_ticket_purchase_card"
                        }),
                        /*#__PURE__*/ _jsx("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "effect2_dropShadow_ticket_purchase_card",
                            result: "shape"
                        })
                    ]
                })
            })
        ]
    }));
};
/* harmony default export */ var svgs_TicketPurchaseCard = ((/* unused pure expression or super */ null && (TicketPurchaseCard)));

;// CONCATENATED MODULE: ./src/views/Lottery/svgs/WhiteBunny.tsx




var WhiteBunny = function(props) {
    return /*#__PURE__*/ _jsxs(Svg, _object_spread_props(_object_spread({
        viewBox: "0 0 27 26"
    }, props), {
        children: [
            /*#__PURE__*/ _jsxs("mask", {
                id: "white-bunny-path-1-outside-1",
                maskUnits: "userSpaceOnUse",
                x: "0.5",
                y: "-0.0263672",
                width: "26",
                height: "26",
                fill: "black",
                children: [
                    /*#__PURE__*/ _jsx("rect", {
                        fill: "white",
                        x: "0.5",
                        y: "-0.0263672",
                        width: "26",
                        height: "26"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M6.909 3.56941C7.03125 1.79519 8.76206 0.588231 10.4692 1.08677C11.9461 1.51808 12.7937 3.06497 12.3624 4.54184L11.1683 8.63073C11.9225 8.53996 12.7022 8.49237 13.5 8.49237C14.6339 8.49237 15.731 8.58848 16.7708 8.76808L18.74 2.99564C19.2367 1.53947 20.8199 0.761724 22.2761 1.25849C23.9593 1.83269 24.6807 3.81559 23.7601 5.3372L20.9057 10.0551C23.7031 11.3976 25.5 13.4834 25.5 15.8257L25.5 15.8267V17.6934C25.5 21.7435 20.1274 25.0267 13.5 25.0267C6.87258 25.0267 1.5 21.7435 1.5 17.6934V15.8267V15.8257C1.5 13.379 3.46066 11.2122 6.47417 9.88004L6.909 3.56941Z"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10.4692 1.08677L10.7142 0.247673V0.247673L10.4692 1.08677ZM6.909 3.56941L7.78108 3.6295V3.62949L6.909 3.56941ZM12.3624 4.54184L13.2015 4.78689V4.78689L12.3624 4.54184ZM11.1683 8.63073L10.3292 8.38568L9.95792 9.65684L11.2727 9.49862L11.1683 8.63073ZM16.7708 8.76808L16.622 9.62947L17.3572 9.75647L17.5981 9.05032L16.7708 8.76808ZM18.74 2.99564L19.5673 3.27788V3.27788L18.74 2.99564ZM22.2761 1.25849L22.5583 0.431153V0.431153L22.2761 1.25849ZM23.7601 5.3372L23.0122 4.88469V4.88469L23.7601 5.3372ZM20.9057 10.0551L20.1578 9.60256L19.6593 10.4265L20.5275 10.8432L20.9057 10.0551ZM25.5 15.8257H24.6258L24.6259 15.8274L25.5 15.8257ZM25.5 15.8267H26.3742L26.3742 15.8251L25.5 15.8267ZM6.47417 9.88004L6.82762 10.6796L7.31 10.4663L7.34626 9.94013L6.47417 9.88004ZM10.7142 0.247673C8.47144 -0.407305 6.19752 1.17838 6.03691 3.50932L7.78108 3.62949C7.86497 2.412 9.05268 1.58377 10.2241 1.92587L10.7142 0.247673ZM13.2015 4.78689C13.7681 2.84659 12.6545 0.814314 10.7142 0.247673L10.2241 1.92587C11.2376 2.22184 11.8192 3.28334 11.5233 4.2968L13.2015 4.78689ZM12.0074 8.87578L13.2015 4.78689L11.5233 4.2968L10.3292 8.38568L12.0074 8.87578ZM13.5 7.61822C12.6675 7.61822 11.853 7.66787 11.0638 7.76284L11.2727 9.49862C11.9921 9.41204 12.7369 9.36652 13.5 9.36652V7.61822ZM16.9195 7.90668C15.8299 7.71847 14.683 7.61822 13.5 7.61822V9.36652C14.5847 9.36652 15.632 9.45848 16.622 9.62947L16.9195 7.90668ZM17.5981 9.05032L19.5673 3.27788L17.9127 2.7134L15.9434 8.48584L17.5981 9.05032ZM19.5673 3.27788C19.9082 2.27864 20.9946 1.74493 21.9938 2.08582L22.5583 0.431153C20.6452 -0.221485 18.5653 0.800311 17.9127 2.7134L19.5673 3.27788ZM21.9938 2.08582C23.1489 2.47985 23.644 3.84054 23.0122 4.88469L24.5081 5.7897C25.7175 3.79064 24.7697 1.18554 22.5583 0.431153L21.9938 2.08582ZM23.0122 4.88469L20.1578 9.60256L21.6536 10.5076L24.5081 5.7897L23.0122 4.88469ZM26.3741 15.8257C26.3741 12.9967 24.2198 10.676 21.284 9.26698L20.5275 10.8432C23.1864 12.1193 24.6259 13.9701 24.6259 15.8257H26.3741ZM26.3742 15.8251L26.3741 15.8241L24.6259 15.8274L24.6259 15.8284L26.3742 15.8251ZM26.3742 17.6934V15.8267H24.6259V17.6934H26.3742ZM13.5 25.9009C16.9478 25.9009 20.1111 25.0486 22.4411 23.6247C24.7561 22.21 26.3742 20.1382 26.3742 17.6934H24.6259C24.6259 19.2987 23.5576 20.8935 21.5295 22.1329C19.5163 23.3632 16.6797 24.1526 13.5 24.1526V25.9009ZM0.62585 17.6934C0.62585 20.1382 2.24387 22.21 4.55889 23.6247C6.88892 25.0486 10.0523 25.9009 13.5 25.9009V24.1526C10.3203 24.1526 7.48367 23.3632 5.47054 22.1329C3.44242 20.8935 2.37415 19.2987 2.37415 17.6934H0.62585ZM0.62585 15.8267V17.6934H2.37415V15.8267H0.62585ZM0.62585 15.8257V15.8267H2.37415V15.8257H0.62585ZM6.12073 9.08053C2.97211 10.4725 0.62585 12.8707 0.62585 15.8257H2.37415C2.37415 13.8874 3.94921 11.952 6.82762 10.6796L6.12073 9.08053ZM6.03691 3.50932L5.60209 9.81995L7.34626 9.94013L7.78108 3.6295L6.03691 3.50932Z",
                fill: "#08060B",
                mask: "url(#path-1-outside-1)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M25.5 17.6933C25.5 21.7434 20.1274 25.0267 13.5 25.0267C6.87258 25.0267 1.5 21.7434 1.5 17.6933V15.8267H25.5V17.6933Z",
                fill: "#F4EEFF"
            }),
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.909 3.56941C7.03125 1.79519 8.76206 0.588231 10.4692 1.08677C11.9461 1.51808 12.7937 3.06497 12.3624 4.54184L11.1683 8.63073C11.9225 8.53996 12.7022 8.49237 13.5 8.49237C14.6339 8.49237 15.731 8.58848 16.7708 8.76808L18.74 2.99564C19.2367 1.53947 20.8199 0.761724 22.2761 1.25849C23.9593 1.83269 24.6807 3.81559 23.7601 5.3372L20.9057 10.0551C23.7031 11.3976 25.5 13.4834 25.5 15.8257C25.5 19.8758 20.1274 23.159 13.5 23.159C6.87258 23.159 1.5 19.8758 1.5 15.8257C1.5 13.379 3.46066 11.2122 6.47417 9.88004L6.909 3.56941Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("ellipse", {
                cx: "10.4334",
                cy: "15.292",
                rx: "1.33333",
                ry: "2",
                fill: "#08060B"
            }),
            /*#__PURE__*/ _jsx("ellipse", {
                cx: "19.6331",
                cy: "15.292",
                rx: "1.33333",
                ry: "2",
                fill: "#08060B"
            })
        ]
    }));
};
/* harmony default export */ var svgs_WhiteBunny = ((/* unused pure expression or super */ null && (WhiteBunny)));

;// CONCATENATED MODULE: ./src/views/Lottery/svgs/Balls.tsx



function Balls_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  top: 45%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  position: absolute;\n"
    ]);
    Balls_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Balls_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #000000;\n  text-shadow: -0.75px -0.75px 0 white, 0.75px -0.75px 0 white, -0.75px 0.75px 0 white, 0.75px 0.75px 0 white;\n  transform: rotate(",
        "deg);\n"
    ]);
    Balls_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var PinkBall = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Svg_Svg/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        viewBox: "0 0 32 32"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "16",
                cy: "16",
                r: "16",
                fill: "#D750B2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                style: {
                    mixBlendMode: "multiply"
                },
                opacity: "0.1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M24.3428 3.13232C28.9191 8.87177 28.5505 17.2573 23.2373 22.5706C17.528 28.2799 8.27148 28.2799 2.56223 22.5706C2.2825 22.2909 2.01648 22.0026 1.76416 21.7067C4.02814 27.3486 9.54881 31.3326 16 31.3326C24.4683 31.3326 31.3332 24.4677 31.3332 15.9994C31.3332 10.6078 28.5504 5.8661 24.3428 3.13232Z",
                    fill: "black"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                style: {
                    mixBlendMode: "multiply"
                },
                opacity: "0.1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M25.7713 4.18262C30.6308 10.2119 30.2607 19.061 24.6609 24.6608C19.0615 30.2602 10.2132 30.6307 4.18396 25.7722C6.99643 29.1689 11.2455 31.3329 16 31.3329C24.4683 31.3329 31.3332 24.468 31.3332 15.9997C31.3332 11.2446 29.1687 6.99508 25.7713 4.18262Z",
                    fill: "black"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                style: {
                    mixBlendMode: "soft-light"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M3.48969 24.8677C0.151051 18.7651 0.974979 11.0636 6.01931 6.01927C11.0639 0.974682 18.7659 0.15093 24.8687 3.49016C22.365 1.71201 19.3046 0.666603 16 0.666603C7.53165 0.666603 0.666733 7.53152 0.666733 15.9998C0.666733 19.3041 1.7119 22.3642 3.48969 24.8677Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                style: {
                    mixBlendMode: "soft-light"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M2.10075 9.5143C3.77271 5.93677 6.78528 3.11129 10.4921 1.68422C10.546 1.73235 10.5987 1.78219 10.6502 1.83374C12.4838 3.66728 10.9119 5.7442 8.66145 7.99465C6.411 10.2451 4.33417 11.8169 2.50064 9.98335C2.35338 9.83609 2.22013 9.6793 2.10075 9.5143Z",
                    fill: "white"
                })
            })
        ]
    }));
};
var LilacBall = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Svg_Svg/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        viewBox: "0 0 32 32"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "16",
                cy: "16",
                r: "16",
                fill: "#A881FC"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                style: {
                    mixBlendMode: "multiply"
                },
                opacity: "0.1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M24.3428 3.13232C28.9191 8.87177 28.5505 17.2573 23.2373 22.5706C17.528 28.2799 8.27148 28.2799 2.56223 22.5706C2.2825 22.2909 2.01648 22.0026 1.76416 21.7067C4.02814 27.3486 9.54881 31.3326 16 31.3326C24.4683 31.3326 31.3332 24.4677 31.3332 15.9994C31.3332 10.6078 28.5504 5.8661 24.3428 3.13232Z",
                    fill: "black"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                style: {
                    mixBlendMode: "multiply"
                },
                opacity: "0.1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M25.7713 4.18262C30.6308 10.2119 30.2607 19.061 24.6609 24.6608C19.0615 30.2602 10.2132 30.6307 4.18396 25.7722C6.99643 29.1689 11.2455 31.3329 16 31.3329C24.4683 31.3329 31.3332 24.468 31.3332 15.9997C31.3332 11.2446 29.1687 6.99508 25.7713 4.18262Z",
                    fill: "black"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                style: {
                    mixBlendMode: "soft-light"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M3.48969 24.8677C0.151051 18.7651 0.974979 11.0636 6.01931 6.01927C11.0639 0.974682 18.7659 0.15093 24.8687 3.49016C22.365 1.71201 19.3046 0.666603 16 0.666603C7.53165 0.666603 0.666733 7.53152 0.666733 15.9998C0.666733 19.3041 1.7119 22.3642 3.48969 24.8677Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                style: {
                    mixBlendMode: "soft-light"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M2.10075 9.5143C3.77271 5.93677 6.78528 3.11129 10.4921 1.68422C10.546 1.73235 10.5987 1.78219 10.6502 1.83374C12.4838 3.66728 10.9119 5.7442 8.66145 7.99465C6.411 10.2451 4.33417 11.8169 2.50064 9.98335C2.35338 9.83609 2.22013 9.6793 2.10075 9.5143Z",
                    fill: "white"
                })
            })
        ]
    }));
};
var TealBall = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Svg_Svg/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        viewBox: "0 0 32 32"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "16",
                cy: "16",
                r: "16",
                fill: "#1FC7D4"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                style: {
                    mixBlendMode: "multiply"
                },
                opacity: "0.1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M24.3428 3.13232C28.9191 8.87177 28.5505 17.2573 23.2373 22.5706C17.528 28.2799 8.27148 28.2799 2.56223 22.5706C2.2825 22.2909 2.01648 22.0026 1.76416 21.7067C4.02814 27.3486 9.54881 31.3326 16 31.3326C24.4683 31.3326 31.3332 24.4677 31.3332 15.9994C31.3332 10.6078 28.5504 5.8661 24.3428 3.13232Z",
                    fill: "black"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                style: {
                    mixBlendMode: "multiply"
                },
                opacity: "0.1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M25.7713 4.18262C30.6308 10.2119 30.2607 19.061 24.6609 24.6608C19.0615 30.2602 10.2132 30.6307 4.18396 25.7722C6.99643 29.1689 11.2455 31.3329 16 31.3329C24.4683 31.3329 31.3332 24.468 31.3332 15.9997C31.3332 11.2446 29.1687 6.99508 25.7713 4.18262Z",
                    fill: "black"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                style: {
                    mixBlendMode: "soft-light"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M3.48969 24.8677C0.151051 18.7651 0.974979 11.0636 6.01931 6.01927C11.0639 0.974682 18.7659 0.15093 24.8687 3.49016C22.365 1.71201 19.3046 0.666603 16 0.666603C7.53165 0.666603 0.666733 7.53152 0.666733 15.9998C0.666733 19.3041 1.7119 22.3642 3.48969 24.8677Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                style: {
                    mixBlendMode: "soft-light"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M2.10075 9.5143C3.77271 5.93677 6.78528 3.11129 10.4921 1.68422C10.546 1.73235 10.5987 1.78219 10.6502 1.83374C12.4838 3.66728 10.9119 5.7442 8.66145 7.99465C6.411 10.2451 4.33417 11.8169 2.50064 9.98335C2.35338 9.83609 2.22013 9.6793 2.10075 9.5143Z",
                    fill: "white"
                })
            })
        ]
    }));
};
var AquaBall = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Svg_Svg/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        viewBox: "0 0 32 32"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "16",
                cy: "16",
                r: "16",
                fill: "#31D0AA"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                style: {
                    mixBlendMode: "multiply"
                },
                opacity: "0.1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M24.3428 3.13232C28.9191 8.87177 28.5505 17.2573 23.2373 22.5706C17.528 28.2799 8.27148 28.2799 2.56223 22.5706C2.2825 22.2909 2.01648 22.0026 1.76416 21.7067C4.02814 27.3486 9.54881 31.3326 16 31.3326C24.4683 31.3326 31.3332 24.4677 31.3332 15.9994C31.3332 10.6078 28.5504 5.8661 24.3428 3.13232Z",
                    fill: "black"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                style: {
                    mixBlendMode: "multiply"
                },
                opacity: "0.1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M25.7713 4.18262C30.6308 10.2119 30.2607 19.061 24.6609 24.6608C19.0615 30.2602 10.2132 30.6307 4.18396 25.7722C6.99643 29.1689 11.2455 31.3329 16 31.3329C24.4683 31.3329 31.3332 24.468 31.3332 15.9997C31.3332 11.2446 29.1687 6.99508 25.7713 4.18262Z",
                    fill: "black"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                style: {
                    mixBlendMode: "soft-light"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M3.48969 24.8677C0.151051 18.7651 0.974979 11.0636 6.01931 6.01927C11.0639 0.974682 18.7659 0.15093 24.8687 3.49016C22.365 1.71201 19.3046 0.666603 16 0.666603C7.53165 0.666603 0.666733 7.53152 0.666733 15.9998C0.666733 19.3041 1.7119 22.3642 3.48969 24.8677Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                style: {
                    mixBlendMode: "soft-light"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M2.10075 9.5143C3.77271 5.93677 6.78528 3.11129 10.4921 1.68422C10.546 1.73235 10.5987 1.78219 10.6502 1.83374C12.4838 3.66728 10.9119 5.7442 8.66145 7.99465C6.411 10.2451 4.33417 11.8169 2.50064 9.98335C2.35338 9.83609 2.22013 9.6793 2.10075 9.5143Z",
                    fill: "white"
                })
            })
        ]
    }));
};
var GreenBall = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Svg_Svg/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        viewBox: "0 0 32 32"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "16",
                cy: "16",
                r: "16",
                fill: "#93D45A"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                style: {
                    mixBlendMode: "multiply"
                },
                opacity: "0.1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M24.3428 3.13232C28.9191 8.87177 28.5505 17.2573 23.2373 22.5706C17.528 28.2799 8.27148 28.2799 2.56223 22.5706C2.2825 22.2909 2.01648 22.0026 1.76416 21.7067C4.02814 27.3486 9.54881 31.3326 16 31.3326C24.4683 31.3326 31.3332 24.4677 31.3332 15.9994C31.3332 10.6078 28.5504 5.8661 24.3428 3.13232Z",
                    fill: "black"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                style: {
                    mixBlendMode: "multiply"
                },
                opacity: "0.1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M25.7713 4.18262C30.6308 10.2119 30.2607 19.061 24.6609 24.6608C19.0615 30.2602 10.2132 30.6307 4.18396 25.7722C6.99643 29.1689 11.2455 31.3329 16 31.3329C24.4683 31.3329 31.3332 24.468 31.3332 15.9997C31.3332 11.2446 29.1687 6.99508 25.7713 4.18262Z",
                    fill: "black"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                style: {
                    mixBlendMode: "soft-light"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M3.48969 24.8677C0.151051 18.7651 0.974979 11.0636 6.01931 6.01927C11.0639 0.974682 18.7659 0.15093 24.8687 3.49016C22.365 1.71201 19.3046 0.666603 16 0.666603C7.53165 0.666603 0.666733 7.53152 0.666733 15.9998C0.666733 19.3041 1.7119 22.3642 3.48969 24.8677Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                style: {
                    mixBlendMode: "soft-light"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M2.10075 9.5143C3.77271 5.93677 6.78528 3.11129 10.4921 1.68422C10.546 1.73235 10.5987 1.78219 10.6502 1.83374C12.4838 3.66728 10.9119 5.7442 8.66145 7.99465C6.411 10.2451 4.33417 11.8169 2.50064 9.98335C2.35338 9.83609 2.22013 9.6793 2.10075 9.5143Z",
                    fill: "white"
                })
            })
        ]
    }));
};
var YellowBall = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Svg_Svg/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        viewBox: "0 0 32 32"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "16",
                cy: "16",
                r: "16",
                fill: "#FFC43C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                style: {
                    mixBlendMode: "multiply"
                },
                opacity: "0.1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M24.3428 3.13245C28.9191 8.87189 28.5505 17.2575 23.2373 22.5707C17.528 28.28 8.27148 28.28 2.56223 22.5707C2.2825 22.291 2.01648 22.0028 1.76416 21.7068C4.02814 27.3487 9.54881 31.3327 16 31.3327C24.4683 31.3327 31.3332 24.4678 31.3332 15.9995C31.3332 10.6079 28.5504 5.86622 24.3428 3.13245Z",
                    fill: "black"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                style: {
                    mixBlendMode: "multiply"
                },
                opacity: "0.1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M25.7714 4.18262C30.6309 10.2119 30.2608 19.061 24.661 24.6608C19.0616 30.2602 10.2134 30.6307 4.18408 25.7722C6.99655 29.1689 11.2456 31.3329 16.0001 31.3329C24.4685 31.3329 31.3334 24.468 31.3334 15.9997C31.3334 11.2446 29.1689 6.99508 25.7714 4.18262Z",
                    fill: "black"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                style: {
                    mixBlendMode: "soft-light"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M3.48969 24.8677C0.151051 18.7651 0.974979 11.0636 6.01931 6.01927C11.0639 0.974682 18.7659 0.15093 24.8687 3.49016C22.365 1.71201 19.3046 0.666603 16 0.666603C7.53165 0.666603 0.666733 7.53152 0.666733 15.9998C0.666733 19.3041 1.7119 22.3642 3.48969 24.8677Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                style: {
                    mixBlendMode: "soft-light"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M2.10087 9.51443C3.77283 5.93689 6.78541 3.11142 10.4922 1.68435C10.5461 1.73247 10.5988 1.78231 10.6504 1.83387C12.4839 3.6674 10.912 5.74432 8.66157 7.99477C6.41112 10.2452 4.33429 11.817 2.50076 9.98347C2.3535 9.83621 2.22025 9.67943 2.10087 9.51443Z",
                    fill: "white"
                })
            })
        ]
    }));
};
var BallTextWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6a2c5391-0"
})(Balls_templateObject());
var BallText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-6a2c5391-1"
})(Balls_templateObject1(), function(param) {
    var rotationTransform = param.rotationTransform;
    return rotationTransform || 0;
});
var ballsMap = {
    pink: PinkBall,
    lilac: LilacBall,
    teal: TealBall,
    aqua: AquaBall,
    green: GreenBall,
    yellow: YellowBall
};
var BallWithNumber = function(param) {
    var color = param.color, number = param.number, size = param.size, fontSize = param.fontSize, rotationTransform = param.rotationTransform;
    var BallComponent = ballsMap[color];
    return /*#__PURE__*/ _jsxs(Flex, {
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        mx: "2px",
        children: [
            /*#__PURE__*/ _jsx(BallComponent, {
                width: size !== null && size !== void 0 ? size : "32px",
                height: size !== null && size !== void 0 ? size : "32px"
            }),
            /*#__PURE__*/ _jsx(BallTextWrapper, {
                children: /*#__PURE__*/ _jsx(BallText, {
                    rotationTransform: rotationTransform,
                    bold: true,
                    fontSize: fontSize !== null && fontSize !== void 0 ? fontSize : "16px",
                    children: number
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(40872);
;// CONCATENATED MODULE: ./src/views/Lottery/svgs/MatchExamples.tsx



var MatchExampleA = function(_param) {
    var rest = (0,_extends/* default */.Z)({}, _param);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Svg_Svg/* default */.Z, {
        width: "265",
        height: "65",
        viewBox: "0 0 265 65",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 10C0 4.47715 4.47715 0 10 0H255C260.523 0 265 4.47715 265 10V30C265 35.5228 260.523 40 255 40H9.99999C4.47714 40 0 35.5228 0 30V10Z",
                fill: "white",
                "fill-opacity": "0.05"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19.508 26.716C18.68 26.716 17.972 26.554 17.384 26.23C16.796 25.906 16.334 25.474 15.998 24.934C15.674 24.394 15.476 23.806 15.404 23.17H17.186C17.294 23.794 17.552 24.274 17.96 24.61C18.368 24.946 18.89 25.114 19.526 25.114C20.402 25.114 21.122 24.706 21.686 23.89C22.262 23.062 22.568 21.796 22.604 20.092C22.316 20.62 21.866 21.07 21.254 21.442C20.654 21.814 19.958 22 19.166 22C18.458 22 17.792 21.832 17.168 21.496C16.544 21.16 16.04 20.692 15.656 20.092C15.272 19.48 15.08 18.76 15.08 17.932C15.08 17.2 15.26 16.51 15.62 15.862C15.98 15.214 16.484 14.692 17.132 14.296C17.792 13.888 18.572 13.684 19.472 13.684C20.396 13.684 21.176 13.858 21.812 14.206C22.448 14.554 22.958 15.016 23.342 15.592C23.726 16.168 24.002 16.816 24.17 17.536C24.35 18.256 24.44 18.994 24.44 19.75C24.44 21.142 24.242 22.36 23.846 23.404C23.462 24.448 22.904 25.264 22.172 25.852C21.44 26.428 20.552 26.716 19.508 26.716ZM19.598 20.362C20.102 20.362 20.552 20.248 20.948 20.02C21.344 19.792 21.656 19.492 21.884 19.12C22.124 18.736 22.244 18.316 22.244 17.86C22.244 17.368 22.124 16.936 21.884 16.564C21.656 16.18 21.338 15.88 20.93 15.664C20.534 15.448 20.084 15.34 19.58 15.34C19.076 15.34 18.626 15.448 18.23 15.664C17.834 15.88 17.516 16.18 17.276 16.564C17.048 16.936 16.934 17.362 16.934 17.842C16.934 18.61 17.186 19.222 17.69 19.678C18.194 20.134 18.83 20.362 19.598 20.362Z",
                fill: "#F6F3FF"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M64.574 26.5V16.06L62.54 16.528V15.124L65.33 13.9H66.554V26.5H64.574Z",
                fill: "#F6F3FF"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M109.81 26.716C108.994 26.716 108.25 26.572 107.578 26.284C106.918 25.984 106.39 25.534 105.994 24.934C105.598 24.334 105.388 23.584 105.364 22.684H107.254C107.278 23.356 107.506 23.926 107.938 24.394C108.382 24.85 109.006 25.078 109.81 25.078C110.578 25.078 111.166 24.868 111.574 24.448C111.982 24.016 112.186 23.482 112.186 22.846C112.186 22.078 111.91 21.508 111.358 21.136C110.818 20.764 110.152 20.578 109.36 20.578H108.424V18.994H109.378C110.086 18.994 110.656 18.826 111.088 18.49C111.532 18.154 111.754 17.68 111.754 17.068C111.754 16.552 111.58 16.132 111.232 15.808C110.896 15.484 110.416 15.322 109.792 15.322C109.144 15.322 108.634 15.514 108.262 15.898C107.89 16.27 107.686 16.738 107.65 17.302H105.76C105.784 16.57 105.964 15.934 106.3 15.394C106.648 14.854 107.122 14.434 107.722 14.134C108.322 13.834 109.012 13.684 109.792 13.684C110.632 13.684 111.334 13.834 111.898 14.134C112.474 14.422 112.906 14.818 113.194 15.322C113.494 15.814 113.644 16.354 113.644 16.942C113.644 17.614 113.458 18.202 113.086 18.706C112.714 19.21 112.216 19.546 111.592 19.714C112.312 19.87 112.906 20.224 113.374 20.776C113.842 21.316 114.076 22.018 114.076 22.882C114.076 23.578 113.914 24.22 113.59 24.808C113.266 25.384 112.786 25.846 112.15 26.194C111.514 26.542 110.734 26.716 109.81 26.716Z",
                fill: "#F6F3FF"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "0.5",
                y: "0.5",
                width: "129",
                height: "39",
                rx: "9.5",
                stroke: "#9465FF",
                fill: "none"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M154.508 26.716C153.68 26.716 152.972 26.554 152.384 26.23C151.796 25.906 151.334 25.474 150.998 24.934C150.674 24.394 150.476 23.806 150.404 23.17H152.186C152.294 23.794 152.552 24.274 152.96 24.61C153.368 24.946 153.89 25.114 154.526 25.114C155.402 25.114 156.122 24.706 156.686 23.89C157.262 23.062 157.568 21.796 157.604 20.092C157.316 20.62 156.866 21.07 156.254 21.442C155.654 21.814 154.958 22 154.166 22C153.458 22 152.792 21.832 152.168 21.496C151.544 21.16 151.04 20.692 150.656 20.092C150.272 19.48 150.08 18.76 150.08 17.932C150.08 17.2 150.26 16.51 150.62 15.862C150.98 15.214 151.484 14.692 152.132 14.296C152.792 13.888 153.572 13.684 154.472 13.684C155.396 13.684 156.176 13.858 156.812 14.206C157.448 14.554 157.958 15.016 158.342 15.592C158.726 16.168 159.002 16.816 159.17 17.536C159.35 18.256 159.44 18.994 159.44 19.75C159.44 21.142 159.242 22.36 158.846 23.404C158.462 24.448 157.904 25.264 157.172 25.852C156.44 26.428 155.552 26.716 154.508 26.716ZM154.598 20.362C155.102 20.362 155.552 20.248 155.948 20.02C156.344 19.792 156.656 19.492 156.884 19.12C157.124 18.736 157.244 18.316 157.244 17.86C157.244 17.368 157.124 16.936 156.884 16.564C156.656 16.18 156.338 15.88 155.93 15.664C155.534 15.448 155.084 15.34 154.58 15.34C154.076 15.34 153.626 15.448 153.23 15.664C152.834 15.88 152.516 16.18 152.276 16.564C152.048 16.936 151.934 17.362 151.934 17.842C151.934 18.61 152.186 19.222 152.69 19.678C153.194 20.134 153.83 20.362 154.598 20.362Z",
                fill: "#F6F3FF"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M199.904 26.716C198.98 26.716 198.2 26.542 197.564 26.194C196.928 25.846 196.412 25.384 196.016 24.808C195.632 24.232 195.356 23.584 195.188 22.864C195.02 22.144 194.936 21.406 194.936 20.65C194.936 19.258 195.128 18.04 195.512 16.996C195.908 15.952 196.472 15.142 197.204 14.566C197.936 13.978 198.824 13.684 199.868 13.684C200.696 13.684 201.404 13.846 201.992 14.17C202.58 14.494 203.036 14.926 203.36 15.466C203.696 16.006 203.9 16.594 203.972 17.23H202.19C202.082 16.606 201.824 16.126 201.416 15.79C201.008 15.454 200.486 15.286 199.85 15.286C198.974 15.286 198.248 15.7 197.672 16.528C197.108 17.344 196.808 18.604 196.772 20.308C197.06 19.78 197.504 19.33 198.104 18.958C198.716 18.586 199.418 18.4 200.21 18.4C200.918 18.4 201.578 18.568 202.19 18.904C202.814 19.24 203.318 19.714 203.702 20.326C204.098 20.926 204.296 21.64 204.296 22.468C204.296 23.2 204.116 23.89 203.756 24.538C203.396 25.186 202.886 25.714 202.226 26.122C201.578 26.518 200.804 26.716 199.904 26.716ZM199.796 25.06C200.3 25.06 200.75 24.952 201.146 24.736C201.542 24.52 201.854 24.226 202.082 23.854C202.31 23.47 202.424 23.038 202.424 22.558C202.424 21.79 202.172 21.178 201.668 20.722C201.176 20.266 200.546 20.038 199.778 20.038C199.274 20.038 198.818 20.152 198.41 20.38C198.014 20.608 197.702 20.914 197.474 21.298C197.246 21.67 197.132 22.084 197.132 22.54C197.132 23.032 197.246 23.47 197.474 23.854C197.714 24.226 198.032 24.52 198.428 24.736C198.836 24.952 199.292 25.06 199.796 25.06Z",
                fill: "#F6F3FF"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M240.526 26.5V25.132C241.342 24.484 242.122 23.83 242.866 23.17C243.61 22.51 244.27 21.862 244.846 21.226C245.434 20.578 245.896 19.948 246.232 19.336C246.568 18.712 246.736 18.112 246.736 17.536C246.736 17.152 246.67 16.792 246.538 16.456C246.406 16.108 246.19 15.832 245.89 15.628C245.59 15.412 245.188 15.304 244.684 15.304C243.928 15.304 243.358 15.544 242.974 16.024C242.602 16.504 242.422 17.08 242.434 17.752H240.58C240.592 16.864 240.778 16.12 241.138 15.52C241.51 14.92 242.002 14.464 242.614 14.152C243.238 13.84 243.94 13.684 244.72 13.684C245.908 13.684 246.856 14.02 247.564 14.692C248.284 15.352 248.644 16.276 248.644 17.464C248.644 18.172 248.47 18.874 248.122 19.57C247.786 20.266 247.342 20.938 246.79 21.586C246.25 22.222 245.668 22.822 245.044 23.386C244.42 23.95 243.826 24.46 243.262 24.916H249.022V26.5H240.526Z",
                fill: "#F6F3FF"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18.2292 59.0625L14.7083 55.5208L15.75 54.4792L18.2292 56.9375L24.25 50.9375L25.2917 52L18.2292 59.0625Z",
                fill: "#66FFB6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M63.2292 59.0625L59.7083 55.5208L60.75 54.4792L63.2292 56.9375L69.25 50.9375L70.2917 52L63.2292 59.0625Z",
                fill: "#66FFB6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M108.229 59.0625L104.708 55.5208L105.75 54.4792L108.229 56.9375L114.25 50.9375L115.292 52L108.229 59.0625Z",
                fill: "#66FFB6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M151.062 60L150 58.9375L153.938 55L150 51.0625L151.062 50L155 53.9375L158.938 50L160 51.0625L156.062 55L160 58.9375L158.938 60L155 56.0625L151.062 60Z",
                fill: "#FF6666"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M198.229 59.0625L194.708 55.5208L195.75 54.4792L198.229 56.9375L204.25 50.9375L205.292 52L198.229 59.0625Z",
                fill: "#66FFB6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M243.229 59.0625L239.708 55.5208L240.75 54.4792L243.229 56.9375L249.25 50.9375L250.292 52L243.229 59.0625Z",
                fill: "#66FFB6"
            })
        ]
    });
};
var MatchExampleB = function(_param) {
    var rest = (0,_extends/* default */.Z)({}, _param);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Svg_Svg/* default */.Z, {
        width: "265",
        height: "65",
        viewBox: "0 0 265 65",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 10C0 4.47715 4.47715 0 10 0H255C260.523 0 265 4.47715 265 10V30C265 35.5228 260.523 40 255 40H9.99999C4.47714 40 0 35.5228 0 30V10Z",
                fill: "white",
                "fill-opacity": "0.05"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19.818 26.716C18.678 26.716 17.694 26.446 16.866 25.906C16.05 25.354 15.42 24.592 14.976 23.62C14.544 22.636 14.328 21.496 14.328 20.2C14.328 18.904 14.544 17.77 14.976 16.798C15.42 15.814 16.05 15.052 16.866 14.512C17.694 13.96 18.678 13.684 19.818 13.684C20.958 13.684 21.936 13.96 22.752 14.512C23.568 15.052 24.192 15.814 24.624 16.798C25.068 17.77 25.29 18.904 25.29 20.2C25.29 21.496 25.068 22.636 24.624 23.62C24.192 24.592 23.568 25.354 22.752 25.906C21.936 26.446 20.958 26.716 19.818 26.716ZM19.818 25.006C20.502 25.006 21.108 24.814 21.636 24.43C22.176 24.046 22.596 23.494 22.896 22.774C23.196 22.054 23.346 21.196 23.346 20.2C23.346 19.204 23.196 18.346 22.896 17.626C22.596 16.906 22.176 16.354 21.636 15.97C21.108 15.586 20.502 15.394 19.818 15.394C19.122 15.394 18.51 15.586 17.982 15.97C17.454 16.354 17.04 16.906 16.74 17.626C16.44 18.346 16.29 19.204 16.29 20.2C16.29 21.196 16.44 22.054 16.74 22.774C17.04 23.494 17.454 24.046 17.982 24.43C18.51 24.814 19.122 25.006 19.818 25.006Z",
                fill: "#F6F3FF"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M64.574 26.5V16.06L62.54 16.528V15.124L65.33 13.9H66.554V26.5H64.574Z",
                fill: "#F6F3FF"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M109.81 26.716C108.994 26.716 108.25 26.572 107.578 26.284C106.918 25.984 106.39 25.534 105.994 24.934C105.598 24.334 105.388 23.584 105.364 22.684H107.254C107.278 23.356 107.506 23.926 107.938 24.394C108.382 24.85 109.006 25.078 109.81 25.078C110.578 25.078 111.166 24.868 111.574 24.448C111.982 24.016 112.186 23.482 112.186 22.846C112.186 22.078 111.91 21.508 111.358 21.136C110.818 20.764 110.152 20.578 109.36 20.578H108.424V18.994H109.378C110.086 18.994 110.656 18.826 111.088 18.49C111.532 18.154 111.754 17.68 111.754 17.068C111.754 16.552 111.58 16.132 111.232 15.808C110.896 15.484 110.416 15.322 109.792 15.322C109.144 15.322 108.634 15.514 108.262 15.898C107.89 16.27 107.686 16.738 107.65 17.302H105.76C105.784 16.57 105.964 15.934 106.3 15.394C106.648 14.854 107.122 14.434 107.722 14.134C108.322 13.834 109.012 13.684 109.792 13.684C110.632 13.684 111.334 13.834 111.898 14.134C112.474 14.422 112.906 14.818 113.194 15.322C113.494 15.814 113.644 16.354 113.644 16.942C113.644 17.614 113.458 18.202 113.086 18.706C112.714 19.21 112.216 19.546 111.592 19.714C112.312 19.87 112.906 20.224 113.374 20.776C113.842 21.316 114.076 22.018 114.076 22.882C114.076 23.578 113.914 24.22 113.59 24.808C113.266 25.384 112.786 25.846 112.15 26.194C111.514 26.542 110.734 26.716 109.81 26.716Z",
                fill: "#F6F3FF"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M154.904 26.716C153.98 26.716 153.2 26.542 152.564 26.194C151.928 25.846 151.412 25.384 151.016 24.808C150.632 24.232 150.356 23.584 150.188 22.864C150.02 22.144 149.936 21.406 149.936 20.65C149.936 19.258 150.128 18.04 150.512 16.996C150.908 15.952 151.472 15.142 152.204 14.566C152.936 13.978 153.824 13.684 154.868 13.684C155.696 13.684 156.404 13.846 156.992 14.17C157.58 14.494 158.036 14.926 158.36 15.466C158.696 16.006 158.9 16.594 158.972 17.23H157.19C157.082 16.606 156.824 16.126 156.416 15.79C156.008 15.454 155.486 15.286 154.85 15.286C153.974 15.286 153.248 15.7 152.672 16.528C152.108 17.344 151.808 18.604 151.772 20.308C152.06 19.78 152.504 19.33 153.104 18.958C153.716 18.586 154.418 18.4 155.21 18.4C155.918 18.4 156.578 18.568 157.19 18.904C157.814 19.24 158.318 19.714 158.702 20.326C159.098 20.926 159.296 21.64 159.296 22.468C159.296 23.2 159.116 23.89 158.756 24.538C158.396 25.186 157.886 25.714 157.226 26.122C156.578 26.518 155.804 26.716 154.904 26.716ZM154.796 25.06C155.3 25.06 155.75 24.952 156.146 24.736C156.542 24.52 156.854 24.226 157.082 23.854C157.31 23.47 157.424 23.038 157.424 22.558C157.424 21.79 157.172 21.178 156.668 20.722C156.176 20.266 155.546 20.038 154.778 20.038C154.274 20.038 153.818 20.152 153.41 20.38C153.014 20.608 152.702 20.914 152.474 21.298C152.246 21.67 152.132 22.084 152.132 22.54C152.132 23.032 152.246 23.47 152.474 23.854C152.714 24.226 153.032 24.52 153.428 24.736C153.836 24.952 154.292 25.06 154.796 25.06Z",
                fill: "#F6F3FF"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M199.904 26.716C198.98 26.716 198.2 26.542 197.564 26.194C196.928 25.846 196.412 25.384 196.016 24.808C195.632 24.232 195.356 23.584 195.188 22.864C195.02 22.144 194.936 21.406 194.936 20.65C194.936 19.258 195.128 18.04 195.512 16.996C195.908 15.952 196.472 15.142 197.204 14.566C197.936 13.978 198.824 13.684 199.868 13.684C200.696 13.684 201.404 13.846 201.992 14.17C202.58 14.494 203.036 14.926 203.36 15.466C203.696 16.006 203.9 16.594 203.972 17.23H202.19C202.082 16.606 201.824 16.126 201.416 15.79C201.008 15.454 200.486 15.286 199.85 15.286C198.974 15.286 198.248 15.7 197.672 16.528C197.108 17.344 196.808 18.604 196.772 20.308C197.06 19.78 197.504 19.33 198.104 18.958C198.716 18.586 199.418 18.4 200.21 18.4C200.918 18.4 201.578 18.568 202.19 18.904C202.814 19.24 203.318 19.714 203.702 20.326C204.098 20.926 204.296 21.64 204.296 22.468C204.296 23.2 204.116 23.89 203.756 24.538C203.396 25.186 202.886 25.714 202.226 26.122C201.578 26.518 200.804 26.716 199.904 26.716ZM199.796 25.06C200.3 25.06 200.75 24.952 201.146 24.736C201.542 24.52 201.854 24.226 202.082 23.854C202.31 23.47 202.424 23.038 202.424 22.558C202.424 21.79 202.172 21.178 201.668 20.722C201.176 20.266 200.546 20.038 199.778 20.038C199.274 20.038 198.818 20.152 198.41 20.38C198.014 20.608 197.702 20.914 197.474 21.298C197.246 21.67 197.132 22.084 197.132 22.54C197.132 23.032 197.246 23.47 197.474 23.854C197.714 24.226 198.032 24.52 198.428 24.736C198.836 24.952 199.292 25.06 199.796 25.06Z",
                fill: "#F6F3FF"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M240.526 26.5V25.132C241.342 24.484 242.122 23.83 242.866 23.17C243.61 22.51 244.27 21.862 244.846 21.226C245.434 20.578 245.896 19.948 246.232 19.336C246.568 18.712 246.736 18.112 246.736 17.536C246.736 17.152 246.67 16.792 246.538 16.456C246.406 16.108 246.19 15.832 245.89 15.628C245.59 15.412 245.188 15.304 244.684 15.304C243.928 15.304 243.358 15.544 242.974 16.024C242.602 16.504 242.422 17.08 242.434 17.752H240.58C240.592 16.864 240.778 16.12 241.138 15.52C241.51 14.92 242.002 14.464 242.614 14.152C243.238 13.84 243.94 13.684 244.72 13.684C245.908 13.684 246.856 14.02 247.564 14.692C248.284 15.352 248.644 16.276 248.644 17.464C248.644 18.172 248.47 18.874 248.122 19.57C247.786 20.266 247.342 20.938 246.79 21.586C246.25 22.222 245.668 22.822 245.044 23.386C244.42 23.95 243.826 24.46 243.262 24.916H249.022V26.5H240.526Z",
                fill: "#F6F3FF"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.0625 60L15 58.9375L18.9375 55L15 51.0625L16.0625 50L20 53.9375L23.9375 50L25 51.0625L21.0625 55L25 58.9375L23.9375 60L20 56.0625L16.0625 60Z",
                fill: "#FF6666"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M63.2292 59.0625L59.7083 55.5208L60.75 54.4792L63.2292 56.9375L69.25 50.9375L70.2917 52L63.2292 59.0625Z",
                fill: "#66FFB6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M108.229 59.0625L104.708 55.5208L105.75 54.4792L108.229 56.9375L114.25 50.9375L115.292 52L108.229 59.0625Z",
                fill: "#66FFB6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M153.229 59.0625L149.708 55.5208L150.75 54.4792L153.229 56.9375L159.25 50.9375L160.292 52L153.229 59.0625Z",
                fill: "#66FFB6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M198.229 59.0625L194.708 55.5208L195.75 54.4792L198.229 56.9375L204.25 50.9375L205.292 52L198.229 59.0625Z",
                fill: "#66FFB6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M243.229 59.0625L239.708 55.5208L240.75 54.4792L243.229 56.9375L249.25 50.9375L250.292 52L243.229 59.0625Z",
                fill: "#66FFB6"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/views/Lottery/svgs/PoolAllocationChart.tsx


var PoolAllocationChart = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Svg_Svg/* default */.Z, {
        width: "300",
        height: "300",
        viewBox: "0 0 300 300",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M150 0C156.285 7.49509e-08 162.564 0.395044 168.8 1.1828L163.16 45.828C158.795 45.2765 154.4 45 150 45V0Z",
                fill: "url(#paint0_radial_4625_11724)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M168.8 1.1828C178.157 2.36491 187.382 4.42695 196.353 7.34153L182.447 50.1391C176.168 48.0989 169.71 46.6554 163.16 45.828L168.8 1.1828Z",
                fill: "url(#paint1_radial_4625_11724)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M196.353 7.34153C211.323 12.2056 225.434 19.3955 238.168 28.6475L211.717 65.0532C202.804 58.5769 192.926 53.5439 182.447 50.1391L196.353 7.34153Z",
                fill: "url(#paint2_radial_4625_11724)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M238.168 28.6475C263.795 47.2667 282.87 73.521 292.659 103.648L249.861 117.553C243.009 96.4647 229.656 78.0867 211.717 65.0532L238.168 28.6475Z",
                fill: "url(#paint3_radial_4625_11724)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M292.658 103.647C302.447 133.774 302.447 166.226 292.658 196.353C282.87 226.479 263.795 252.733 238.168 271.353L211.717 234.947C229.656 221.913 243.009 203.535 249.861 182.447C256.713 161.358 256.713 138.642 249.861 117.553L292.658 103.647Z",
                fill: "url(#paint4_radial_4625_11724)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M238.168 271.353C212.541 289.972 181.677 300 150 300C118.323 300 87.4595 289.972 61.8324 271.353C36.2052 252.733 17.1303 226.479 7.34161 196.353C-2.44714 166.226 -2.4472 133.774 7.34141 103.648L50.139 117.553C43.287 138.642 43.287 161.358 50.1391 182.447C56.9912 203.535 70.3437 221.913 88.2826 234.947C106.222 247.98 127.826 255 150 255C172.174 255 193.778 247.98 211.717 234.947L238.168 271.353Z",
                fill: "url(#paint5_radial_4625_11724)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M150 0C118.323 -3.77743e-07 87.4594 10.0282 61.8322 28.6475C36.2051 47.2667 17.1302 73.5209 7.34152 103.647L50.1391 117.553C56.9912 96.4647 70.3436 78.0867 88.2825 65.0532C106.222 52.0198 127.826 45 150 45V0Z",
                fill: "url(#paint6_radial_4625_11724)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_4625_11724",
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "103",
                width: "239",
                height: "197",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M238.168 271.353C212.541 289.972 181.677 300 150 300C118.323 300 87.4595 289.972 61.8324 271.353C36.2052 252.733 17.1303 226.479 7.34161 196.353C-2.44714 166.226 -2.4472 133.774 7.34141 103.648L50.139 117.553C43.287 138.642 43.287 161.358 50.1391 182.447C56.9912 203.535 70.3437 221.913 88.2826 234.947C106.222 247.98 127.826 255 150 255C172.174 255 193.778 247.98 211.717 234.947L238.168 271.353Z",
                    fill: "url(#paint7_radial_4625_11724)"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                mask: "url(#mask0_4625_11724)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                    cx: "150",
                    cy: "150",
                    r: "150",
                    fill: "url(#paint8_radial_4625_11724)"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask1_4625_11724",
                maskUnits: "userSpaceOnUse",
                x: "7",
                y: "0",
                width: "143",
                height: "118",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M150 0C118.323 -3.77743e-07 87.4594 10.0282 61.8322 28.6475C36.2051 47.2667 17.1302 73.5209 7.34152 103.647L50.1391 117.553C56.9912 96.4647 70.3436 78.0867 88.2825 65.0532C106.222 52.0198 127.826 45 150 45V0Z",
                    fill: "url(#paint9_radial_4625_11724)"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                mask: "url(#mask1_4625_11724)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                    cx: "150",
                    cy: "150",
                    r: "150",
                    fill: "url(#paint10_radial_4625_11724)"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask2_4625_11724",
                maskUnits: "userSpaceOnUse",
                x: "211",
                y: "103",
                width: "89",
                height: "169",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M292.658 103.647C302.447 133.774 302.447 166.226 292.658 196.353C282.87 226.479 263.795 252.733 238.168 271.353L211.717 234.947C229.656 221.913 243.009 203.535 249.861 182.447C256.713 161.358 256.713 138.642 249.861 117.553L292.658 103.647Z",
                    fill: "url(#paint11_radial_4625_11724)"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                mask: "url(#mask2_4625_11724)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                    cx: "150",
                    cy: "150",
                    r: "150",
                    fill: "url(#paint12_radial_4625_11724)"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask3_4625_11724",
                maskUnits: "userSpaceOnUse",
                x: "211",
                y: "28",
                width: "82",
                height: "90",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M238.168 28.6475C263.795 47.2667 282.87 73.521 292.659 103.648L249.861 117.553C243.009 96.4647 229.656 78.0867 211.717 65.0532L238.168 28.6475Z",
                    fill: "#FF66D4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                mask: "url(#mask3_4625_11724)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                    cx: "150",
                    cy: "150",
                    r: "150",
                    fill: "url(#paint13_radial_4625_11724)"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask4_4625_11724",
                maskUnits: "userSpaceOnUse",
                x: "182",
                y: "7",
                width: "57",
                height: "59",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M196.353 7.34153C211.323 12.2056 225.434 19.3955 238.168 28.6475L211.717 65.0532C202.804 58.5769 192.926 53.5439 182.447 50.1391L196.353 7.34153Z",
                    fill: "url(#paint14_radial_4625_11724)"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                mask: "url(#mask4_4625_11724)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                    cx: "150",
                    cy: "150",
                    r: "150",
                    fill: "url(#paint15_radial_4625_11724)"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask5_4625_11724",
                maskUnits: "userSpaceOnUse",
                x: "163",
                y: "1",
                width: "34",
                height: "50",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M168.8 1.1828C178.157 2.36491 187.382 4.42695 196.353 7.34153L182.447 50.1391C176.168 48.0989 169.71 46.6554 163.16 45.828L168.8 1.1828Z",
                    fill: "url(#paint16_radial_4625_11724)"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                mask: "url(#mask5_4625_11724)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                    cx: "150",
                    cy: "150",
                    r: "150",
                    fill: "url(#paint17_radial_4625_11724)"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask6_4625_11724",
                maskUnits: "userSpaceOnUse",
                x: "150",
                y: "0",
                width: "19",
                height: "46",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M150 0C156.285 7.49509e-08 162.564 0.395044 168.8 1.1828L163.16 45.828C158.795 45.2765 154.4 45 150 45V0Z",
                    fill: "url(#paint18_radial_4625_11724)"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                mask: "url(#mask6_4625_11724)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                    cx: "150",
                    cy: "150",
                    r: "150",
                    fill: "url(#paint19_radial_4625_11724)"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M150 300C232.843 300 300 232.843 300 150C300 67.1573 232.843 0 150 0C67.1573 0 0 67.1573 0 150C0 232.843 67.1573 300 150 300ZM150 255C207.99 255 255 207.99 255 150C255 92.0101 207.99 45 150 45C92.0101 45 45 92.0101 45 150C45 207.99 92.0101 255 150 255Z",
                    fill: "white",
                    "fill-opacity": "0"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("radialGradient", {
                        id: "paint0_radial_4625_11724",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(150 150) rotate(90) scale(150)",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.68",
                                "stop-color": "#FF6666",
                                "stop-opacity": "0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                "stop-color": "#FF6666"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("radialGradient", {
                        id: "paint1_radial_4625_11724",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(150 150) rotate(90) scale(150)",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.68",
                                "stop-color": "#FFA666",
                                "stop-opacity": "0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                "stop-color": "#FFA666"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("radialGradient", {
                        id: "paint2_radial_4625_11724",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(150 150) rotate(90) scale(150)",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.673333",
                                "stop-color": "#FFE766",
                                "stop-opacity": "0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                "stop-color": "#FFE766"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("radialGradient", {
                        id: "paint3_radial_4625_11724",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(150 150) rotate(90) scale(150)",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.703333",
                                "stop-color": "#FF66D4",
                                "stop-opacity": "0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                "stop-color": "#FF66D4"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("radialGradient", {
                        id: "paint4_radial_4625_11724",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(150 150) rotate(90) scale(150)",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.693333",
                                "stop-color": "#65F6FF",
                                "stop-opacity": "0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                "stop-color": "#327B80"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("radialGradient", {
                        id: "paint5_radial_4625_11724",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(150 150) rotate(90) scale(150)",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.686667",
                                "stop-color": "#9465FF",
                                "stop-opacity": "0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                "stop-color": "#9465FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("radialGradient", {
                        id: "paint6_radial_4625_11724",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(150 150) rotate(90) scale(150)",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.686667",
                                "stop-color": "#66FFB6",
                                "stop-opacity": "0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                "stop-color": "#66FFB6"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("radialGradient", {
                        id: "paint7_radial_4625_11724",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(150 150) rotate(90) scale(150)",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.646667",
                                "stop-color": "#9465FF",
                                "stop-opacity": "0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                "stop-color": "#9465FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("radialGradient", {
                        id: "paint8_radial_4625_11724",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(150 150) rotate(90) scale(150)",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.713542",
                                "stop-color": "#9465FF",
                                "stop-opacity": "0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                "stop-color": "#030014",
                                "stop-opacity": "0.87"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("radialGradient", {
                        id: "paint9_radial_4625_11724",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(150 150) rotate(90) scale(150)",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.734375",
                                "stop-color": "#66FFB6",
                                "stop-opacity": "0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                "stop-color": "#66FFB6"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("radialGradient", {
                        id: "paint10_radial_4625_11724",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(150 150) rotate(90) scale(150)",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.713542",
                                "stop-color": "#66FFB6",
                                "stop-opacity": "0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                "stop-color": "#030014",
                                "stop-opacity": "0.87"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("radialGradient", {
                        id: "paint11_radial_4625_11724",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(150 150) rotate(90) scale(150)",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.734375",
                                "stop-color": "#65F6FF",
                                "stop-opacity": "0.25"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                "stop-color": "#65F6FF",
                                "stop-opacity": "0.65"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("radialGradient", {
                        id: "paint12_radial_4625_11724",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(150 150) rotate(90) scale(150)",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.655",
                                "stop-color": "#65F6FF",
                                "stop-opacity": "0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                "stop-color": "#030014"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("radialGradient", {
                        id: "paint13_radial_4625_11724",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(150 150) rotate(90) scale(150)",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.663333",
                                "stop-color": "#FF66D4",
                                "stop-opacity": "0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                "stop-color": "#030014",
                                "stop-opacity": "0.87"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("radialGradient", {
                        id: "paint14_radial_4625_11724",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(150 150) rotate(90) scale(150)",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.68",
                                "stop-color": "#FFE766",
                                "stop-opacity": "0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                "stop-color": "#FFE766"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("radialGradient", {
                        id: "paint15_radial_4625_11724",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(150 150) rotate(90) scale(150)",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.68",
                                "stop-color": "#FF66D4",
                                "stop-opacity": "0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                "stop-color": "#030014",
                                "stop-opacity": "0.87"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("radialGradient", {
                        id: "paint16_radial_4625_11724",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(150 150) rotate(90) scale(150)",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.68",
                                "stop-color": "#FFA666",
                                "stop-opacity": "0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                "stop-color": "#FFA666"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("radialGradient", {
                        id: "paint17_radial_4625_11724",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(150 150) rotate(90) scale(150)",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.658228",
                                "stop-color": "#FFA666",
                                "stop-opacity": "0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                "stop-color": "#030014",
                                "stop-opacity": "0.87"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("radialGradient", {
                        id: "paint18_radial_4625_11724",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(150 150) rotate(90) scale(150)",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.68",
                                "stop-color": "#FF6666",
                                "stop-opacity": "0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                "stop-color": "#FF6666"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("radialGradient", {
                        id: "paint19_radial_4625_11724",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(150 150) rotate(90) scale(150)",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.68",
                                "stop-color": "#FF6666",
                                "stop-opacity": "0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                "stop-color": "#030014",
                                "stop-opacity": "0.87"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var svgs_PoolAllocationChart = (PoolAllocationChart);

;// CONCATENATED MODULE: ./src/views/Lottery/svgs/index.tsx






;// CONCATENATED MODULE: ./src/views/Lottery/components/HowToPlay.tsx

function HowToPlay_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  height: 1px;\n  margin: 40px 0;\n  width: 100%;\n"
    ]);
    HowToPlay_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function HowToPlay_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  list-style-type: none;\n  margin-left: 8px;\n  padding: 0;\n  li {\n    margin: 0;\n    padding: 0;\n  }\n  li::before {\n    content: '•';\n    margin-right: 4px;\n    color: ",
        ";\n  }\n  li::marker {\n    font-size: 12px;\n  }\n"
    ]);
    HowToPlay_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function HowToPlay_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  gap: 24px;\n  width: 100%;\n  flex-direction: column;\n  ",
        " {\n    flex-direction: row;\n  }\n"
    ]);
    HowToPlay_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function HowToPlay_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-self: baseline;\n  position: relative;\n  padding: 1px 1px 3px 1px;\n  border-radius: ",
        ";\n"
    ]);
    HowToPlay_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function HowToPlay_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  border-radius: ",
        ";\n"
    ]);
    HowToPlay_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function HowToPlay_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  width: 265px;\n  gap: 5px;\n"
    ]);
    HowToPlay_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline;\n  color: ",
        ";\n  text-decoration: none;\n  font-weight: 500;\n  font-size: 18px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n  flex-direction: column;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 10px 0px; \n  gap: 5px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 50%;\n  width: 20px;\n  height: 20px;\n  margin-right: 8px;\n  background-color: ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  gap: 24px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}







var HowToPlay_Divider = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3cf883f7-0"
})(HowToPlay_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.primary_disabled;
});
var BulletList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-3cf883f7-1"
})(HowToPlay_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
});
var StepContainer = (0,styled_components_browser_esm/* default */.ZP)(Box_Flex/* default */.Z).withConfig({
    componentId: "sc-3cf883f7-2"
})(HowToPlay_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var StyledStepCard = (0,styled_components_browser_esm/* default */.ZP)(Box_Flex/* default */.Z).withConfig({
    componentId: "sc-3cf883f7-3"
})(HowToPlay_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.radii.card;
});
var StepCardInner = (0,styled_components_browser_esm/* default */.ZP)(Box_Flex/* default */.Z).withConfig({
    componentId: "sc-3cf883f7-4"
})(HowToPlay_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.radii.card;
});
var StepCard = function(param) {
    var step = param.step;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledStepCard, {
        width: "100%",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StepCardInner, {
            flexDirection: "column",
            height: [
                "200px",
                "180px",
                null,
                "200px"
            ],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryNumbers, {
                    color: "purple",
                    number: step.label,
                    style: {
                        margin: "auto auto 20px auto"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                    mb: "20px",
                    scale: "lg",
                    color: "text",
                    textAlign: "center",
                    children: step.title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    textAlign: "center",
                    color: "textSubtle",
                    children: step.subtitle
                })
            ]
        })
    });
};
var BallsContainer = (0,styled_components_browser_esm/* default */.ZP)(Box_Flex/* default */.Z).withConfig({
    componentId: "sc-3cf883f7-5"
})(HowToPlay_templateObject5());
var InlineLink = (0,styled_components_browser_esm/* default */.ZP)(Link/* default */.Z).withConfig({
    componentId: "sc-3cf883f7-6"
})(_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
var ExampleBalls = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BallsContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryNumbers, {
                color: "pink",
                number: 9
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryNumbers, {
                color: "purple",
                number: 1
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryNumbers, {
                color: "cyan",
                number: 3
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryNumbers, {
                color: "green",
                number: 6
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryNumbers, {
                color: "yellow",
                number: 6
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryNumbers, {
                color: "orange",
                number: 2
            })
        ]
    });
};
var MatchExampleContainer = (0,styled_components_browser_esm/* default */.ZP)(Box_Flex/* default */.Z).withConfig({
    componentId: "sc-3cf883f7-7"
})(_templateObject7());
var AllocationGrid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3cf883f7-8"
})(_templateObject8());
var AllocationColorCircle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3cf883f7-9"
})(_templateObject9(), function(param) {
    var color = param.color;
    return color;
});
var AllocationMatch = function(param) {
    var color = param.color, text = param.text, percentage = param.percentage;
    var theme = (0,useTheme/* default */.ZP)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
        pb: "5px",
        alignItems: "center",
        justifyContent: "space-between",
        style: {
            borderBottom: "1px solid ".concat(theme.theme.colors.primary_disabled)
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryNumbers, {
                        size: 18,
                        color: color
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontSize: "18px",
                        ml: "5px",
                        color: "text",
                        children: text
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                fontSize: "18px",
                textAlign: "right",
                children: percentage ? "".concat(percentage, "%") : ""
            })
        ]
    });
};
var PoolAllocations = function() {
    var t = (0,src/* useTranslation */.$G)().t;
    var theme = (0,useTheme/* default */.ZP)().theme;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledStepCard, {
        maxWidth: "680px",
        width: "100%",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StepCardInner, {
            height: "auto",
            flexDirection: [
                "column",
                "column",
                "row",
                "row"
            ],
            style: {
                gap: "40px"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Flex/* default */.Z, {
                    mb: "32px",
                    justifyContent: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svgs_PoolAllocationChart, {
                        width: "100px",
                        height: "100px"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                    flexDirection: "column",
                    width: "100%",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                            justifyContent: "space-between",
                            style: {
                                borderBottom: "1px solid ".concat(theme.colors.primary_disabled)
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    fontSize: "14px",
                                    color: "textSubtle",
                                    children: t("Digits matched")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    fontSize: "14px",
                                    color: "textSubtle",
                                    textAlign: "right",
                                    children: t("Prize pool allocation")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(AllocationGrid, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AllocationMatch, {
                                    color: "red",
                                    percentage: 2,
                                    text: t("Matches first %digits%", {
                                        digits: 1
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AllocationMatch, {
                                    color: "orange",
                                    percentage: 3,
                                    text: t("Matches first %digits%", {
                                        digits: 2
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AllocationMatch, {
                                    color: "yellow",
                                    percentage: 5,
                                    text: t("Matches first %digits%", {
                                        digits: 3
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AllocationMatch, {
                                    color: "pink",
                                    percentage: 10,
                                    text: t("Matches first %digits%", {
                                        digits: 4
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AllocationMatch, {
                                    color: "cyan",
                                    percentage: 20,
                                    text: t("Matches first %digits%", {
                                        digits: 5
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AllocationMatch, {
                                    color: "purple",
                                    percentage: 40,
                                    text: t("Matches all 6")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AllocationMatch, {
                                    color: "green",
                                    percentage: 20,
                                    text: t("Treasury Fee")
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var GappedFlex = (0,styled_components_browser_esm/* default */.ZP)(Box_Flex/* default */.Z).withConfig({
    componentId: "sc-3cf883f7-10"
})(_templateObject10());
var HowToPlay = function() {
    var t = (0,src/* useTranslation */.$G)().t;
    var steps = [
        {
            label: 1,
            title: t("Buy Tickets"),
            subtitle: t("Prices are set when the round starts, equal to 5 USD in ETH per ticket.")
        },
        {
            label: 2,
            title: t("Wait for the Draw"),
            subtitle: t("There is one draw every day at 2PM UTC.")
        },
        {
            label: 3,
            title: t("Check for Prizes"),
            subtitle: t("Once the round’s over, come back to the page and check to see if you’ve won!")
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        width: "100%",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                mb: "40px",
                alignItems: "center",
                flexDirection: "column",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                        mb: "20px",
                        mt: "60px",
                        scale: "xl",
                        color: "text",
                        children: t("How to Play")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        textAlign: "center",
                        fontSize: "18px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                t("If the digits on your tickets match the winning numbers in the correct order,"),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                t("you win a portion of the prize pool.")
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        children: t("Simple!")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StepContainer, {
                children: steps.map(function(step) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StepCard, {
                        step: step
                    }, step.label);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HowToPlay_Divider, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                flexDirection: "column",
                maxWidth: "680px",
                m: "auto",
                mb: "130px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                        mb: "20px",
                        scale: "lg",
                        color: "text",
                        textAlign: "center",
                        style: {
                            fontSize: "32px"
                        },
                        children: t("Winning Criteria")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        mb: "20px",
                        fontSize: "18px",
                        textAlign: "center",
                        children: t("The digits on your ticket must match in the correct order to win.")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HowToPlay_Divider, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GappedFlex, {
                        flexDirection: [
                            "column",
                            "column",
                            "column",
                            "row"
                        ],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                            flex: "2",
                            flexDirection: "column",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                                    justifyContent: "center",
                                    alignItems: "center",
                                    flexDirection: [
                                        "column",
                                        "column",
                                        "row",
                                        "row"
                                    ],
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Flex/* default */.Z, {
                                            mb: [
                                                "20px",
                                                "20px",
                                                "0px",
                                                "0px"
                                            ],
                                            mr: [
                                                "0px",
                                                "0px",
                                                "60px",
                                                "60px"
                                            ],
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExampleBalls, {})
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            color: "textSubtle",
                                            fontSize: "18px",
                                            textAlign: [
                                                "center",
                                                "center",
                                                "left",
                                                "left"
                                            ],
                                            children: t("Here’s an example lottery draw, with two tickets, A and B.")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HowToPlay_Divider, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                                    flexDirection: [
                                        "column",
                                        "column",
                                        "row",
                                        "row"
                                    ],
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Flex/* default */.Z, {
                                            mb: [
                                                "20px",
                                                "20px",
                                                "0px",
                                                "0px"
                                            ],
                                            mr: [
                                                "auto",
                                                "auto",
                                                "60px",
                                                "60px"
                                            ],
                                            ml: "auto",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MatchExampleA, {})
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                                            flexDirection: "column",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                    color: "text",
                                                    fontSize: "18px",
                                                    className: "syncopate",
                                                    fontWeight: 700,
                                                    textAlign: [
                                                        "center",
                                                        "center",
                                                        "left",
                                                        "left"
                                                    ],
                                                    children: t("TICKET A")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                    color: "textSubtle",
                                                    fontSize: "18px",
                                                    textAlign: [
                                                        "center",
                                                        "center",
                                                        "left",
                                                        "left"
                                                    ],
                                                    children: t("The first 3 digits and the last 2 digits match, but the 4th digit is wrong, so this ticket only wins a “Match first 3” prize.")
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HowToPlay_Divider, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                                    flexDirection: [
                                        "column",
                                        "column",
                                        "row",
                                        "row"
                                    ],
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Flex/* default */.Z, {
                                            mb: [
                                                "20px",
                                                "20px",
                                                "0px",
                                                "0px"
                                            ],
                                            mr: [
                                                "auto",
                                                "auto",
                                                "60px",
                                                "60px"
                                            ],
                                            ml: "auto",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MatchExampleB, {})
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                                            flexDirection: "column",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                    color: "text",
                                                    fontSize: "18px",
                                                    className: "syncopate",
                                                    fontWeight: 700,
                                                    textAlign: [
                                                        "center",
                                                        "center",
                                                        "left",
                                                        "left"
                                                    ],
                                                    children: t("TICKET B")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                    color: "textSubtle",
                                                    fontSize: "18px",
                                                    textAlign: [
                                                        "center",
                                                        "center",
                                                        "left",
                                                        "left"
                                                    ],
                                                    children: t("Even though the last 5 digits match, the first digit is wrong, so this ticket doesn’t win a prize.")
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    mt: "60px",
                                    color: "textSubtle",
                                    children: t("Prize brackets don’t ‘stack’: if you match the first 3 digits in order, you’ll only win prizes from the ‘Match 3’ bracket, and not from ‘Match 1’ and ‘Match 2’.")
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(GappedFlex, {
                flexDirection: [
                    "column-reverse",
                    "column-reverse",
                    "column-reverse",
                    "column-reverse"
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                        flex: "1",
                        flexDirection: "column",
                        maxWidth: "680px",
                        justifyContent: "center",
                        m: "auto",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                textAlign: "center",
                                mb: "30px",
                                mt: "90px",
                                scale: "lg",
                                color: "text",
                                style: {
                                    fontSize: "32px"
                                },
                                children: t("Prize Funds")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                mb: "60px",
                                textAlign: "center",
                                fontSize: "18px",
                                color: "text",
                                children: t("The prizes for each lottery round come from three sources:")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                fontSize: "18px",
                                mt: "0px",
                                mb: "20px",
                                scale: "md",
                                children: t("Ticket Purchases")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: "18px",
                                mb: "60px",
                                display: "inline",
                                color: "textSubtle",
                                children: t("100% of the ETH paid by people buying tickets that round goes back into the prize pools.")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                fontSize: "18px",
                                mt: "0px",
                                mb: "20px",
                                scale: "md",
                                children: t("Rollover Prizes")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: "18px",
                                mb: "-60px",
                                display: "inline",
                                color: "textSubtle",
                                children: t("After every round, if nobody wins in one of the prize brackets, the unclaimed ETH for that bracket rolls over into the next round and are redistributed among the prize pools.")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Flex/* default */.Z, {
                        flex: "1",
                        justifyContent: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PoolAllocations, {})
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_HowToPlay = (HowToPlay);

// EXTERNAL MODULE: ./src/state/lottery/getUserLotteryData.ts
var getUserLotteryData = __webpack_require__(35159);
;// CONCATENATED MODULE: ./src/views/Lottery/hooks/useShowMoreUserRounds.ts





var useShowMoreUserRounds = function() {
    var account = (0,wagmi_src/* useWeb3React */.Ge)().account;
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var ref = (0,react.useState)(getUserLotteryData/* MAX_USER_LOTTERIES_REQUEST_SIZE */.n5), numUserRoundsRequested = ref[0], setNumUserRoundsRequested = ref[1];
    var handleShowMoreUserRounds = function() {
        dispatch((0,lottery/* fetchAdditionalUserLotteries */.Mz)({
            account: account,
            skip: numUserRoundsRequested
        }));
        setNumUserRoundsRequested(numUserRoundsRequested + getUserLotteryData/* MAX_USER_LOTTERIES_REQUEST_SIZE */.n5);
    };
    return {
        numUserRoundsRequested: numUserRoundsRequested,
        handleShowMoreUserRounds: handleShowMoreUserRounds
    };
};
/* harmony default export */ var hooks_useShowMoreUserRounds = (useShowMoreUserRounds);

// EXTERNAL MODULE: ./src/components/Layout/Page.tsx + 1 modules
var Page = __webpack_require__(27553);
;// CONCATENATED MODULE: ./src/views/Lottery/index.tsx

function Lottery_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px;\n  border-top-left-radius: 30px;\n  border-top-right-radius: 30px;\n  border: 1px solid ",
        ";\n  border-bottom: none;\n"
    ]);
    Lottery_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Lottery_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  max-width: 680px;\n  margin: auto;\n  //target the second div\n  & > div:nth-child(2) {\n    border-top-left-radius: 0px;\n    border-top-right-radius: 0px;\n  }\n"
    ]);
    Lottery_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Lottery_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: calc(100vh - 64px);\n"
    ]);
    Lottery_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




















var Lottery_StyledFlex = (0,styled_components_browser_esm/* default */.ZP)(Box_Flex/* default */.Z).withConfig({
    componentId: "sc-925db57a-0"
})(Lottery_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
});
var StyledNoBorderFlex = (0,styled_components_browser_esm/* default */.ZP)(Box_Flex/* default */.Z).withConfig({
    componentId: "sc-925db57a-1"
})(Lottery_templateObject1());
var LotteryPage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-925db57a-2"
})(Lottery_templateObject2());
var Lottery = function() {
    useFetchLottery();
    hooks_useStatusTransitions();
    var t = (0,src/* useTranslation */.$G)().t;
    var ref = (0,useTheme/* default */.ZP)(), isDark = ref.isDark, theme = ref.theme;
    var ref1 = useLottery(), _currentRound = ref1.currentRound, status = _currentRound.status, endTime = _currentRound.endTime;
    var ref2 = (0,react.useState)(0), historyTabMenuIndex = ref2[0], setHistoryTabMenuIndex = ref2[1];
    var endTimeAsInt = parseInt(endTime, 10);
    var ref3 = hooks_useGetNextLotteryEvent(endTimeAsInt, status), nextEventTime = ref3.nextEventTime, postCountdownText = ref3.postCountdownText, preCountdownText = ref3.preCountdownText;
    var ref4 = hooks_useShowMoreUserRounds(), numUserRoundsRequested = ref4.numUserRoundsRequested, handleShowMoreUserRounds = ref4.handleShowMoreUserRounds;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* PageMeta */.V, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(LotteryPage, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSection/* default */.Z, {
                        containerProps: {
                            style: {
                                marginTop: "-30px"
                            }
                        },
                        background: GET_TICKETS_BG,
                        concaveDivider: true,
                        dividerPosition: "top",
                        index: 2,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                            alignItems: "center",
                            justifyContent: "center",
                            flexDirection: "column",
                            pt: "24px",
                            children: [
                                status === types/* LotteryStatus.OPEN */.p3.OPEN && /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                    scale: "xl",
                                    color: "#ffffff",
                                    mb: "24px",
                                    textAlign: "center",
                                    children: t("Lottery")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_NextDrawCard, {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CheckPrizesSection, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSection/* default */.Z, {
                        innerProps: {
                            style: {
                                width: "100%"
                            }
                        },
                        background: isDark ? FINISHED_ROUNDS_BG_DARK : FINISHED_ROUNDS_BG,
                        hasCurvedDivider: false,
                        index: 2,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledNoBorderFlex, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Lottery_StyledFlex, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                            style: {
                                                fontSize: "18px"
                                            },
                                            scale: "xl",
                                            children: t("Finished Rounds")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_HistoryTabMenu, {
                                                activeIndex: historyTabMenuIndex,
                                                setActiveIndex: function(index) {
                                                    return setHistoryTabMenuIndex(index);
                                                }
                                            })
                                        })
                                    ]
                                }),
                                historyTabMenuIndex === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AllHistoryCard, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components_YourHistoryCard, {
                                    handleShowMoreClick: handleShowMoreUserRounds,
                                    numUserRoundsRequested: numUserRoundsRequested
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSection/* default */.Z, {
                        dividerPosition: "top",
                        dividerFill: {
                            light: theme.colors.background
                        },
                        clipFill: {
                            light: "#9A9FD0",
                            dark: "#66578D"
                        },
                        index: 2,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_HowToPlay, {})
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var views_Lottery = (Lottery);

;// CONCATENATED MODULE: ./src/pages/lottery.tsx

/* harmony default export */ var pages_lottery = (views_Lottery);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7857,3293,9774,2888,179], function() { return __webpack_exec__(17230); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);